import * as l from "react";
import o0, { forwardRef as U, useState as P, useEffect as V, createContext as c2, useContext as a2, useRef as I, useId as v1, useMemo as i1, useCallback as E, useLayoutEffect as n2, memo as T1, useImperativeHandle as pe, useReducer as i0, createElement as s0 } from "react";
import { createPortal as N2 } from "react-dom";
function c0(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var X1 = { exports: {} }, O1 = {};
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var D2;
function a0() {
  if (D2) return O1;
  D2 = 1;
  var e = Symbol.for("react.transitional.element"), t = Symbol.for("react.fragment");
  function n(r, o, i) {
    var a = null;
    if (i !== void 0 && (a = "" + i), o.key !== void 0 && (a = "" + o.key), "key" in o) {
      i = {};
      for (var c in o)
        c !== "key" && (i[c] = o[c]);
    } else i = o;
    return o = i.ref, {
      $$typeof: e,
      type: r,
      key: a,
      ref: o !== void 0 ? o : null,
      props: i
    };
  }
  return O1.Fragment = t, O1.jsx = n, O1.jsxs = n, O1;
}
var B1 = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Z2;
function l0() {
  return Z2 || (Z2 = 1, process.env.NODE_ENV !== "production" && function() {
    function e(p) {
      if (p == null) return null;
      if (typeof p == "function")
        return p.$$typeof === O ? null : p.displayName || p.name || null;
      if (typeof p == "string") return p;
      switch (p) {
        case v:
          return "Fragment";
        case C:
          return "Profiler";
        case w:
          return "StrictMode";
        case M:
          return "Suspense";
        case S:
          return "SuspenseList";
        case T:
          return "Activity";
      }
      if (typeof p == "object")
        switch (typeof p.tag == "number" && console.error(
          "Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."
        ), p.$$typeof) {
          case _:
            return "Portal";
          case H:
            return (p.displayName || "Context") + ".Provider";
          case L:
            return (p._context.displayName || "Context") + ".Consumer";
          case k:
            var N = p.render;
            return p = p.displayName, p || (p = N.displayName || N.name || "", p = p !== "" ? "ForwardRef(" + p + ")" : "ForwardRef"), p;
          case A:
            return N = p.displayName || null, N !== null ? N : e(p.type) || "Memo";
          case g:
            N = p._payload, p = p._init;
            try {
              return e(p(N));
            } catch {
            }
        }
      return null;
    }
    function t(p) {
      return "" + p;
    }
    function n(p) {
      try {
        t(p);
        var N = !1;
      } catch {
        N = !0;
      }
      if (N) {
        N = console;
        var Z = N.error, R = typeof Symbol == "function" && Symbol.toStringTag && p[Symbol.toStringTag] || p.constructor.name || "Object";
        return Z.call(
          N,
          "The provided key is an unsupported type %s. This value must be coerced to a string before using it here.",
          R
        ), t(p);
      }
    }
    function r(p) {
      if (p === v) return "<>";
      if (typeof p == "object" && p !== null && p.$$typeof === g)
        return "<...>";
      try {
        var N = e(p);
        return N ? "<" + N + ">" : "<...>";
      } catch {
        return "<...>";
      }
    }
    function o() {
      var p = F.A;
      return p === null ? null : p.getOwner();
    }
    function i() {
      return Error("react-stack-top-frame");
    }
    function a(p) {
      if (W.call(p, "key")) {
        var N = Object.getOwnPropertyDescriptor(p, "key").get;
        if (N && N.isReactWarning) return !1;
      }
      return p.key !== void 0;
    }
    function c(p, N) {
      function Z() {
        B || (B = !0, console.error(
          "%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://react.dev/link/special-props)",
          N
        ));
      }
      Z.isReactWarning = !0, Object.defineProperty(p, "key", {
        get: Z,
        configurable: !0
      });
    }
    function u() {
      var p = e(this.type);
      return Q[p] || (Q[p] = !0, console.error(
        "Accessing element.ref was removed in React 19. ref is now a regular prop. It will be removed from the JSX Element type in a future release."
      )), p = this.props.ref, p !== void 0 ? p : null;
    }
    function d(p, N, Z, R, q, G, m1, $) {
      return Z = G.ref, p = {
        $$typeof: x,
        type: p,
        key: N,
        props: G,
        _owner: q
      }, (Z !== void 0 ? Z : null) !== null ? Object.defineProperty(p, "ref", {
        enumerable: !1,
        get: u
      }) : Object.defineProperty(p, "ref", { enumerable: !1, value: null }), p._store = {}, Object.defineProperty(p._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: 0
      }), Object.defineProperty(p, "_debugInfo", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: null
      }), Object.defineProperty(p, "_debugStack", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: m1
      }), Object.defineProperty(p, "_debugTask", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: $
      }), Object.freeze && (Object.freeze(p.props), Object.freeze(p)), p;
    }
    function h(p, N, Z, R, q, G, m1, $) {
      var D = N.children;
      if (D !== void 0)
        if (R)
          if (z(D)) {
            for (R = 0; R < D.length; R++)
              m(D[R]);
            Object.freeze && Object.freeze(D);
          } else
            console.error(
              "React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead."
            );
        else m(D);
      if (W.call(N, "key")) {
        D = e(p);
        var X = Object.keys(N).filter(function(Y) {
          return Y !== "key";
        });
        R = 0 < X.length ? "{key: someKey, " + X.join(": ..., ") + ": ...}" : "{key: someKey}", J[D + R] || (X = 0 < X.length ? "{" + X.join(": ..., ") + ": ...}" : "{}", console.error(
          `A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`,
          R,
          D,
          X,
          D
        ), J[D + R] = !0);
      }
      if (D = null, Z !== void 0 && (n(Z), D = "" + Z), a(N) && (n(N.key), D = "" + N.key), "key" in N) {
        Z = {};
        for (var j in N)
          j !== "key" && (Z[j] = N[j]);
      } else Z = N;
      return D && c(
        Z,
        typeof p == "function" ? p.displayName || p.name || "Unknown" : p
      ), d(
        p,
        D,
        G,
        q,
        o(),
        Z,
        m1,
        $
      );
    }
    function m(p) {
      typeof p == "object" && p !== null && p.$$typeof === x && p._store && (p._store.validated = 1);
    }
    var f = o0, x = Symbol.for("react.transitional.element"), _ = Symbol.for("react.portal"), v = Symbol.for("react.fragment"), w = Symbol.for("react.strict_mode"), C = Symbol.for("react.profiler"), L = Symbol.for("react.consumer"), H = Symbol.for("react.context"), k = Symbol.for("react.forward_ref"), M = Symbol.for("react.suspense"), S = Symbol.for("react.suspense_list"), A = Symbol.for("react.memo"), g = Symbol.for("react.lazy"), T = Symbol.for("react.activity"), O = Symbol.for("react.client.reference"), F = f.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, W = Object.prototype.hasOwnProperty, z = Array.isArray, y = console.createTask ? console.createTask : function() {
      return null;
    };
    f = {
      "react-stack-bottom-frame": function(p) {
        return p();
      }
    };
    var B, Q = {}, e1 = f["react-stack-bottom-frame"].bind(
      f,
      i
    )(), t1 = y(r(i)), J = {};
    B1.Fragment = v, B1.jsx = function(p, N, Z, R, q) {
      var G = 1e4 > F.recentlyCreatedOwnerStacks++;
      return h(
        p,
        N,
        Z,
        !1,
        R,
        q,
        G ? Error("react-stack-top-frame") : e1,
        G ? y(r(p)) : t1
      );
    }, B1.jsxs = function(p, N, Z, R, q) {
      var G = 1e4 > F.recentlyCreatedOwnerStacks++;
      return h(
        p,
        N,
        Z,
        !0,
        R,
        q,
        G ? Error("react-stack-top-frame") : e1,
        G ? y(r(p)) : t1
      );
    };
  }()), B1;
}
var F2;
function u0() {
  return F2 || (F2 = 1, process.env.NODE_ENV === "production" ? X1.exports = a0() : X1.exports = l0()), X1.exports;
}
var s = u0(), w2 = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var W2;
function d0() {
  return W2 || (W2 = 1, function(e) {
    (function() {
      var t = {}.hasOwnProperty;
      function n() {
        for (var i = "", a = 0; a < arguments.length; a++) {
          var c = arguments[a];
          c && (i = o(i, r(c)));
        }
        return i;
      }
      function r(i) {
        if (typeof i == "string" || typeof i == "number")
          return i;
        if (typeof i != "object")
          return "";
        if (Array.isArray(i))
          return n.apply(null, i);
        if (i.toString !== Object.prototype.toString && !i.toString.toString().includes("[native code]"))
          return i.toString();
        var a = "";
        for (var c in i)
          t.call(i, c) && i[c] && (a = o(a, c));
        return a;
      }
      function o(i, a) {
        return a ? i ? i + " " + a : i + a : i;
      }
      e.exports ? (n.default = n, e.exports = n) : window.classNames = n;
    })();
  }(w2)), w2.exports;
}
var h0 = d0();
const b = /* @__PURE__ */ c0(h0), f0 = "_footer_f7tu9_1", C0 = "_link_f7tu9_6", U2 = {
  footer: f0,
  link: C0
}, m0 = "_link_1v2y3_3", p0 = "_onColor_1v2y3_28", g0 = "_textColor_1v2y3_39", w0 = "_secondary_1v2y3_46", _0 = "_small_1v2y3_50", v0 = "_largerClickArea_1v2y3_58", J1 = {
  link: m0,
  default: "_default_1v2y3_15",
  onColor: p0,
  textColor: g0,
  secondary: w0,
  small: _0,
  largerClickArea: v0
};
function z2({
  kind: e = "default",
  className: t,
  largerClickArea: n,
  size: r = "default",
  ...o
}) {
  return {
    ...o,
    className: b(J1.link, J1[`${e}`], t, {
      [J1.largerClickArea]: n,
      [J1.small]: r === "small"
    })
  };
}
const ge = U(function({ href: t, ...n }, r) {
  const { children: o, ...i } = z2(n);
  return /* @__PURE__ */ s.jsx("a", { ref: r, href: t, ...i, children: o });
});
function C1(e) {
  return /* @__PURE__ */ s.jsx(ge, { ...e });
}
function l2(e) {
  return /* @__PURE__ */ s.jsx("img", { ...e });
}
function E1({
  Link: e,
  href: t,
  hidden: n,
  children: r,
  external: o,
  className: i,
  onClick: a,
  title: c,
  doNotOpenInNewTab: u
}) {
  return /* @__PURE__ */ s.jsx(
    e,
    {
      href: t,
      onClick: a,
      title: c,
      "aria-label": c,
      className: b(i, { "hide-link": n }),
      rel: o ? "noopener noreferrer" : void 0,
      target: u || !o ? void 0 : "_blank",
      children: r
    }
  );
}
function H9({ text: e, Link: t = C1 }) {
  return /* @__PURE__ */ s.jsxs("footer", { className: b("bp-shared", U2.footer), children: [
    e.providerInfo,
    e.links.map(({ className: n, ...r }, o) => /* @__PURE__ */ s.jsx(s.Fragment, { children: /* @__PURE__ */ s.jsx(E1, { Link: t, ...r, className: b(U2.link, n) }) }, o))
  ] });
}
const we = "data:image/svg+xml,%3csvg%20enable-background='new%200%200%202406.6%20358.8'%20viewBox='0%200%202406.6%20358.8'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='m213.9%20290.7c9.7-10.4%2020.7-22.3%2035.5-38.4%2050.5-54.6%2059.8-111.8%2043.1-159-15.8-44.5-75.1-93.3-141.7-93.3-68.4.5-128.2%2046.6-143.4%2093.4-10.2%2031.5-20%2089.9%2045.4%20159.9l97.8%20105.5%2021-22.6s-68.8-74.5-93.8-101.5c-20.2-24.9-55.2-69.3-40.7-127.7%205.5-22.3%2045.3-76.4%20113.8-76.2%2068.4.2%20105.7%2056.7%20111.9%2073.4%2014.3%2038.7%206.3%2082.1-38.6%20130.2-16%2017.1-7.6%208.3-23.9%2025.7%200%200-66.2-71.8-83.2-90.4-12.6-13.8-14.6-36-.8-49.6%2013.6-13.3%2034.6-17.3%2051.5-1.1l19.9%2021.7c10.3%2010.7%2014.6%2010.6%2024.1.8%207.4-7.6%2024.5-26.5%2028.9-31.4-7.6-7.4-13.7-13.4-21.9-21.6-4.9%205.2-16%2017.3-18.7%2020.1-10.7-11.5-24.2-30.5-56.5-30.8-19.6%200-37%208.3-49%2020.2-16.4%2018-19.3%2033.3-19.6%2041.7-.6%2017.4%201.3%2031.7%2022.9%2055.3%2035.3%2038.2%2078.5%2084.7%2089%2095.9%2010.4%2011%2016.8%2010.8%2027-.2z'%20fill='%239ecb09'/%3e%3cpath%20d='m2084.9%20273.4c0%2010.7-8.6%2019.6-19.6%2019.6-10.7%200-19.3-8.9-19.3-19.6%200-10.5%208.6-19.3%2019.3-19.3%2011%200%2019.6%208.9%2019.6%2019.3z'/%3e%3cpath%20d='m2214.9%20235c0%2034.5-19.5%2057.7-52.2%2057.7-32.5%200-52.2-21.6-52.2-57.7%200-34.7%2019.5-57.7%2052.4-57.7%2032.4%200%2052%2021.5%2052%2057.7zm-74%200c0%2025.1%207.4%2036%2021.8%2036s21.8-11.1%2021.8-36c0-25.1-7.4-36-21.6-36-14.6%200-22%2011.1-22%2036z'/%3e%3cpath%20d='m2297.6%20179-4.9%2028.2c-3.3-.8-6-1.4-9.7-1.4-13.4%200-19.5%209.9-23.4%2027.3v59.5h-29.2v-112.1h25.3l2.7%2021.2c5.1-15.2%2015.6-24.3%2028.4-24.3%203.8%200%207.1.6%2010.8%201.6z'/%3e%3cpath%20d='m2406.6%20186.5c-8%203.1-18.3%204.1-31.4%204.1%2013.4%206%2020.1%2014.2%2020.1%2028%200%2021.2-17.1%2036.6-44.8%2036.6-4.7%200-8.8-.4-12.7-1.4-2.5%201.6-4.1%204.3-4.1%207.2%200%203.7%201.8%207.2%2012.5%207.2h16.6c24.7%200%2040.5%2013.2%2040.5%2031.2%200%2022-19.1%2035.4-55.5%2035.4-39.9%200-50.8-13-50.8-34.7h26.1c0%2010.3%204.5%2014.8%2025.3%2014.8%2020.1%200%2025.5-5.5%2025.5-13.4%200-7.4-5.6-11.9-17.1-11.9h-16c-22.8%200-32.3-9.9-32.3-21.4%200-7.8%204.9-15.4%2012.7-20.3-13.6-7.4-19.3-17.1-19.3-31%200-24%2019.1-39.5%2046.4-39.5%2025.1.6%2037.8-5.8%2051-13.2zm-75.4%2029.8c0%2012.5%207%2019.9%2018.1%2019.9%2011.7%200%2017.9-7%2017.9-20.3%200-13-6-19.1-18.1-19.1-11.1%200-17.9%207.6-17.9%2019.5z'/%3e%3cpath%20d='m1498.3%2030.6-50.1%2016.1v131.1h-14.4c-4.7-45.1-27.6-81.7-79.7-81.7-29.5%200-48.5%2013.1-59.7%2031.7h-.7v-27.2h-75.4c-29.9%200-37.7%2025.8-40%2043.7h-.7v-43.7h-44.4v128.6c-29.9%2018.9-58.9%2032.3-87.7%2032.4-31%20.1-52.6-21.3-54.9-52.2h120.9c0-67.2-23-112.2-79.4-112.4-59.7-.2-89.2%2045.9-89.2%20101.5%200%2019.6%203.6%2036.6%2010.4%2050.8-8.9%204.9-19.4%209.2-29.8%209.2-19-.1-23.5-15.3-23.5-31.7v-89.6h31.9l22-36.6h-53.8v-69l-50%2016.1v52.9h-52.8v-69l-50%2016.1-.1%2053.3h-19.8v35.9h19.9v89.2c-31.1%2020.2-61.4%2034.6-91.3%2034.7-31%20.1-52.6-20.4-54.9-51.4h120.3c0-67.2-22.4-113-78.9-113.2-52.5-.2-81.6%2035.4-87.9%2081.7h-12.7c-4.7-45.1-27.6-81.7-79.7-81.7-26.1%200-43.7%2010.8-57.5%2029.1h-.7v-94.5l-50%2015.7v246.4h48.5v-23.5h.7c14.6%2020.5%2037.7%2028%2059%2028%2051.9%200%2074.8-42.8%2079.6-87.7h12.4c6.3%2052.4%2042%2087.7%2099.4%2087.7%2025.4%200%2055.6-9.4%2099.4-32.1%208.9%2020.1%2027.6%2032%2055%2032%2014.8%200%2023.5-2.7%2033.3-7.3l-13.1-34.7c-2.6%201.7-5.6%202.9-9.5%203.1-19%20.9-21.5-15.2-21.5-31.6v-89.6h52.8v97.8c0%2038.1%2021.6%2062.3%2060.8%2062.3%2029.3%200%2039.5-7.1%2063.8-20.6%2016.9%2013.9%2040.1%2021.4%2068.7%2021.4%2023.6%200%2051.2-8%2090-27.3v22h50v-70.5c0-27.6%200-78.4%2040.7-78.4%208.7%200%2017.4%201.4%2022%203.9v210.8h50v-87.9h.7c17.5%2021.3%2035.1%2026.5%2056.4%2026.5%2055%200%2077.7-40.7%2081.2-87.9h14v24.7c0%2038.1%2021.6%2062.3%2060.8%2062.3%2023.9%200%2033.5-4.7%2041.4-8.3%2011.1%206%2024.3%209.2%2037.6%209.2%2022.8%200%2047.8-11.9%2059.3-33.2h.7c.4%206%20.4%2018.7%202.2%2028.7h44c-1.1-14.9-1.9-28.4-2.2-42.9-.3-10.8-.6-27.6-.7-40.8h12c6.3%2048.5%2037.6%2088.1%2093.6%2088.2%2020.7%200%2050.1-9.7%2074.1-27.2%2017.2%2018.2%2042.9%2028%2075.7%2028%2026.9%200%2051.1-9.7%2068-21.5v-40.5c-22.6%2019.1-39.1%2025.4-65.7%2025.4-31%200-52.6-21.3-54.9-52.2h120.9c0-67.2-23-112.2-79.4-112.4-59.7-.2-89.2%2045.9-89.2%20101.5%200%2015.4%202.2%2029.3%206.5%2041.4-12.2%209.7-25.2%2017.7-46.7%2018.6-35.1%201.5-51.9-27.2-51.9-62.7%200-36.2%2019.8-60.7%2050.8-60.8%2013.9%200%2017.6%201.9%2027.6%207.5l15.1-31.2c-19.3-9.6-32.7-15.1-52.9-15.1-52.1%200-83.8%2037-91.3%2082.1h-12.6c-.8-54.7-25.1-82.1-82.7-82.1-21.3%200-47.4%205.6-66.8%2014.6l1.5%2042.9c16.8-12.7%2038.1-20.9%2059.3-20.9%2029.5%200%2043.2%2014.4%2043.2%2045.4h-27.6c-20.9%200-45.4-2.1-64.4%207.2s-32.8%2026.1-32.8%2054.9c0%208.6%201.8%2016.3%205.1%2023-1.4.4-2.8.6-4.2.6-19%200-23.5-21.6-23.5-38zm-855.6%20102c26.3%200%2036.9%2020.9%2038.3%2045.2h-80.1c2.1-25.8%2015.4-45.2%2041.8-45.2zm-194.5%20125.8c-33.2%200-44-35.1-44-62.3%200-26.9%2012.7-61.2%2044.8-61.2%2032.5%200%2041.4%2035.5%2041.4%2061.2%200%2026.5-9.4%2062.3-42.2%2062.3zm584.2-124.9c26.3%200%2036.9%2020.1%2038.3%2044.3h-80.1c2.1-25.8%2015.4-44.3%2041.8-44.3zm307.9%20124.9c-33.2%200-44-35.1-44-62.3%200-26.9%2012.7-61.2%2044.8-61.2%2032.5%200%2041.4%2035.5%2041.4%2061.2%200%2026.5-9.3%2062.3-42.2%2062.3zm295.2-14.9c-7.8%2010.5-19.8%2017.2-35.1%2017.2-17.9%200-31.7-7.1-31.7-23.5%200-28.1%2032.6-28%2055-28h21.6c-.7%2015.7-3.9%2026.3-9.8%2034.3zm300.6-110c26.3%200%2036.8%2020.1%2038.2%2044.3h-80.1c2.2-25.8%2015.6-44.3%2041.9-44.3z'/%3e%3c/svg%3e", x0 = "_header_zzlnp_1", b0 = "_headerClaim_zzlnp_11", L0 = "_inner_zzlnp_35", E0 = "_headerLogo_zzlnp_54", k0 = "_headerLogoLink_zzlnp_59", y0 = "_imageContainer_zzlnp_65", j0 = "_logoDesktop_zzlnp_70", M0 = "_claimHidden_zzlnp_109", b1 = {
  header: x0,
  headerClaim: b0,
  inner: L0,
  headerLogo: E0,
  headerLogoLink: k0,
  imageContainer: y0,
  logoDesktop: j0,
  claimHidden: M0
};
function s1(e) {
  e.preventDefault(), e.stopPropagation();
}
function u2(e) {
  return e ? typeof e == "string" ? e : e.src : "";
}
const N0 = u2(we), q2 = 175;
function H0({
  Link: e = C1,
  Image: t = l2,
  text: n,
  children: r,
  className: o,
  hideClaim: i
}) {
  return /* @__PURE__ */ s.jsx(
    "header",
    {
      style: { "--logo-size": `${q2}px` },
      className: b(b1.header, "bp-shared", { [b1.claimHidden]: i }, o),
      children: /* @__PURE__ */ s.jsxs("div", { className: b1.inner, children: [
        /* @__PURE__ */ s.jsx("div", { className: b1.headerLogo, children: /* @__PURE__ */ s.jsx(e, { href: n.homePageUrl, className: b1.headerLogoLink, children: /* @__PURE__ */ s.jsx("div", { className: b1.imageContainer, children: /* @__PURE__ */ s.jsx(t, { src: N0, alt: n.logoAlt, width: q2, className: b1.logoDesktop }) }) }) }),
        /* @__PURE__ */ s.jsx("div", { className: b1.headerClaim, "data-axe-expect": "color-contrast", children: n.claim }),
        r
      ] })
    }
  );
}
const T0 = "data:image/svg+xml,%3csvg%20enable-background='new%200%200%20402.872%20109.449'%20height='109.449'%20viewBox='0%200%20402.872%20109.449'%20width='402.872'%20xmlns='http://www.w3.org/2000/svg'%20xmlns:xlink='http://www.w3.org/1999/xlink'%3e%3clinearGradient%20id='a'%20gradientUnits='userSpaceOnUse'%20x1='0'%20x2='161.0322'%20y1='57.5601'%20y2='57.5601'%3e%3cstop%20offset='0'%20stop-color='%230d0d0d'/%3e%3cstop%20offset='.2418'%20stop-color='%23ababab'/%3e%3cstop%20offset='.5'%20stop-color='%23f2f2f2'/%3e%3cstop%20offset='.7473'%20stop-color='%23ababab'/%3e%3cstop%20offset='1'%20stop-color='%230d0d0d'/%3e%3c/linearGradient%3e%3clinearGradient%20id='b'%20gradientUnits='userSpaceOnUse'%20x1='0'%20x2='161.0322'%20y1='40.2637'%20y2='40.2637'%3e%3cstop%20offset='0'%20stop-color='%230d0d0d'/%3e%3cstop%20offset='.2418'%20stop-color='%23737373'/%3e%3cstop%20offset='.5'%20stop-color='%23ccc'/%3e%3cstop%20offset='.7473'%20stop-color='%23737373'/%3e%3cstop%20offset='1'%20stop-color='%230d0d0d'/%3e%3c/linearGradient%3e%3cpath%20d='m80.516%20109.449-80.516-39.637%2080.516-29.547%2080.516%2029.547z'/%3e%3cpath%20d='m80.516%2092.152-80.516-39.637%2080.516-29.547%2080.516%2029.547z'%20fill='url(%23a)'%20opacity='.5'/%3e%3cpath%20d='m80.516%2074.856-80.516-39.636%2080.516-29.549%2080.516%2029.549z'%20fill='url(%23b)'%20opacity='.35'/%3e%3cg%20fill='%234d4d4d'%3e%3cpath%20d='m205.851%2013.923h2.25v18.918h-2.25z'/%3e%3cpath%20d='m213.265%2019.342h2.223v2.02c1.176-1.15%202.863-2.301%205.063-2.301%202.58%200%203.987%201.483%203.987%204.04v9.74h-2.199v-9.255c0-1.789-.767-2.632-2.479-2.632-1.608%200-2.966.844-4.372%202.173v9.714h-2.223z'/%3e%3cpath%20d='m229.037%2014.307h2.302v2.146h-2.302zm.052%205.035h2.197v13.499h-2.197z'/%3e%3cpath%20d='m236.937%2029.568v-8.411h-2.352v-1.815h2.352v-4.806h2.198v4.806h3.503v1.815h-3.503v7.925c0%201.431.46%202.146%202.096%202.146.486%200%201.023-.077%201.382-.179v1.815c-.385.077-1.228.154-1.919.154-2.837.001-3.757-1.099-3.757-3.45z'/%3e%3cpath%20d='m246.344%2014.307h2.302v2.146h-2.302zm.052%205.035h2.198v13.499h-2.198z'/%3e%3cpath%20d='m252.454%2029.645c0-2.736%202.327-4.679%209.024-5.623v-.615c0-1.687-.896-2.504-2.558-2.504-2.045%200-3.553.895-4.883%202.045l-1.149-1.38c1.56-1.431%203.579-2.505%206.263-2.505%203.221%200%204.499%201.688%204.499%204.499v5.957c0%201.636.102%202.633.384%203.324h-2.249c-.179-.563-.307-1.1-.307-1.867-1.51%201.407-3.197%202.07-5.216%202.07-2.324-.003-3.808-1.228-3.808-3.401zm9.025-.307v-3.784c-5.139.819-6.852%202.071-6.852%203.758%200%201.303.869%201.995%202.274%201.995%201.79%200%203.324-.743%204.578-1.969z'/%3e%3cpath%20d='m269.02%2029.568v-8.411h-2.352v-1.815h2.352v-4.806h2.198v4.806h3.502v1.815h-3.502v7.925c0%201.431.46%202.146%202.096%202.146.486%200%201.023-.077%201.382-.179v1.815c-.385.077-1.228.154-1.919.154-2.837.001-3.757-1.099-3.757-3.45z'/%3e%3cpath%20d='m278.427%2014.307h2.3v2.146h-2.3zm.05%205.035h2.199v13.499h-2.199z'/%3e%3cpath%20d='m283.923%2019.342h2.352l3.783%2010.941h.052l3.731-10.941h2.2l-4.935%2013.549h-2.225z'/%3e%3cpath%20d='m297.754%2026.091c0-4.908%203.272-7.03%206.108-7.03%203.194%200%205.625%202.25%205.625%207.133v.46h-9.536c.078%203.041%201.841%204.677%204.065%204.677%201.943%200%203.04-.792%204.064-2.198l1.279%201.125c-1.254%201.789-2.968%202.864-5.498%202.864-3.193%200-6.107-2.327-6.107-7.031zm9.638-1.15c-.181-2.403-1.33-4.04-3.555-4.04-1.814%200-3.527%201.252-3.835%204.04z'/%3e%3c/g%3e%3cpath%20d='m210.095%2044.377h-6.008v-2.072h14.289v2.072h-6.031v16.845h-2.25z'/%3e%3cpath%20d='m218.403%2047.725h2.199v2.506h.05c.998-1.561%202.582-2.787%205.216-2.787h.28l-.154%202.045c-.074-.025-.562-.025-.639-.025-2.147%200-3.757%201.124-4.753%203.042v8.717h-2.199z'/%3e%3cpath%20d='m227.963%2058.027c0-2.734%202.327-4.676%209.024-5.626v-.611c0-1.688-.895-2.506-2.556-2.506-2.046%200-3.553.896-4.883%202.045l-1.15-1.38c1.559-1.431%203.579-2.505%206.262-2.505%203.222%200%204.499%201.687%204.499%204.5v5.956c0%201.636.103%202.633.384%203.322h-2.25c-.179-.564-.306-1.1-.306-1.865-1.509%201.404-3.195%202.07-5.215%202.07-2.325%200-3.809-1.227-3.809-3.4zm9.024-.306v-3.783c-5.139.817-6.852%202.07-6.852%203.756%200%201.305.87%201.994%202.275%201.994%201.79%200%203.324-.741%204.577-1.967z'/%3e%3cpath%20d='m243.558%2047.725h2.225v2.021c1.176-1.151%202.861-2.302%205.062-2.302%202.582%200%203.987%201.482%203.987%204.039v9.739h-2.198v-9.254c0-1.789-.768-2.633-2.48-2.633-1.608%200-2.966.844-4.37%202.172v9.715h-2.225v-13.497z'/%3e%3cpath%20d='m258.256%2059.177%201.33-1.329c1.021%201.099%202.377%201.866%204.219%201.866%202.096%200%203.246-.743%203.246-2.123%200-1.354-1.176-1.864-3.476-2.401-2.863-.69-4.832-1.456-4.832-4.066%200-2.044%201.79-3.68%204.729-3.68%202.379%200%203.911.767%205.165%201.942l-1.151%201.457c-1.023-.944-2.403-1.61-3.91-1.61-1.969%200-2.736.869-2.736%201.814%200%201.252%201.074%201.715%203.195%202.199%203.042.741%205.14%201.484%205.14%204.269%200%202.583-2.329%203.962-5.395%203.962-2.429%200-4.425-.97-5.524-2.3z'/%3e%3cpath%20d='m272.955%2047.725h2.199v1.866c1.022-1.124%202.43-2.147%204.448-2.147%203.093%200%205.496%202.302%205.496%207.005%200%204.702-2.429%206.979-5.727%206.979-1.662%200-3.068-.741-4.218-1.943v6.852h-2.199v-18.612zm9.944%206.749c0-3.452-1.637-5.139-3.81-5.139-1.559%200-2.811.844-3.936%202.071v6.185c1.177%201.33%202.479%202.047%203.911%202.047%202.353%200%203.835-1.586%203.835-5.164z'/%3e%3cpath%20d='m287.836%2058.027c0-2.734%202.326-4.676%209.023-5.626v-.611c0-1.688-.897-2.506-2.558-2.506-2.044%200-3.553.896-4.883%202.045l-1.148-1.38c1.559-1.431%203.577-2.505%206.263-2.505%203.219%200%204.499%201.687%204.499%204.5v5.956c0%201.636.102%202.633.383%203.322h-2.25c-.179-.564-.306-1.1-.306-1.865-1.509%201.404-3.197%202.07-5.216%202.07-2.327%200-3.807-1.227-3.807-3.4zm9.023-.306v-3.783c-5.139.817-6.853%202.07-6.853%203.756%200%201.305.869%201.994%202.275%201.994%201.791%200%203.325-.741%204.578-1.967z'/%3e%3cpath%20d='m303.429%2047.725h2.198v2.506h.052c.995-1.561%202.581-2.787%205.214-2.787h.28l-.151%202.045c-.077-.025-.562-.025-.642-.025-2.146%200-3.756%201.124-4.753%203.042v8.717h-2.198z'/%3e%3cpath%20d='m312.836%2054.474c0-4.909%203.271-7.03%206.11-7.03%203.194%200%205.623%202.25%205.623%207.131v.461h-9.535c.076%203.042%201.841%204.679%204.064%204.679%201.943%200%203.042-.793%204.063-2.199l1.278%201.126c-1.251%201.79-2.963%202.861-5.494%202.861-3.195-.001-6.109-2.326-6.109-7.029zm9.638-1.15c-.179-2.403-1.33-4.04-3.554-4.04-1.815%200-3.528%201.253-3.835%204.04z'/%3e%3cpath%20d='m328.354%2047.725h2.224v2.021c1.176-1.151%202.862-2.302%205.061-2.302%202.584%200%203.988%201.482%203.988%204.039v9.739h-2.197v-9.254c0-1.789-.768-2.633-2.48-2.633-1.611%200-2.966.844-4.371%202.172v9.715h-2.224v-13.497z'/%3e%3cpath%20d='m344.995%2057.95v-8.41h-2.352v-1.814h2.352v-4.806h2.198v4.805h3.502v1.814h-3.502v7.926c0%201.432.46%202.147%202.096%202.147.485%200%201.021-.077%201.382-.179v1.814c-.385.077-1.228.152-1.919.152-2.837.002-3.757-1.098-3.757-3.449z'/%3e%3cpath%20d='m353.355%2054.474c0-4.909%203.271-7.03%206.108-7.03%203.196%200%205.623%202.25%205.623%207.131v.461h-9.533c.076%203.042%201.839%204.679%204.064%204.679%201.943%200%203.042-.793%204.063-2.199l1.278%201.126c-1.253%201.79-2.965%202.861-5.496%202.861-3.192-.001-6.107-2.326-6.107-7.029zm9.636-1.15c-.179-2.403-1.33-4.04-3.552-4.04-1.815%200-3.528%201.253-3.834%204.04z'/%3e%3cpath%20d='m204.292%2088.02%2011.067-15.44h-10.352v-1.892h13.113v1.636l-10.992%2015.413h10.992v1.867h-13.829v-1.584z'/%3e%3cpath%20d='m222.059%2071.071h2.3v2.148h-2.3zm.05%205.036h2.199v13.497h-2.199z'/%3e%3cpath%20d='m227.555%2076.107h2.353l3.783%2010.94h.051l3.733-10.94h2.197l-4.935%2013.548h-2.223z'/%3e%3cpath%20d='m242.893%2071.071h2.301v2.148h-2.301zm.052%205.036h2.198v13.497h-2.198z'/%3e%3cpath%20d='m249.975%2070.688h2.198v18.916h-2.198z'/%3e%3cpath%20d='m255.343%2091.445c0-1.38.944-2.403%202.453-2.992-.766-.358-1.15-.918-1.15-1.713%200-.868.716-1.609%201.688-2.171-1.304-.845-2.071-2.199-2.071-3.887%200-2.837%202.274-4.855%205.496-4.855%201.661%200%203.041.562%203.987%201.404.818-.611%202.096-1.124%203.197-1.252v1.943c-.741%200-1.639.128-2.43.435.436.614.691%201.405.691%202.325%200%202.915-2.302%204.807-5.446%204.807-.791%200-1.456-.129-2.147-.333-.562.257-.945.587-.945%201.048%200%20.563.434.819%201.865.948l2.762.229c3.425.229%205.163%201.327%205.163%203.502%200%202.556-2.683%203.91-6.595%203.91-4.549%200-6.518-1.303-6.518-3.348zm11.095-.358c0-1.203-.896-1.737-3.733-1.941l-2.556-.181c-.256-.025-.513-.053-.767-.076-1.305.461-1.995%201.303-1.995%202.224%200%201.354%201.406%202.021%204.757%202.021%202.683-.001%204.294-.821%204.294-2.047zm-1.281-10.353c0-1.969-1.226-3.194-3.398-3.194-2.096%200-3.4%201.252-3.4%203.194%200%201.941%201.355%203.145%203.427%203.145%202.068-.001%203.371-1.204%203.371-3.145z'/%3e%3cpath%20d='m270.912%2082.857c0-4.909%203.271-7.03%206.108-7.03%203.195%200%205.624%202.249%205.624%207.132v.46h-9.535c.076%203.04%201.84%204.676%204.064%204.676%201.943%200%203.042-.791%204.064-2.197l1.28%201.126c-1.256%201.788-2.968%202.861-5.498%202.861-3.194-.001-6.107-2.327-6.107-7.028zm9.638-1.151c-.181-2.403-1.33-4.04-3.555-4.04-1.815%200-3.527%201.254-3.834%204.04z'/%3e%3cpath%20d='m285.202%2087.558%201.328-1.328c1.023%201.099%202.377%201.864%204.219%201.864%202.096%200%203.246-.738%203.246-2.118%200-1.356-1.176-1.869-3.476-2.406-2.863-.688-4.832-1.456-4.832-4.062%200-2.047%201.79-3.682%204.729-3.682%202.379%200%203.913.766%205.163%201.941l-1.148%201.457c-1.024-.945-2.404-1.609-3.911-1.609-1.969%200-2.736.868-2.736%201.814%200%201.252%201.074%201.713%203.197%202.198%203.04.741%205.136%201.483%205.136%204.269%200%202.582-2.324%203.962-5.393%203.962-2.429.001-4.422-.969-5.522-2.3z'/%3e%3cpath%20d='m298.905%2082.857c0-4.909%203.27-7.03%206.107-7.03%203.194%200%205.624%202.249%205.624%207.132v.46h-9.536c.079%203.04%201.842%204.676%204.066%204.676%201.944%200%203.04-.791%204.064-2.197l1.277%201.126c-1.252%201.788-2.965%202.861-5.496%202.861-3.193-.001-6.106-2.327-6.106-7.028zm9.635-1.151c-.179-2.403-1.329-4.04-3.552-4.04-1.814%200-3.528%201.254-3.834%204.04z'/%3e%3cpath%20d='m314.574%2070.688h2.199v18.916h-2.199z'/%3e%3cpath%20d='m321.604%2070.688h2.2v18.916h-2.2z'/%3e%3cpath%20d='m327.51%2087.558%201.328-1.328c1.023%201.099%202.378%201.864%204.221%201.864%202.095%200%203.244-.738%203.244-2.118%200-1.356-1.176-1.869-3.476-2.406-2.863-.688-4.832-1.456-4.832-4.062%200-2.047%201.789-3.682%204.73-3.682%202.377%200%203.91.766%205.163%201.941l-1.151%201.457c-1.021-.945-2.401-1.609-3.91-1.609-1.969%200-2.734.868-2.734%201.814%200%201.252%201.074%201.713%203.194%202.198%203.043.741%205.139%201.483%205.139%204.269%200%202.582-2.327%203.962-5.395%203.962-2.428.001-4.423-.969-5.521-2.3z'/%3e%3cpath%20d='m341.212%2082.857c0-4.935%203.17-7.03%206.186-7.03%203.043%200%204.474%201.789%205.292%203.783l-1.864.766c-.666-1.738-1.715-2.685-3.479-2.685-1.943%200-3.912%201.354-3.912%205.166%200%203.321%201.586%205.188%203.863%205.188%201.713%200%202.758-.741%203.627-2.71l1.817.717c-1.05%202.249-2.608%203.833-5.523%203.833-3.117-.001-6.007-2.402-6.007-7.028z'/%3e%3cpath%20d='m356.321%2070.688h2.223v7.438c1.176-1.149%202.864-2.3%205.062-2.3%202.582%200%203.987%201.481%203.987%204.037v9.74h-2.195v-9.253c0-1.79-.771-2.633-2.481-2.633-1.61%200-2.966.843-4.372%202.173v9.713h-2.223v-18.915z'/%3e%3cpath%20d='m371.172%2086.41c0-2.735%202.327-4.679%209.024-5.624v-.614c0-1.688-.893-2.506-2.557-2.506-2.043%200-3.552.896-4.882%202.047l-1.148-1.38c1.557-1.433%203.578-2.506%206.262-2.506%203.22%200%204.497%201.688%204.497%204.499v5.954c0%201.638.104%202.633.386%203.324h-2.25c-.179-.562-.308-1.098-.308-1.867-1.507%201.409-3.195%202.072-5.215%202.072-2.325%200-3.809-1.227-3.809-3.399zm9.024-.309v-3.781c-5.137.817-6.85%202.068-6.85%203.758%200%201.304.868%201.994%202.275%201.994%201.79%200%203.322-.743%204.575-1.971z'/%3e%3cpath%20d='m387.815%2077.922h-2.352v-1.815h2.352v-1.814c0-2.274%201.2-3.656%204.064-3.656.385%200%201.049.077%201.252.077v1.789c-.203-.052-.64-.076-.946-.076-1.226%200-2.173.435-2.173%201.891v1.79h2.966v1.815h-2.966v11.682h-2.197z'/%3e%3cpath%20d='m397.172%2086.332v-8.409h-2.352v-1.815h2.352v-4.805h2.198v4.805h3.502v1.815h-3.502v7.925c0%201.43.459%202.146%202.095%202.146.487%200%201.024-.075%201.382-.179v1.816c-.385.077-1.228.152-1.918.152-2.837%200-3.757-1.1-3.757-3.451z'/%3e%3cpath%20d='m183.244%200h2.379v105.309h-2.379z'%20fill='%234d4d4d'/%3e%3c/svg%3e", z0 = "_taxReceiptHint_ukn1q_1", R0 = "_content_ukn1q_24", I0 = "_learnMoreLink_ukn1q_30", _2 = {
  taxReceiptHint: z0,
  content: R0,
  learnMoreLink: I0
}, S0 = "_center_8efln_1", V0 = "_centerIntrinsic_8efln_12", P0 = "_container_8efln_19", A0 = "_flex_8efln_23", Q1 = {
  center: S0,
  centerIntrinsic: V0,
  container: P0,
  flex: A0
};
function $0({
  as: e = "div",
  maxSize: t = "fix-content-total",
  gutter: n = "300",
  className: r,
  centeredChildren: o,
  container: i,
  flex: a,
  style: c,
  ...u
}) {
  return /* @__PURE__ */ s.jsx(
    e,
    {
      ...u,
      className: b(
        Q1.center,
        { [Q1.centerIntrinsic]: o, [Q1.container]: i, [Q1.flex]: a },
        r
      ),
      style: {
        "--container-size": `var(--betterplace-sizing-${t})`,
        "--container-gutters": `var(--betterplace-spacing-${n})`,
        ...c
      },
      children: u.children
    }
  );
}
const O0 = "_stack_19aq8_1", B0 = "_container_19aq8_8", D0 = "_flex_19aq8_12", v2 = {
  stack: O0,
  container: B0,
  flex: D0
};
function l1({
  as: e = "div",
  className: t,
  style: n,
  space: r = "200",
  container: o,
  flex: i,
  ...a
}) {
  return /* @__PURE__ */ s.jsx(
    e,
    {
      ...a,
      className: b(v2.stack, { [v2.container]: o, [v2.flex]: i }, t),
      style: {
        ...n,
        "--space": `var(--betterplace-spacing-${r})`
      },
      children: a.children
    }
  );
}
const Z0 = "_cluster_m70n1_1", F0 = "_clustered_m70n1_7", W0 = "_flex_m70n1_11", U0 = "_justified_m70n1_15", q0 = "_justifyStart_m70n1_19", K0 = "_justifyCenter_m70n1_23", Y0 = "_justifyEnd_m70n1_27", G0 = "_justifySpaceBetween_m70n1_31", X0 = "_justifySpaceAround_m70n1_35", J0 = "_container_m70n1_39", Q0 = "_noWrap_m70n1_43", e3 = "_alignStart_m70n1_47", t3 = "_alignEnd_m70n1_51", n3 = "_alignCenter_m70n1_55", h1 = {
  cluster: Z0,
  clustered: F0,
  flex: W0,
  justified: U0,
  justifyStart: q0,
  justifyCenter: K0,
  justifyEnd: Y0,
  justifySpaceBetween: G0,
  justifySpaceAround: X0,
  container: J0,
  noWrap: Q0,
  alignStart: e3,
  alignEnd: t3,
  alignCenter: n3
}, U1 = U(function({
  as: t = "div",
  alignment: n = "clustered",
  justify: r = "start",
  container: o,
  className: i,
  flex: a,
  wrap: c = !0,
  space: u = "200",
  style: d,
  align: h,
  ...m
}, f) {
  return /* @__PURE__ */ s.jsx(
    t,
    {
      ...m,
      className: b(h1.cluster, i, {
        [h1.justified]: n === "justified",
        [h1.clustered]: n === "clustered",
        [h1.justifyStart]: r === "start",
        [h1.justifyEnd]: r === "end",
        [h1.justifyCenter]: r === "center",
        [h1.justifySpaceAround]: r === "space-around",
        [h1.justifySpaceBetween]: r === "space-between",
        [h1.alignStart]: h === "start",
        [h1.alignEnd]: h === "end",
        [h1.alignCenter]: h === "center",
        [h1.container]: o,
        [h1.flex]: a,
        [h1.noWrap]: !c
      }),
      ref: f,
      style: {
        ...d,
        "--space": `var(--betterplace-spacing-${u})`
      },
      children: m.children
    }
  );
});
function r3() {
  const e = /* @__PURE__ */ new Date();
  return e.getMonth() > 8 || e.getMonth() < 1;
}
function o3() {
  const e = /* @__PURE__ */ new Date();
  let t = e.getFullYear();
  return e.getMonth() < 9 && (t -= 1), t;
}
function i3({
  children: e,
  href: t,
  label: n,
  Link: r = C1
}) {
  const [o, i] = P(!1), [a, c] = P(0), { className: u } = z2({ kind: "secondary" });
  return V(() => {
    i(r3()), c(o3());
  }, []), o ? /* @__PURE__ */ s.jsx(l1, { space: "none", className: _2.taxReceiptHint, children: /* @__PURE__ */ s.jsx("div", { className: _2.content, children: /* @__PURE__ */ s.jsxs("p", { children: [
    e.replace("0000", a.toString()).replace("0001", (a + 1).toString()),
    " ",
    /* @__PURE__ */ s.jsx(E1, { Link: r, href: t, className: b(u, _2.learnMoreLink), children: n })
  ] }) }) }) : null;
}
const s3 = "_footer_1npss_1", c3 = "_grid_1npss_14", a3 = "_item_1npss_18", l3 = "_mobileOnly_1npss_26", u3 = "_wideOnly_1npss_34", d3 = "_accordionContent_1npss_42", h3 = "_accordionLabel_1npss_46", f3 = "_footerLink_1npss_50", C3 = "_cookieSettingsLink_1npss_56", m3 = "_transparentCivilSocietyLink_1npss_61", p3 = "_logo_1npss_69", g3 = "_organizationInfo_1npss_78", w3 = "_organizationInfoDetails_1npss_86", _3 = "_localeSwitchLink_1npss_91", v3 = "_socialLink_1npss_95", x3 = "_socialLinks_1npss_104", b3 = "_footerContent_1npss_111", L3 = "_textContent_1npss_124", r1 = {
  footer: s3,
  grid: c3,
  item: a3,
  mobileOnly: l3,
  wideOnly: u3,
  accordionContent: d3,
  accordionLabel: h3,
  footerLink: f3,
  cookieSettingsLink: C3,
  transparentCivilSocietyLink: m3,
  logo: p3,
  organizationInfo: g3,
  organizationInfoDetails: w3,
  localeSwitchLink: _3,
  socialLink: v3,
  socialLinks: x3,
  footerContent: b3,
  textContent: L3
}, E3 = (e) => /* @__PURE__ */ l.createElement("svg", { width: "800px", height: "800px", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", "xmlns:svg": "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ l.createElement("path", { d: "M 12,1.25 C 6.0718263,1.25 1.25,6.0718263 1.25,12 1.25,17.928127 6.0718217,22.75 12,22.75 17.928132,22.75 22.75,17.928132 22.75,12 22.75,6.0718217 17.928127,1.25 12,1.25 Z m 0,1.5 c 5.117462,0 9.25,4.1324893 9.25,9.25 0,5.117457 -4.132543,9.25 -9.25,9.25 C 6.8824893,21.25 2.75,17.117462 2.75,12 2.75,6.8824848 6.8824848,2.75 12,2.75 Z" }), /* @__PURE__ */ l.createElement("path", { d: "M 7.1464844,8.2636719 A 0.75,0.75 0 0 0 6.2636719,8.8535156 0.75,0.75 0 0 0 6.8535156,9.7363281 L 11.25,10.615234 v 2.236329 l -1.9472656,4.86914 a 0.75,0.75 0 0 0 0.4179687,0.976563 0.75,0.75 0 0 0 0.9765629,-0.417969 L 12,15.023438 l 1.302734,3.255859 a 0.75,0.75 0 0 0 0.976563,0.417969 0.75,0.75 0 0 0 0.417969,-0.976563 L 12.75,12.851563 V 10.615234 L 17.146484,9.7363281 A 0.75,0.75 0 0 0 17.736328,8.8535156 0.75,0.75 0 0 0 16.853516,8.2636719 L 12,9.234375 Z", id: "path32" }), /* @__PURE__ */ l.createElement("path", { d: "M 12,7 C 11.7239,7 11.5,6.77614 11.5,6.5 11.5,6.22386 11.7239,6 12,6 12.2761,6 12.5,6.22386 12.5,6.5 12.5,6.77614 12.2761,7 12,7 Z" }), /* @__PURE__ */ l.createElement("path", { d: "m 12,5.25 c -0.681496,0 -1.25,0.5684504 -1.25,1.25 0,0.6815496 0.568504,1.25 1.25,1.25 0.681496,0 1.25,-0.5684504 1.25,-1.25 0,-0.6815496 -0.568504,-1.25 -1.25,-1.25 z m 0,1 c 0.129296,0 0.25,0.1207298 0.25,0.25 0,0.1292702 -0.120704,0.25 -0.25,0.25 -0.129296,0 -0.25,-0.1207298 -0.25,-0.25 0,-0.1292702 0.120704,-0.25 0.25,-0.25 z" })), k3 = (e) => /* @__PURE__ */ l.createElement("svg", { fill: "none", height: 16, viewBox: "0 0 16 16", width: 16, xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", ...e }, /* @__PURE__ */ l.createElement("clipPath", { id: "a" }, /* @__PURE__ */ l.createElement("path", { d: "m0 0h16v16h-16z" })), /* @__PURE__ */ l.createElement("g", { clipPath: "url(#a)" }, /* @__PURE__ */ l.createElement("path", { clipRule: "evenodd", d: "m8.00016 2.33337c-3.12961 0-5.66666 2.53706-5.66666 5.66667 0 3.12966 2.53705 5.66666 5.66666 5.66666 3.12964 0 5.66664-2.537 5.66664-5.66666 0-3.12961-2.537-5.66667-5.66664-5.66667zm-7.666664 5.66667c0-4.23418 3.432484-7.666666 7.666664-7.666666 4.23414 0 7.66664 3.432486 7.66664 7.666666 0 4.23416-3.4325 7.66666-7.66664 7.66666-4.23418 0-7.666664-3.4325-7.666664-7.66666zm6.666504 2.66666c0-.5523.44772-.99998 1-.99998h.00667c.55228 0 1 .44768 1 .99998s-.44772 1-1 1h-.00667c-.55228 0-1-.4477-1-1zm2-5.33333c0-.55228-.44771-1-1-1-.55228 0-1 .44772-1 1v2.66667c0 .55229.44772 1 1 1 .55229 0 1-.44771 1-1z", fillRule: "evenodd" }))), y3 = (e) => /* @__PURE__ */ l.createElement("svg", { width: 17, height: 17, viewBox: "0 0 17 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ l.createElement("g", { clipPath: "url(#clip0_5790_290)" }, /* @__PURE__ */ l.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.00004 2.3335C4.87043 2.3335 2.33337 4.87055 2.33337 8.00016C2.33337 11.1298 4.87043 13.6668 8.00004 13.6668C11.1297 13.6668 13.6667 11.1298 13.6667 8.00016C13.6667 4.87055 11.1297 2.3335 8.00004 2.3335ZM0.333374 8.00016C0.333374 3.76598 3.76586 0.333496 8.00004 0.333496C12.2342 0.333496 15.6667 3.76598 15.6667 8.00016C15.6667 12.2343 12.2342 15.6668 8.00004 15.6668C3.76586 15.6668 0.333374 12.2343 0.333374 8.00016Z" }), /* @__PURE__ */ l.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.00004 7.00016C8.55233 7.00016 9.00004 7.44788 9.00004 8.00016V10.6668C9.00004 11.2191 8.55233 11.6668 8.00004 11.6668C7.44776 11.6668 7.00004 11.2191 7.00004 10.6668V8.00016C7.00004 7.44788 7.44776 7.00016 8.00004 7.00016Z" }), /* @__PURE__ */ l.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.00004 5.3335C7.00004 4.78121 7.44776 4.3335 8.00004 4.3335H8.00671C8.55899 4.3335 9.00671 4.78121 9.00671 5.3335C9.00671 5.88578 8.55899 6.3335 8.00671 6.3335H8.00004C7.44776 6.3335 7.00004 5.88578 7.00004 5.3335Z" })), /* @__PURE__ */ l.createElement("defs", null, /* @__PURE__ */ l.createElement("clipPath", { id: "clip0_5790_290" }, /* @__PURE__ */ l.createElement("rect", { width: 16.028, height: 16.028, transform: "translate(0 0.111816)" })))), j3 = (e) => /* @__PURE__ */ l.createElement("svg", { fill: "none", height: 16, viewBox: "0 0 16 16", width: 16, xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ l.createElement("path", { clipRule: "evenodd", d: "m6.85529 1.23162c.34944-.19674.7437-.300101 1.14472-.300101.40103 0 .79528.103361 1.14473.300101s.64229.48022.85027.8231l.00288.00475 5.64661 9.42663.0082.0139c.2037.3528.3115.7528.3127 1.1602.0011.4075-.1045.8081-.3062 1.162-.2018.354-.4927.649-.8439.8556-.3511.2066-.7502.3177-1.1576.3222l-.011.0001-11.30434-.0001c-.40741-.0045-.80653-.1156-1.15768-.3222-.351144-.2066-.642068-.5016-.843826-.8556-.201758-.3539-.3073177-.7545-.3061769-1.162.0011409-.4074.1089429-.8074.3126799-1.1602l.008123-.0139 5.64667-9.42662.85784.51386-.85498-.51862c.20799-.34288.50083-.62636.85028-.8231zm.8607 1.85876-5.63928 9.41432c-.0274.0493-.04188.1047-.04204.1611-.00016.0582.01492.1155.04374.166.02882.0506.07038.0927.12055.1223.0491.0288.10477.0447.16169.0459h11.27875c.0569-.0012.1126-.0171.1617-.0459.0501-.0296.0917-.0717.1205-.1223.0288-.0505.0439-.1078.0438-.166-.0002-.0564-.0147-.1118-.0421-.1611l-5.63926-9.41432c-.02965-.04827-.07112-.08819-.12049-.11599-.04992-.02811-.10625-.04287-.16354-.04287s-.11361.01476-.16353.04287c-.04938.0278-.09084.06772-.12049.11599zm.28401 1.90962c.55229 0 1 .44772 1 1v2.66667c0 .55228-.44771 1-1 1-.55228 0-1-.44772-1-1v-2.66667c0-.55228.44772-1 1-1zm0 5.3334c-.55228 0-1 .4477-1 1s.44772 1 1 1h.00667c.55228 0 1-.4477 1-1s-.44772-1-1-1z", fillRule: "evenodd" })), M3 = (e) => /* @__PURE__ */ l.createElement("svg", { width: 48, height: 31, viewBox: "0 0 48 31", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ l.createElement("g", { clipPath: "url(#clip0_2440_75123)" }, /* @__PURE__ */ l.createElement("path", { d: "M43.7014 0H4.29862C4.13451 0 3.97012 0 3.8063 0.000965412C3.66783 0.00196008 3.52968 0.00351059 3.39152 0.00731373C3.09022 0.0155344 2.78634 0.0334676 2.4888 0.0874137C2.18651 0.142296 1.90522 0.231816 1.6308 0.372766C1.36102 0.511171 1.11403 0.692201 0.89999 0.908219C0.685856 1.12424 0.506408 1.37299 0.369241 1.64544C0.229494 1.92228 0.140698 2.20614 0.086672 2.51133C0.0329102 2.81157 0.0150147 3.11808 0.00689488 3.42171C0.00318297 3.56108 0.0015909 3.70045 0.000689024 3.8398C-0.000267954 4.00541 5.10388e-05 4.1709 5.10388e-05 4.33681V26.6635C5.10388e-05 26.8294 -0.000267954 26.9946 0.000689024 27.1606C0.0015909 27.2999 0.00318297 27.4393 0.00689488 27.5786C0.0150147 27.882 0.0329102 28.1885 0.086672 28.4887C0.140698 28.794 0.229494 29.0777 0.369241 29.3546C0.506408 29.627 0.685856 29.8761 0.89999 30.0918C1.11403 30.3082 1.36102 30.4892 1.6308 30.6272C1.90522 30.7686 2.18651 30.8581 2.4888 30.913C2.78634 30.9666 3.09022 30.9848 3.39152 30.993C3.52968 30.9962 3.66783 30.9981 3.8063 30.9987C3.97012 31 4.13451 31 4.29862 31H43.7014C43.8652 31 44.0296 31 44.1934 30.9987C44.3316 30.9981 44.4697 30.9962 44.6085 30.993C44.9092 30.9848 45.213 30.9666 45.5113 30.913C45.8132 30.8581 46.0945 30.7686 46.369 30.6272C46.639 30.4892 46.8853 30.3082 47.0998 30.0918C47.3136 29.8761 47.493 29.627 47.6305 29.3546C47.7706 29.0777 47.8593 28.794 47.9131 28.4887C47.9669 28.1885 47.9843 27.882 47.9925 27.5786C47.9962 27.4393 47.9981 27.2999 47.9987 27.1606C48 26.9946 48 26.8294 48 26.6635V4.33681C48 4.1709 48 4.00541 47.9987 3.8398C47.9981 3.70045 47.9962 3.56108 47.9925 3.42171C47.9843 3.11808 47.9669 2.81157 47.9131 2.51133C47.8593 2.20614 47.7706 1.92228 47.6305 1.64544C47.493 1.37299 47.3136 1.12424 47.0998 0.908219C46.8853 0.692201 46.639 0.511171 46.369 0.372766C46.0945 0.231816 45.8132 0.142296 45.5113 0.0874137C45.213 0.0334676 44.9092 0.0155344 44.6085 0.00731373C44.4697 0.00351059 44.3316 0.00196008 44.1934 0.000965412C44.0296 0 43.8652 0 43.7014 0Z", fill: "#CCCCCC" }), /* @__PURE__ */ l.createElement("path", { d: "M43.7014 1.03326L44.1862 1.0342C44.3175 1.03514 44.4488 1.03657 44.5808 1.0402C44.8105 1.04646 45.0792 1.05901 45.3296 1.1043C45.5473 1.14385 45.7299 1.204 45.9051 1.29398C46.0781 1.38266 46.2366 1.49886 46.3749 1.63826C46.5139 1.77859 46.6292 1.93873 46.7182 2.11517C46.8069 2.29055 46.8662 2.47386 46.9052 2.69509C46.9499 2.94498 46.9623 3.21676 46.9686 3.4499C46.9722 3.58148 46.9739 3.71307 46.9745 3.84779C46.9758 4.01071 46.9758 4.17355 46.9758 4.33679V26.6635C46.9758 26.8267 46.9758 26.9893 46.9745 27.1557C46.9739 27.2872 46.9722 27.4188 46.9686 27.5506C46.9623 27.7834 46.9499 28.0551 46.9046 28.3079C46.8662 28.5261 46.807 28.7094 46.7178 28.8857C46.629 29.0617 46.5138 29.2217 46.3755 29.3611C46.2364 29.5015 46.0784 29.6174 45.9034 29.7069C45.7295 29.7964 45.5472 29.8565 45.3316 29.8957C45.0761 29.9416 44.7962 29.9542 44.5854 29.96C44.4527 29.963 44.3207 29.9648 44.1855 29.9655C44.0243 29.9667 43.8626 29.9667 43.7014 29.9667H4.29864C4.29649 29.9667 4.2944 29.9667 4.29223 29.9667C4.1329 29.9667 3.97326 29.9667 3.81104 29.9654C3.67877 29.9648 3.5468 29.963 3.4192 29.9601C3.20356 29.9542 2.92346 29.9416 2.67003 29.896C2.45263 29.8565 2.27036 29.7964 2.09416 29.7057C1.92078 29.617 1.76293 29.5013 1.62371 29.3606C1.48556 29.2215 1.37075 29.062 1.28198 28.8857C1.19313 28.7096 1.13368 28.5257 1.09459 28.305C1.04941 28.0526 1.03699 27.7821 1.03079 27.5509C1.02725 27.4185 1.02577 27.2861 1.02493 27.1545L1.02429 26.7661L1.02432 26.6635V4.33679L1.02429 4.23422L1.0249 3.84656C1.02577 3.71418 1.02725 3.58184 1.03079 3.44957C1.03699 3.21814 1.04941 2.94747 1.09496 2.69301C1.13371 2.47422 1.19313 2.29032 1.28244 2.11336C1.37051 1.93844 1.48553 1.77877 1.62441 1.63869C1.76273 1.49909 1.9211 1.38304 2.09559 1.29352C2.2699 1.20397 2.45251 1.14385 2.66992 1.10438C2.92041 1.05898 3.18927 1.04646 3.41952 1.04017C3.55077 1.03657 3.68202 1.03514 3.81229 1.03423L4.29864 1.03326H43.7014Z", fill: "white" }), /* @__PURE__ */ l.createElement("path", { d: "M13.1037 10.4266C13.5147 9.90799 13.7936 9.21167 13.72 8.50012C13.1184 8.5303 12.3842 8.90054 11.9592 9.41953C11.5775 9.86397 11.2397 10.5894 11.3278 11.2712C12.0031 11.3303 12.6779 10.9306 13.1037 10.4266Z", fill: "black" }), /* @__PURE__ */ l.createElement("path", { d: "M13.7123 11.4043C12.7315 11.3453 11.8976 11.9658 11.4293 11.9658C10.9606 11.9658 10.2434 11.434 9.46763 11.4483C8.45794 11.4633 7.52107 12.0392 7.00869 12.9552C5.95482 14.7876 6.73058 17.5057 7.75541 18.9981C8.25309 19.7364 8.85288 20.5494 9.64319 20.5202C10.3899 20.4906 10.6826 20.0324 11.5903 20.0324C12.4973 20.0324 12.7609 20.5202 13.5513 20.5054C14.371 20.4906 14.8835 19.7667 15.3812 19.0276C15.9521 18.186 16.1858 17.3733 16.2005 17.3287C16.1858 17.3139 14.6199 16.7079 14.6054 14.8907C14.5906 13.3691 15.8348 12.6454 15.8934 12.6005C15.1908 11.5522 14.0929 11.434 13.7123 11.4043Z", fill: "black" }), /* @__PURE__ */ l.createElement("path", { d: "M22.2523 9.3451C24.384 9.3451 25.8684 10.8275 25.8684 12.9857C25.8684 15.1516 24.3534 16.6417 22.1988 16.6417H19.8386V20.4282H18.1333V9.34509L22.2523 9.3451ZM19.8386 15.1977H21.7952C23.2799 15.1977 24.1249 14.3913 24.1249 12.9934C24.1249 11.5956 23.2799 10.7968 21.8029 10.7968H19.8386V15.1977Z", fill: "black" }), /* @__PURE__ */ l.createElement("path", { d: "M26.314 18.1318C26.314 16.7184 27.3875 15.8506 29.291 15.743L31.4835 15.6125V14.9904C31.4835 14.0918 30.882 13.5541 29.8772 13.5541C28.9253 13.5541 28.3314 14.0149 28.1869 14.7369H26.6338C26.7252 13.2775 27.9584 12.2023 29.938 12.2023C31.8794 12.2023 33.1203 13.2392 33.1203 14.8598V20.4282H31.5443V19.0995H31.5064C31.0421 19.9981 30.0294 20.5664 28.9788 20.5664C27.4104 20.5664 26.314 19.5833 26.314 18.1318ZM31.4835 17.4021V16.7646L29.5116 16.8875C28.5294 16.9566 27.9737 17.3944 27.9737 18.0857C27.9737 18.7922 28.5523 19.2531 29.4355 19.2531C30.5851 19.2531 31.4835 18.4543 31.4835 17.4021Z", fill: "black" }), /* @__PURE__ */ l.createElement("path", { d: "M34.6082 23.4006V22.0565C34.7298 22.0872 35.0039 22.0872 35.141 22.0872C35.9023 22.0872 36.3135 21.7646 36.5646 20.9352C36.5646 20.9198 36.7094 20.4436 36.7094 20.4359L33.8164 12.3482H35.5977L37.6231 18.9229H37.6534L39.6788 12.3482H41.4146L38.4147 20.8506C37.7298 22.8092 36.9379 23.439 35.2782 23.439C35.141 23.439 34.7298 23.4236 34.6082 23.4006Z", fill: "black" })), /* @__PURE__ */ l.createElement("defs", null, /* @__PURE__ */ l.createElement("clipPath", { id: "clip0_2440_75123" }, /* @__PURE__ */ l.createElement("rect", { width: 48, height: 31, fill: "white" })))), N3 = (e) => /* @__PURE__ */ l.createElement("svg", { width: 18, height: 19, viewBox: "0 0 18 19", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ l.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.75 9.92432C2.75 9.37203 3.19772 8.92432 3.75 8.92432H14.25C14.8023 8.92432 15.25 9.37203 15.25 9.92432C15.25 10.4766 14.8023 10.9243 14.25 10.9243H3.75C3.19772 10.9243 2.75 10.4766 2.75 9.92432Z" }), /* @__PURE__ */ l.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.29289 3.96721C8.68342 3.57669 9.31658 3.57669 9.70711 3.96721L14.9571 9.21721C15.3476 9.60773 15.3476 10.2409 14.9571 10.6314L9.70711 15.8814C9.31658 16.2719 8.68342 16.2719 8.29289 15.8814C7.90237 15.4909 7.90237 14.8577 8.29289 14.4672L12.8358 9.92432L8.29289 5.38142C7.90237 4.9909 7.90237 4.35773 8.29289 3.96721Z" })), H3 = (e) => /* @__PURE__ */ l.createElement("svg", { width: 18, height: 19, viewBox: "0 0 18 19", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ l.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9 16.1182C8.44772 16.1182 8 15.6704 8 15.1182L8 4.61816C8 4.06588 8.44771 3.61816 9 3.61816C9.55228 3.61816 10 4.06588 10 4.61816L10 15.1182C10 15.6704 9.55228 16.1182 9 16.1182Z" }), /* @__PURE__ */ l.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.04289 10.5753C2.65237 10.1847 2.65237 9.55158 3.04289 9.16106L8.29289 3.91106C8.68342 3.52053 9.31658 3.52053 9.70711 3.91106L14.9571 9.16106C15.3476 9.55158 15.3476 10.1847 14.9571 10.5753C14.5666 10.9658 13.9334 10.9658 13.5429 10.5753L9 6.03238L4.45711 10.5753C4.06658 10.9658 3.43342 10.9658 3.04289 10.5753Z" })), T3 = (e) => /* @__PURE__ */ l.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ l.createElement("g", { id: "icon-new" }, /* @__PURE__ */ l.createElement("path", { id: "Vector", d: "M12 6H4", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ l.createElement("path", { id: "Vector_2", d: "M14 2H2", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ l.createElement("path", { id: "Vector_3", d: "M14 10H2", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ l.createElement("path", { id: "Vector_4", d: "M12 14H4", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }))), z3 = (e) => /* @__PURE__ */ l.createElement("svg", { width: 17, height: 17, viewBox: "0 0 17 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ l.createElement("g", { transform: "translate(0.50, 0.83)" }, /* @__PURE__ */ l.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.0404 3.29289C14.4309 3.68342 14.4309 4.31658 14.0404 4.70711L6.70707 12.0404C6.51953 12.228 6.26518 12.3333 5.99996 12.3333C5.73474 12.3333 5.48039 12.228 5.29285 12.0404L1.95952 8.70711C1.56899 8.31658 1.56899 7.68342 1.95952 7.29289C2.35004 6.90237 2.98321 6.90237 3.37373 7.29289L5.99996 9.91912L12.6262 3.29289C13.0167 2.90237 13.6499 2.90237 14.0404 3.29289Z" }))), R3 = (e) => /* @__PURE__ */ l.createElement("svg", { fill: "none", height: 16, viewBox: "0 0 16 16", width: 16, xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", ...e }, /* @__PURE__ */ l.createElement("clipPath", { id: "a" }, /* @__PURE__ */ l.createElement("path", { d: "m0 0h16v16h-16z" })), /* @__PURE__ */ l.createElement("g", { clipPath: "url(#a)" }, /* @__PURE__ */ l.createElement("path", { clipRule: "evenodd", d: "m6.75134 2.4688c1.19193-.26931 2.43898-.1461 3.55516.35125.5045.22478 1.0956-.00196 1.3204-.50643s-.0019-1.09565-.5064-1.32043c-1.51013-.672876-3.19732-.83957-4.80992-.475222-1.61261.364348-3.06425 1.240212-4.1384 2.496982-1.07416 1.25676-1.713286 2.82707-1.822065 4.47675-.108779 1.64967.318619 3.2903 1.218455 4.6772.89983 1.387 2.22388 2.4459 3.77469 3.0188 1.5508.5729 3.24527.6292 4.83064.1605 1.5854-.4688 2.9769-1.4375 3.9668-2.7616.9898-1.3242 1.5252-2.93339 1.5261-4.58665v-.61333c0-.55229-.4477-1-1-1s-1 .44771-1 1v.61276c-.0007 1.22197-.3964 2.41102-1.128 3.38972-.7317.9787-1.7601 1.6947-2.93193 2.0412-1.17183.3464-2.42426.3048-3.57051-.1187-1.14624-.4234-2.12489-1.2061-2.78998-2.2312-.6651-1.0251-.981-2.23778-.9006-3.45711.0804-1.21932.5528-2.37999 1.34674-3.3089s1.86689-1.57629 3.05882-1.84559zm8.62276.90458c.3904-.39072.39-1.02389-.0007-1.41421-.3907-.39033-1.0239-.39002-1.4142.0007l-5.95955 5.96552-1.29254-1.29254c-.39053-.39052-1.02369-.39052-1.41422 0-.39052.39053-.39052 1.02369 0 1.41422l2 2.00003c.1876.1876.44206.2929.70736.2929.2653-.0001.51971-.1056.70721-.2933z", fillRule: "evenodd" }))), I3 = (e) => /* @__PURE__ */ l.createElement("svg", { width: 17, height: 17, viewBox: "0 0 17 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ l.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.82269 5.85553C4.17043 5.50779 4.73423 5.50779 5.08197 5.85553L8.01411 8.78767L10.9463 5.85553C11.294 5.50779 11.8578 5.50779 12.2055 5.85553C12.5533 6.20327 12.5533 6.76707 12.2055 7.11481L8.64375 10.6766C8.29601 11.0243 7.73221 11.0243 7.38447 10.6766L3.82269 7.11481C3.47495 6.76707 3.47495 6.20327 3.82269 5.85553Z" })), S3 = (e) => /* @__PURE__ */ l.createElement("svg", { fill: "none", height: 16, viewBox: "0 0 16 16", width: 16, xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ l.createElement("path", { clipRule: "evenodd", d: "m10.7071 3.29289c.3905.39053.3905 1.02369 0 1.41422l-3.29289 3.29289 3.29289 3.2929c.3905.3905.3905 1.0237 0 1.4142s-1.02368.3905-1.41421 0l-4-3.99999c-.39052-.39053-.39052-1.02369 0-1.41422l4-4c.39053-.39052 1.02371-.39052 1.41421 0z", fillRule: "evenodd" })), V3 = (e) => /* @__PURE__ */ l.createElement("svg", { width: 17, height: 17, viewBox: "0 0 17 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ l.createElement("g", { transform: "translate(0.50, 0.50)" }, /* @__PURE__ */ l.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.29289 3.29289C5.68342 2.90237 6.31658 2.90237 6.70711 3.29289L10.7071 7.29289C11.0976 7.68342 11.0976 8.31658 10.7071 8.70711L6.70711 12.7071C6.31658 13.0976 5.68342 13.0976 5.29289 12.7071C4.90237 12.3166 4.90237 11.6834 5.29289 11.2929L8.58579 8L5.29289 4.70711C4.90237 4.31658 4.90237 3.68342 5.29289 3.29289Z" }))), P3 = (e) => /* @__PURE__ */ l.createElement("svg", { width: 17, height: 17, viewBox: "0 0 17 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ l.createElement("g", { transform: "translate(0.50, 0.25)" }, /* @__PURE__ */ l.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.29289 5.54485C7.68342 5.15432 8.31658 5.15432 8.70711 5.54485L12.7071 9.54485C13.0976 9.93537 13.0976 10.5685 12.7071 10.9591C12.3166 11.3496 11.6834 11.3496 11.2929 10.9591L8 7.66617L4.70711 10.9591C4.31658 11.3496 3.68342 11.3496 3.29289 10.9591C2.90237 10.5685 2.90237 9.93537 3.29289 9.54485L7.29289 5.54485Z" }))), A3 = (e) => /* @__PURE__ */ l.createElement("svg", { width: 48, height: 31, viewBox: "0 0 48 31", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ l.createElement("rect", { x: 0.501, y: 0.501, width: 46.998, height: 29.998, rx: 1.502, fill: "white" }), /* @__PURE__ */ l.createElement("rect", { x: 0.501, y: 0.501, width: 46.998, height: 29.998, rx: 1.502, stroke: "#CCCCCC", strokeWidth: 1.002 }), /* @__PURE__ */ l.createElement("path", { d: "M10 9.375C10 7.442 11.567 5.875 13.5 5.875H34.5C36.433 5.875 38 7.442 38 9.375V21.625C38 23.558 36.433 25.125 34.5 25.125H13.5C11.567 25.125 10 23.558 10 21.625V9.375Z", fill: "white" }), /* @__PURE__ */ l.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M34.5 7.625H13.5C12.5335 7.625 11.75 8.4085 11.75 9.375V21.625C11.75 22.5915 12.5335 23.375 13.5 23.375H34.5C35.4665 23.375 36.25 22.5915 36.25 21.625V9.375C36.25 8.4085 35.4665 7.625 34.5 7.625ZM13.5 5.875C11.567 5.875 10 7.442 10 9.375V21.625C10 23.558 11.567 25.125 13.5 25.125H34.5C36.433 25.125 38 23.558 38 21.625V9.375C38 7.442 36.433 5.875 34.5 5.875H13.5Z", fill: "black" }), /* @__PURE__ */ l.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M36.25 14.1875H11.75V10.6875H36.25V14.1875Z", fill: "black" }), /* @__PURE__ */ l.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M21.375 19.875C21.375 20.3582 20.9832 20.75 20.5 20.75L15.25 20.75C14.7668 20.75 14.375 20.3582 14.375 19.875C14.375 19.3918 14.7668 19 15.25 19L20.5 19C20.9832 19 21.375 19.3918 21.375 19.875Z", fill: "black" }), /* @__PURE__ */ l.createElement("path", { d: "M30.125 18.125C30.125 17.6418 30.5168 17.25 31 17.25H33.625C34.1082 17.25 34.5 17.6418 34.5 18.125V20.75C34.5 21.2332 34.1082 21.625 33.625 21.625H31C30.5168 21.625 30.125 21.2332 30.125 20.75V18.125Z", fill: "black" })), $3 = (e) => /* @__PURE__ */ l.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ l.createElement("path", { d: "M7.61257 6.10305C6.80523 7.03731 5.27812 6.64997 5.01295 5.44389L4.73303 4.17185L2.94758 10.8352L11.6409 13.1646L13.3589 6.75308L12.7841 7.41901C11.9514 8.38317 10.3714 7.93618 10.1679 6.67856L9.68568 3.70133L7.61257 6.10305ZM13.4434 14.1652C13.2289 14.9654 12.4064 15.4403 11.6062 15.2259L1.94698 12.6377C1.14678 12.4233 0.67191 11.6008 0.886323 10.8006L3.33196 1.67331C3.72602 0.203628 5.7742 0.203912 6.20874 1.59995L6.24619 1.73939L6.75115 4.03927L8.87327 1.58294C9.68014 0.648847 11.1884 1.03997 11.4666 2.20907L11.4893 2.32434L11.9698 5.30011L13.2708 3.79551C14.3123 2.58959 16.2676 3.62517 15.8551 5.16436L13.4434 14.1652Z" })), O3 = (e) => /* @__PURE__ */ l.createElement("svg", { width: 19, height: 19, viewBox: "0 0 19 19", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ l.createElement("g", { id: "icons-in-use", clipPath: "url(#clip0_708_26327)" }, /* @__PURE__ */ l.createElement("path", { id: "Union", fillRule: "evenodd", clipRule: "evenodd", d: "M15.1454 3.38427C15.2326 3.29703 15.351 3.24802 15.4743 3.24802C15.5977 3.24802 15.716 3.29703 15.8033 3.38427C15.8905 3.47151 15.9395 3.58983 15.9395 3.7132C15.9395 3.83657 15.8905 3.95489 15.8033 4.04213L8.91067 10.9347L8.03352 11.154L8.25281 10.2769L15.1454 3.38427ZM15.4743 1.00195C14.7553 1.00195 14.0657 1.2876 13.5572 1.79606L6.44464 8.90861C6.30072 9.05254 6.19861 9.23288 6.14925 9.43034L5.40056 12.4251C5.30488 12.8078 5.41701 13.2126 5.69595 13.4916C5.97489 13.7705 6.37973 13.8827 6.76244 13.787L9.7572 13.0383C9.95466 12.9889 10.135 12.8868 10.2789 12.7429L17.3915 5.63034C17.8999 5.12188 18.1856 4.43227 18.1856 3.7132C18.1856 2.99413 17.8999 2.30452 17.3915 1.79606C16.883 1.2876 16.1934 1.00195 15.4743 1.00195ZM3.49541 2.58999C2.80044 2.58999 2.13392 2.86607 1.6425 3.3575C1.15108 3.84892 0.875 4.51543 0.875 5.21041V15.6921C0.875 16.387 1.15108 17.0536 1.6425 17.545C2.13392 18.0364 2.80044 18.3125 3.49541 18.3125H13.9771C14.6721 18.3125 15.3386 18.0364 15.83 17.545C16.3214 17.0536 16.5975 16.387 16.5975 15.6921V10.4512C16.5975 9.831 16.0947 9.3282 15.4745 9.3282C14.8542 9.3282 14.3514 9.831 14.3514 10.4512V15.6921C14.3514 15.7913 14.312 15.8866 14.2418 15.9568C14.1716 16.027 14.0764 16.0664 13.9771 16.0664H3.49541C3.39613 16.0664 3.30092 16.027 3.23071 15.9568C3.16051 15.8866 3.12107 15.7913 3.12107 15.6921V5.21041C3.12107 5.11113 3.16051 5.01591 3.23071 4.94571C3.30092 4.8755 3.39613 4.83606 3.49541 4.83606H8.73624C9.35648 4.83606 9.85928 4.33326 9.85928 3.71303C9.85928 3.09279 9.35648 2.58999 8.73624 2.58999H3.49541Z" })), /* @__PURE__ */ l.createElement("defs", null, /* @__PURE__ */ l.createElement("clipPath", { id: "clip0_708_26327" }, /* @__PURE__ */ l.createElement("rect", { width: 18, height: 18, fill: "white", transform: "translate(0.5 0.75)" })))), B3 = (e) => /* @__PURE__ */ l.createElement("svg", { width: 46, height: 46, viewBox: "0 0 46 46", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ l.createElement("g", { id: "Ellipse 424", filter: "url(#filter0_d_5604_449)" }, /* @__PURE__ */ l.createElement("circle", { cx: 22.75, cy: 23.25, r: 18 })), /* @__PURE__ */ l.createElement("defs", null, /* @__PURE__ */ l.createElement("filter", { id: "filter0_d_5604_449", x: 0.25, y: 0.75, width: 45, height: 45, filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB" }, /* @__PURE__ */ l.createElement("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }), /* @__PURE__ */ l.createElement("feColorMatrix", { in: "SourceAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }), /* @__PURE__ */ l.createElement("feOffset", null), /* @__PURE__ */ l.createElement("feGaussianBlur", { stdDeviation: 2.25 }), /* @__PURE__ */ l.createElement("feComposite", { in2: "hardAlpha", operator: "out" }), /* @__PURE__ */ l.createElement("feColorMatrix", { type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0" }), /* @__PURE__ */ l.createElement("feBlend", { mode: "normal", in2: "BackgroundImageFix", result: "effect1_dropShadow_5604_449" }), /* @__PURE__ */ l.createElement("feBlend", { mode: "normal", in: "SourceGraphic", in2: "effect1_dropShadow_5604_449", result: "shape" })))), D3 = (e) => /* @__PURE__ */ l.createElement("svg", { width: 17, height: 17, viewBox: "0 0 17 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ l.createElement("path", { d: "M7.428 10.46C7.788 11.99 8.67 12.656 10.056 12.656C11.028 12.656 11.91 12.332 12.684 11.882V14.06C11.73 14.492 10.884 14.726 9.786 14.726C6.978 14.726 5.124 13.142 4.548 10.46H3L3.396 8.984H4.476V7.706H3L3.396 6.212H4.584C5.286 3.584 7.338 2 9.876 2C11.352 2 12.432 2.45 13.314 3.044L12.306 4.772C11.568 4.286 10.866 4.052 9.984 4.052C8.832 4.052 7.896 4.736 7.464 6.212H11.838L11.442 7.706H7.338V8.984H11.172L10.794 10.46H7.428Z" })), Z3 = (e) => /* @__PURE__ */ l.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ l.createElement("path", { d: "M24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 17.9895 4.3882 22.954 10.125 23.8542V15.4688H7.07812V12H10.125V9.35625C10.125 6.34875 11.9166 4.6875 14.6576 4.6875C15.9701 4.6875 17.3438 4.92188 17.3438 4.92188V7.875H15.8306C14.34 7.875 13.875 8.80008 13.875 9.75V12H17.2031L16.6711 15.4688H13.875V23.8542C19.6118 22.954 24 17.9895 24 12Z" })), F3 = (e) => /* @__PURE__ */ l.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ l.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.64645 2.82076C9.74022 2.72699 9.86739 2.67432 10 2.67432C10.1326 2.67432 10.2598 2.72699 10.3536 2.82076C10.4473 2.91453 10.5 3.04171 10.5 3.17432L10.5 3.24182L10.5 3.2458C10.5017 3.68217 10.631 4.1085 10.872 4.47231C11.1119 4.83463 11.4522 5.11921 11.8511 5.29133C12.2589 5.47012 12.7107 5.52322 13.1489 5.44378C13.5888 5.36401 13.9947 5.15434 14.3143 4.84172L14.3675 4.78853C14.4139 4.74204 14.4691 4.70516 14.5298 4.68C14.5905 4.65484 14.6555 4.64189 14.7213 4.64189C14.787 4.64189 14.852 4.65484 14.9127 4.68C14.9734 4.70516 15.0286 4.74204 15.075 4.78853L15.0758 4.78932C15.1223 4.83575 15.1592 4.8909 15.1843 4.9516C15.2095 5.0123 15.2224 5.07736 15.2224 5.14307C15.2224 5.20877 15.2095 5.27384 15.1843 5.33454C15.1592 5.39523 15.1219 5.45078 15.0754 5.49721L15.0303 5.54217L15.0226 5.55005C14.71 5.86965 14.5003 6.27557 14.4205 6.71547C14.3528 7.08919 14.3814 7.47289 14.5023 7.83067C14.5152 7.9122 14.5382 7.99201 14.5709 8.06825C14.7428 8.46933 15.0282 8.81139 15.392 9.05233C15.7558 9.29327 16.1821 9.42258 16.6185 9.42432H16.75C16.8826 9.42432 17.0098 9.47699 17.1036 9.57076C17.1973 9.66453 17.25 9.79171 17.25 9.92432C17.25 10.0569 17.1973 10.1841 17.1036 10.2779C17.0098 10.3716 16.8826 10.4243 16.75 10.4243L16.6825 10.4243L16.6785 10.4243C16.2421 10.4261 15.8158 10.5554 15.452 10.7963C15.0897 11.0362 14.8051 11.3765 14.633 11.7754C14.4542 12.1832 14.4011 12.635 14.4805 13.0732C14.5603 13.5131 14.77 13.919 15.0826 14.2386L15.1358 14.2918C15.1823 14.3382 15.2192 14.3934 15.2443 14.4541C15.2695 14.5148 15.2824 14.5799 15.2824 14.6456C15.2824 14.7113 15.2695 14.7763 15.2443 14.837C15.2192 14.8977 15.1823 14.9529 15.1358 14.9993L15.135 15.0001C15.0886 15.0466 15.0334 15.0835 14.9727 15.1086C14.912 15.1338 14.847 15.1467 14.7812 15.1467C14.7155 15.1467 14.6505 15.1338 14.5898 15.1086C14.5291 15.0835 14.4735 15.0462 14.4271 14.9997L14.3821 14.9547L14.3743 14.947C14.0547 14.6343 13.6487 14.4246 13.2089 14.3449C12.7707 14.2654 12.3189 14.3185 11.9112 14.4973C11.5122 14.6694 11.1719 14.954 10.932 15.3163C10.691 15.6801 10.5617 16.1065 10.56 16.5428V16.6743C10.56 16.8069 10.5073 16.9341 10.4136 17.0279C10.3198 17.1216 10.1926 17.1743 10.06 17.1743C9.92739 17.1743 9.80022 17.1216 9.70645 17.0279C9.61268 16.9341 9.56 16.8069 9.56 16.6743V16.6068L9.55973 16.5834C9.54923 16.1346 9.40394 15.6993 9.14275 15.3341C8.88769 14.9775 8.53363 14.7039 8.12475 14.5469C7.72336 14.3765 7.28067 14.327 6.85115 14.4049C6.41125 14.4846 6.00529 14.6943 5.68569 15.0069L5.6325 15.0601C5.58607 15.1066 5.53092 15.1435 5.47022 15.1686C5.40952 15.1938 5.34446 15.2067 5.27875 15.2067C5.21304 15.2067 5.14798 15.1938 5.08728 15.1686C5.02658 15.1435 4.97143 15.1066 4.925 15.0601L4.92421 15.0593C4.87773 15.0129 4.84085 14.9577 4.81568 14.897C4.79052 14.8363 4.77757 14.7713 4.77757 14.7056C4.77757 14.6399 4.79052 14.5748 4.81568 14.5141C4.84085 14.4534 4.87812 14.3979 4.9246 14.3514L4.96965 14.3065L4.97736 14.2986C5.28998 13.979 5.4997 13.5731 5.57946 13.1332C5.6589 12.695 5.60581 12.2432 5.42704 11.8355C5.25492 11.4365 4.97034 11.0963 4.608 10.8563C4.24418 10.6154 3.81785 10.4861 3.38149 10.4843H3.25C3.11739 10.4843 2.99022 10.4316 2.89645 10.3379C2.80268 10.2441 2.75 10.1169 2.75 9.98432C2.75 9.85171 2.80268 9.72453 2.89645 9.63076C2.99022 9.53699 3.11739 9.48432 3.25 9.48432H3.3175L3.34088 9.48404C3.78973 9.47354 4.22504 9.32826 4.59022 9.06707C4.94683 8.81201 5.22045 8.45795 5.37742 8.04908C5.54784 7.64769 5.59734 7.20499 5.51946 6.77547C5.4397 6.33557 5.23003 5.9296 4.91741 5.61001L4.86421 5.55682C4.81773 5.51038 4.78085 5.45524 4.75568 5.39454C4.73052 5.33384 4.71757 5.26877 4.71757 5.20307C4.71757 5.13736 4.73052 5.0723 4.75568 5.0116C4.78085 4.9509 4.81773 4.89575 4.86421 4.84932L4.865 4.84853C4.91144 4.80204 4.96658 4.76516 5.02728 4.74C5.08798 4.71484 5.15304 4.70189 5.21875 4.70189C5.28446 4.70189 5.34952 4.71484 5.41022 4.74C5.47092 4.76516 5.52646 4.80243 5.57289 4.84892L5.61785 4.89397L5.62574 4.90168C5.94533 5.2143 6.35125 5.42401 6.79115 5.50378C7.16488 5.57154 7.54857 5.54287 7.90636 5.42202C7.98788 5.40911 8.0677 5.38613 8.14393 5.35346C8.54501 5.18156 8.88708 4.89613 9.12802 4.53231C9.36895 4.1685 9.49826 3.74217 9.5 3.3058V3.17432C9.5 3.04171 9.55268 2.91453 9.64645 2.82076ZM16.4649 12.5781L15.55 12.1743L16.4691 12.5682C16.4874 12.5257 16.5177 12.4894 16.5563 12.4638C16.5946 12.4384 16.6394 12.4247 16.6853 12.4243H16.75C17.413 12.4243 18.0489 12.1609 18.5178 11.6921C18.9866 11.2232 19.25 10.5874 19.25 9.92432C19.25 9.26127 18.9866 8.62539 18.5178 8.15655C18.0489 7.68771 17.413 7.42432 16.75 7.42432H16.6253C16.5794 7.4239 16.5346 7.41019 16.4963 7.38484C16.4809 7.37463 16.4668 7.36271 16.4543 7.34936C16.4413 7.30205 16.4248 7.25565 16.4049 7.21055C16.3857 7.16714 16.38 7.11898 16.3885 7.07228C16.3967 7.0267 16.4181 6.98455 16.45 6.95101L16.4892 6.91182C16.7217 6.67963 16.9061 6.40391 17.0319 6.10042C17.1577 5.79692 17.2224 5.47161 17.2224 5.14307C17.2224 4.81453 17.1577 4.48921 17.0319 4.18572C16.9061 3.88243 16.7219 3.60688 16.4897 3.3748C16.2576 3.1425 15.982 2.95821 15.6786 2.83245C15.3751 2.70664 15.0498 2.64189 14.7213 2.64189C14.3927 2.64189 14.0674 2.70664 13.7639 2.83245C13.4606 2.95819 13.1846 3.14284 12.9525 3.3751L12.9133 3.41429C12.8798 3.44618 12.8376 3.4676 12.792 3.47586C12.7453 3.48433 12.6972 3.47856 12.6538 3.4594L12.6439 3.45518C12.6014 3.43693 12.5651 3.40663 12.5395 3.36802C12.5141 3.32973 12.5004 3.28491 12.5 3.23901V3.17432C12.5 2.51127 12.2366 1.87539 11.7678 1.40655C11.2989 0.937709 10.663 0.674316 10 0.674316C9.33696 0.674316 8.70107 0.937709 8.23223 1.40655C7.76339 1.87539 7.5 2.51127 7.5 3.17432V3.29906C7.49958 3.34495 7.48587 3.38974 7.46052 3.42802C7.45031 3.44344 7.43839 3.45753 7.42504 3.47006C7.37774 3.48305 7.33134 3.49955 7.28623 3.51945C7.24282 3.53861 7.19466 3.54433 7.14797 3.53586C7.10238 3.5276 7.06023 3.50618 7.02669 3.47429L6.98711 3.43471C6.75501 3.20245 6.47942 3.01819 6.1761 2.89245C5.87261 2.76664 5.54729 2.70189 5.21875 2.70189C4.89021 2.70189 4.56489 2.76664 4.2614 2.89245C3.95808 3.01819 3.68249 3.20245 3.45039 3.43471C3.21814 3.66681 3.03388 3.94239 2.90814 4.24572C2.78233 4.54921 2.71757 4.87453 2.71757 5.20307C2.71757 5.53161 2.78233 5.85692 2.90814 6.16042C3.03388 6.46374 3.21853 6.73972 3.45079 6.97182L3.48998 7.01101C3.52187 7.04455 3.54328 7.0867 3.55155 7.13228C3.56001 7.17898 3.5543 7.22714 3.53514 7.27055C3.52663 7.28982 3.51874 7.30936 3.51146 7.32914C3.49501 7.37386 3.46549 7.41261 3.42673 7.44033C3.3899 7.46667 3.34635 7.48191 3.30123 7.48432H3.25C2.58696 7.48432 1.95107 7.74771 1.48223 8.21655C1.01339 8.68539 0.75 9.32127 0.75 9.98432C0.75 10.6474 1.01339 11.2832 1.48223 11.7521C1.95107 12.2209 2.58696 12.4843 3.25 12.4843H3.37469C3.4206 12.4847 3.46541 12.4984 3.5037 12.5238C3.54232 12.5494 3.57256 12.5857 3.59081 12.6283L3.59514 12.6381C3.6143 12.6815 3.62001 12.7297 3.61155 12.7763C3.60328 12.8219 3.58187 12.8641 3.54998 12.8976L3.51079 12.9368C3.27834 13.169 3.09395 13.4447 2.96814 13.7482C2.84233 14.0517 2.77757 14.377 2.77757 14.7056C2.77757 15.0341 2.84233 15.3594 2.96814 15.6629C3.09389 15.9663 3.27818 16.2419 3.51048 16.474C3.74257 16.7062 4.01812 16.8905 4.3214 17.0162C4.62489 17.142 4.95021 17.2067 5.27875 17.2067C5.60729 17.2067 5.93261 17.142 6.2361 17.0162C6.53959 16.8904 6.81532 16.706 7.0475 16.4735L7.08667 16.4344C7.12022 16.4025 7.16237 16.381 7.20797 16.3728C7.25466 16.3643 7.30282 16.37 7.34623 16.3892C7.36551 16.3977 7.38505 16.4056 7.40482 16.4129C7.44955 16.4293 7.48829 16.4588 7.51601 16.4976C7.54235 16.5344 7.55759 16.578 7.56 16.6231V16.6743C7.56 17.3374 7.82339 17.9732 8.29223 18.4421C8.76107 18.9109 9.39696 19.1743 10.06 19.1743C10.723 19.1743 11.3589 18.9109 11.8278 18.4421C12.2966 17.9732 12.56 17.3374 12.56 16.6743V16.5496C12.5604 16.5037 12.5741 16.4589 12.5995 16.4206C12.6251 16.382 12.6614 16.3518 12.704 16.3335L12.7138 16.3292C12.7572 16.31 12.8053 16.3043 12.852 16.3128C12.8976 16.321 12.9398 16.3424 12.9733 16.3743L13.0125 16.4135C13.2447 16.646 13.5204 16.8304 13.8239 16.9562C14.1274 17.082 14.4527 17.1467 14.7812 17.1467C15.1098 17.1467 15.4351 17.082 15.7386 16.9562C16.0419 16.8304 16.3175 16.6462 16.5496 16.4139C16.7819 16.1818 16.9661 15.9062 17.0919 15.6029C17.2177 15.2994 17.2824 14.9741 17.2824 14.6456C17.2824 14.317 17.2177 13.9917 17.0919 13.6882C16.9661 13.3847 16.7817 13.109 16.5492 12.8768L16.51 12.8376C16.4781 12.8041 16.4567 12.7619 16.4485 12.7163C16.44 12.6697 16.4457 12.6215 16.4649 12.5781ZM8.75 9.92432C8.75 9.23396 9.30964 8.67432 10 8.67432C10.6904 8.67432 11.25 9.23396 11.25 9.92432C11.25 10.6147 10.6904 11.1743 10 11.1743C9.30964 11.1743 8.75 10.6147 8.75 9.92432ZM10 6.67432C8.20507 6.67432 6.75 8.12939 6.75 9.92432C6.75 11.7192 8.20507 13.1743 10 13.1743C11.7949 13.1743 13.25 11.7192 13.25 9.92432C13.25 8.12939 11.7949 6.67432 10 6.67432Z" })), W3 = (e) => /* @__PURE__ */ l.createElement("svg", { width: 48, height: 31, viewBox: "0 0 48 31", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ l.createElement("rect", { x: 0.501, y: 0.501, width: 46.998, height: 29.998, rx: 1.502, fill: "white" }), /* @__PURE__ */ l.createElement("rect", { x: 0.501, y: 0.501, width: 46.998, height: 29.998, rx: 1.502, stroke: "#CCCCCC", strokeWidth: 1.002 }), /* @__PURE__ */ l.createElement("g", { clipPath: "url(#clip0_2440_75122)" }, /* @__PURE__ */ l.createElement("path", { d: "M23.0375 15.79V19.9397H21.725V9.67719H25.1375C25.9687 9.67719 26.7562 9.98952 27.3687 10.5696C27.9812 11.105 28.2875 11.9082 28.2875 12.7559C28.2875 13.6037 27.9812 14.3622 27.3687 14.9423C26.7562 15.5223 26.0125 15.8347 25.1375 15.8347L23.0375 15.79ZM23.0375 10.9265V14.4961H25.225C25.7062 14.4961 26.1875 14.3176 26.4937 13.9606C27.1937 13.2914 27.1937 12.1759 26.5375 11.5066L26.4937 11.462C26.1437 11.105 25.7062 10.8819 25.225 10.9265H23.0375Z", fill: "#5F6368" }), /* @__PURE__ */ l.createElement("path", { d: "M31.3062 12.7113C32.2687 12.7113 33.0125 12.979 33.5812 13.5145C34.15 14.0499 34.4125 14.7638 34.4125 15.6562V19.9397H33.1875V18.958H33.1437C32.6187 19.7612 31.875 20.1627 31 20.1627C30.2562 20.1627 29.6 19.9396 29.075 19.4935C28.5937 19.0473 28.2875 18.4226 28.2875 17.7533C28.2875 17.0394 28.55 16.4593 29.075 16.0131C29.6 15.5669 30.3437 15.3885 31.2187 15.3885C32.0062 15.3885 32.6187 15.5223 33.1 15.8347V15.5223C33.1 15.0761 32.925 14.6299 32.575 14.3622C32.225 14.0499 31.7875 13.8714 31.3062 13.8714C30.5625 13.8714 29.9937 14.1837 29.6 14.8084L28.4625 14.0945C29.1625 13.1575 30.0812 12.7113 31.3062 12.7113ZM29.6437 17.7979C29.6437 18.1549 29.8187 18.4672 30.0812 18.6457C30.3875 18.8688 30.7375 19.0026 31.0875 19.0026C31.6125 19.0026 32.1375 18.7795 32.5312 18.378C32.9687 17.9764 33.1875 17.4856 33.1875 16.9501C32.7937 16.6378 32.225 16.4593 31.4812 16.4593C30.9562 16.4593 30.5187 16.5932 30.1687 16.8609C29.8187 17.084 29.6437 17.3963 29.6437 17.7979Z", fill: "#5F6368" }), /* @__PURE__ */ l.createElement("path", { d: "M41.5 12.9344L37.1687 23.063H35.8562L37.475 19.5381L34.6312 12.979H36.0312L38.0875 18.021H38.1312L40.1437 12.979H41.5V12.9344Z", fill: "#5F6368" }), /* @__PURE__ */ l.createElement("path", { d: "M17.8313 14.8977C17.8313 14.4961 17.7875 14.0945 17.7438 13.6929H12.275V15.9685H15.3813C15.25 16.6824 14.8563 17.3517 14.2438 17.7533V19.2257H16.125C17.2188 18.1995 17.8313 16.6824 17.8313 14.8977Z", fill: "#4285F4" }), /* @__PURE__ */ l.createElement("path", { d: "M12.275 20.6536C13.85 20.6536 15.1625 20.1181 16.125 19.2257L14.2437 17.7533C13.7187 18.1102 13.0625 18.3333 12.275 18.3333C10.7875 18.3333 9.47499 17.3071 9.03749 15.8793H7.11249V17.3963C8.11874 19.4042 10.0875 20.6536 12.275 20.6536Z", fill: "#34A853" }), /* @__PURE__ */ l.createElement("path", { d: "M9.03751 15.8793C8.77501 15.1653 8.77501 14.3622 9.03751 13.6037V12.0866H7.11251C6.28126 13.7375 6.28126 15.7008 7.11251 17.3963L9.03751 15.8793Z", fill: "#FBBC04" }), /* @__PURE__ */ l.createElement("path", { d: "M12.275 11.1943C13.1062 11.1943 13.8937 11.5066 14.5062 12.0866L16.1687 10.3911C15.1187 9.40948 13.7187 8.82942 12.3187 8.87404C10.1312 8.87404 8.11875 10.1234 7.15625 12.1313L9.08125 13.6483C9.475 12.2205 10.7875 11.1943 12.275 11.1943Z", fill: "#EA4335" })), /* @__PURE__ */ l.createElement("defs", null, /* @__PURE__ */ l.createElement("clipPath", { id: "clip0_2440_75122" }, /* @__PURE__ */ l.createElement("rect", { width: 35, height: 17, fill: "white", transform: "translate(6.5 7)" })))), U3 = (e) => /* @__PURE__ */ l.createElement("svg", { width: 18, height: 19, viewBox: "0 0 18 19", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ l.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.7507 2.50705C11.3726 2.24934 12.0392 2.1167 12.7125 2.1167C13.3857 2.1167 14.0523 2.24934 14.6743 2.50705C15.2961 2.76469 15.861 3.1423 16.3369 3.6183C16.8129 4.09416 17.1908 4.65946 17.4485 5.28126C17.7062 5.90321 17.8388 6.56984 17.8388 7.24307C17.8388 7.9163 17.7062 8.58293 17.4485 9.20488C17.1908 9.82675 16.8132 10.3918 16.3371 10.8677C16.337 10.8677 16.3371 10.8676 16.3371 10.8677L9.70707 17.4977C9.51954 17.6852 9.26518 17.7906 8.99997 17.7906C8.73475 17.7906 8.4804 17.6852 8.29286 17.4977L1.66286 10.8677C0.701555 9.90637 0.161499 8.60256 0.161499 7.24307C0.161499 5.88358 0.701555 4.57977 1.66286 3.61846C2.62417 2.65716 3.92798 2.1171 5.28747 2.1171C6.64696 2.1171 7.95077 2.65716 8.91207 3.61846L8.99997 3.70636L9.08769 3.61863C9.56363 3.14247 10.1287 2.76475 10.7507 2.50705ZM12.7125 4.1167C12.302 4.1167 11.8955 4.19758 11.5162 4.35472C11.137 4.51185 10.7924 4.74217 10.5022 5.03251L9.70707 5.82768C9.31655 6.2182 8.68339 6.2182 8.29286 5.82768L7.49786 5.03268C6.91163 4.44644 6.11653 4.1171 5.28747 4.1171C4.45841 4.1171 3.66331 4.44644 3.07707 5.03268C2.49084 5.61891 2.1615 6.41401 2.1615 7.24307C2.1615 8.07213 2.49084 8.86723 3.07707 9.45346L8.99997 15.3764L14.9229 9.45346C15.2132 9.16326 15.4437 8.81853 15.6008 8.43929C15.758 8.06005 15.8388 7.65357 15.8388 7.24307C15.8388 6.83257 15.758 6.42608 15.6008 6.04684C15.4437 5.6676 15.2134 5.32304 14.923 5.03284C14.6328 4.7425 14.2879 4.51185 13.9087 4.35472C13.5295 4.19758 13.123 4.1167 12.7125 4.1167Z" })), q3 = (e) => /* @__PURE__ */ l.createElement("svg", { width: 18, height: 19, viewBox: "0 0 18 19", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ l.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.75 3.86597C3.47386 3.86597 3.25 4.08982 3.25 4.36597V14.2018L10.5429 6.90886C10.9334 6.51834 11.5666 6.51834 11.9571 6.90886L14.75 9.70175V4.36597C14.75 4.08982 14.5261 3.86597 14.25 3.86597H3.75ZM14.25 15.366H4.91421L11.25 9.03018L14.2929 12.0731C14.424 12.2042 14.5825 12.2913 14.75 12.3344V14.866C14.75 15.1421 14.5261 15.366 14.25 15.366ZM1.25 4.36597C1.25 2.98525 2.36929 1.86597 3.75 1.86597H14.25C15.6307 1.86597 16.75 2.98525 16.75 4.36597V14.866C16.75 16.2467 15.6307 17.366 14.25 17.366H3.75C2.36929 17.366 1.25 16.2467 1.25 14.866V4.36597ZM6 6.74097C6 6.67193 6.05596 6.61597 6.125 6.61597C6.19404 6.61597 6.25 6.67193 6.25 6.74097C6.25 6.81 6.19404 6.86597 6.125 6.86597C6.05596 6.86597 6 6.81 6 6.74097ZM6.125 4.61597C4.9514 4.61597 4 5.56736 4 6.74097C4 7.91457 4.9514 8.86597 6.125 8.86597C7.2986 8.86597 8.25 7.91457 8.25 6.74097C8.25 5.56736 7.2986 4.61597 6.125 4.61597Z" })), K3 = (e) => /* @__PURE__ */ l.createElement("svg", { width: 17, height: 17, viewBox: "0 0 17 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ l.createElement("path", { d: "M8.34278 2.02783C9.1369 2.02783 9.7 2.60591 9.7 3.36185C9.7 4.1178 9.1369 4.69587 8.34278 4.69587C7.54866 4.69587 7 4.1178 7 3.36185C7 2.60591 7.54866 2.02783 8.34278 2.02783ZM9.49786 6.17812V14.0488H7.21658V6.17812H9.49786Z" })), Y3 = (e) => /* @__PURE__ */ l.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ l.createElement("path", { d: "M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z" })), G3 = (e) => /* @__PURE__ */ l.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ l.createElement("g", { id: "icon-new" }, /* @__PURE__ */ l.createElement("path", { id: "Vector", d: "M11.3333 13.5H2", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ l.createElement("path", { id: "Vector_2", d: "M14 10H2", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ l.createElement("path", { id: "Vector_3", d: "M11.3333 6.5H2", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ l.createElement("path", { id: "Vector_4", d: "M14 3H2", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }))), X3 = (e) => /* @__PURE__ */ l.createElement("svg", { width: 17, height: 17, viewBox: "0 0 17 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ l.createElement("g", { clipPath: "url(#clip0_4337_9)" }, /* @__PURE__ */ l.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.3531 1.05095C10.2149 1.04105 9.11835 1.4786 8.29965 2.26933L8.2893 2.27947L7.14062 3.42146C6.74828 3.81153 6.74643 4.4458 7.13649 4.83815C7.52656 5.23049 8.16083 5.23234 8.55317 4.84228L9.69625 3.70585C10.1366 3.28296 10.725 3.04906 11.3356 3.05437C11.9485 3.0597 12.5348 3.30552 12.9681 3.73889C13.4015 4.17227 13.6473 4.75852 13.6527 5.37139C13.658 5.9816 13.4244 6.56958 13.0021 7.0098L11.0052 9.00674C10.7682 9.24379 10.4831 9.4271 10.169 9.54424C9.85498 9.66139 9.51942 9.70963 9.18511 9.68568C8.85079 9.66174 8.52553 9.56618 8.23139 9.40548C7.93726 9.24477 7.68112 9.0227 7.48036 8.7543C7.14897 8.31128 6.52119 8.22077 6.07816 8.55216C5.63514 8.88355 5.54464 9.51133 5.87602 9.95435C6.24887 10.4528 6.72455 10.8652 7.2708 11.1637C7.81706 11.4621 8.42111 11.6396 9.04199 11.6841C9.66286 11.7285 10.286 11.6389 10.8692 11.4214C11.4525 11.2038 11.9821 10.8634 12.4221 10.4232L14.4255 8.4198L14.4377 8.40738C15.2284 7.58868 15.666 6.49215 15.6561 5.35398C15.6462 4.2158 15.1897 3.12705 14.3848 2.32221C13.58 1.51737 12.4912 1.06084 11.3531 1.05095ZM6.98597 5.68885C6.36509 5.64438 5.74191 5.73397 5.15871 5.95152C4.57555 6.16905 4.04587 6.50958 3.60583 6.94974L1.60245 8.95311L1.59025 8.96553C0.799518 9.78424 0.361978 10.8808 0.371868 12.0189C0.381759 13.1571 0.838288 14.2459 1.64313 15.0507C2.44797 15.8555 3.53673 16.3121 4.6749 16.322C5.81308 16.3319 6.9096 15.8943 7.72831 15.1036L7.74072 15.0914L8.88272 13.9494C9.27393 13.5582 9.27393 12.9239 8.88272 12.5327C8.49151 12.1415 7.85724 12.1415 7.46603 12.5327L6.33075 13.668C5.89052 14.0903 5.30253 14.3238 4.69231 14.3185C4.07945 14.3132 3.49319 14.0674 3.05982 13.634C2.62644 13.2006 2.38062 12.6144 2.37529 12.0015C2.36999 11.3913 2.60354 10.8033 3.02585 10.3631L5.02277 8.36617C5.25973 8.12913 5.5449 7.94582 5.85894 7.82867C6.17297 7.71153 6.50853 7.66329 6.84285 7.68723C7.17716 7.71118 7.50242 7.80674 7.79656 7.96744C8.0907 8.12814 8.34683 8.35022 8.5476 8.61862C8.87898 9.06164 9.50676 9.15214 9.94979 8.82076C10.3928 8.48937 10.4833 7.86159 10.1519 7.41856C9.77908 6.92011 9.3034 6.50768 8.75715 6.20923C8.21089 5.91079 7.60684 5.73332 6.98597 5.68885Z" })), /* @__PURE__ */ l.createElement("defs", null, /* @__PURE__ */ l.createElement("clipPath", { id: "clip0_4337_9" }, /* @__PURE__ */ l.createElement("rect", { width: 16.028, height: 16.028, fill: "white", transform: "translate(0 0.672363)" })))), J3 = (e) => /* @__PURE__ */ l.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ l.createElement("path", { d: "M20.4491 20.4495H16.8931V14.8805C16.8931 13.5525 16.8694 11.844 15.0436 11.844C13.1915 11.844 12.9081 13.2915 12.9081 14.7885V20.4495H9.35207V8.99707H12.7658V10.562H12.8137C13.2886 9.66153 14.4501 8.71003 16.1817 8.71003C19.7861 8.71003 20.4491 11.0825 20.4491 14.1665V20.4495ZM5.33963 7.43157C4.19514 7.43157 3.27271 6.50507 3.27271 5.36507C3.27271 4.22507 4.19514 3.29907 5.33963 3.29907C6.47967 3.29907 7.40655 4.22507 7.40655 5.36507C7.40655 6.50507 6.47967 7.43157 5.33963 7.43157ZM7.11765 20.4495H3.55716V8.99707H7.11765V20.4495ZM22.2222 0H1.77106C0.792355 0 0 0.774024 0 1.72952V22.2705C0 23.226 0.792355 24 1.77106 24H22.2222C23.2031 24 24 23.226 24 22.2705V1.72952C24 0.774024 23.2031 0 22.2222 0Z" })), Q3 = (e) => /* @__PURE__ */ l.createElement("svg", { width: 14, height: 17, viewBox: "0 0 14 17", fill: "none", ...e }, /* @__PURE__ */ l.createElement("path", { d: "M 9.76552,13.5516 C 10.1858,13.0878 10.6623,12.5572 11.3035,11.8392 13.4913,9.40443 13.8942,6.85371 13.1707,4.74891 12.4862,2.76452 9.91715,0.588379 7.03185,0.588379 4.06858,0.610675 1.47788,2.66642 0.819372,4.75337 0.377479,6.15806 -0.047084,8.76229 2.78622,11.8838 l 4.23697,4.7046 0.90978,-1.0078 c 0,0 -2.98061,-3.3222 -4.06368,-4.5262 C 2.99417,9.94401 1.47788,7.96408 2.10606,5.35984 2.34433,4.36541 4.06858,1.95293 7.03619,1.96185 9.99946,1.97076 11.6154,4.49027 11.884,5.23498 c 0.6195,1.72575 0.2729,3.66109 -1.6723,5.80602 -0.69312,0.7625 -0.32921,0.3701 -1.03537,1.146 0,0 -2.86797,-3.20174 -3.60445,-4.03117 C 5.02601,7.54044 4.93936,6.55047 5.53722,5.94401 6.12641,5.35092 7.03619,5.17255 7.76834,5.89496 L 8.63046,6.86263 C 9.07669,7.33977 9.26298,7.33531 9.67454,6.8983 9.99513,6.55939 10.7359,5.71658 10.9266,5.49808 10.5973,5.16809 10.333,4.90053 9.9778,4.53487 9.76552,4.76675 9.28464,5.30633 9.16767,5.43119 8.70411,4.91837 8.11926,4.0711 6.71993,4.05772 5.8708,4.05772 5.11699,4.42784 4.59712,4.9585 3.88662,5.76118 3.76099,6.44345 3.74799,6.81803 3.722,7.59395 3.80431,8.23163 4.74008,9.28403 6.26937,10.9875 8.14092,13.0611 8.59581,13.5605 9.04636,14.051 9.32363,14.0421 9.76552,13.5516 Z" })), et = (e) => /* @__PURE__ */ l.createElement("svg", { width: 18, height: 19, viewBox: "0 0 18 19", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ l.createElement("g", { transform: "translate(0.00, -0.50)" }, /* @__PURE__ */ l.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.4962 1.74798C17.8077 1.92602 18 2.25736 18 2.61621V16.1547C18 16.5135 17.8077 16.8449 17.4961 17.0229C17.1845 17.201 16.8014 17.1984 16.4923 17.0162L11.3628 13.9932L5.19291 13.5739C5.19756 13.613 5.19995 13.6528 5.19995 13.6931V17.3854C5.19995 17.9377 4.75224 18.3854 4.19995 18.3854C3.64767 18.3854 3.19995 17.9377 3.19995 17.3854V13.6931C3.19995 13.6059 3.21112 13.5212 3.23211 13.4406L0.932184 13.2842C0.407432 13.2486 0 12.8125 0 12.2865V6.48434C0 5.9584 0.407406 5.52234 0.93214 5.48665L11.3628 4.77719L16.4923 1.75466C16.8015 1.57248 17.1846 1.56993 17.4962 1.74798ZM16 4.36614L12.1743 6.62039C12.0403 6.69936 11.8897 6.74597 11.7345 6.75653L8.23858 6.99431C8.34058 7.15104 8.39984 7.33813 8.39984 7.53906V11.7872L11.7345 12.0139C11.8897 12.0244 12.0403 12.0711 12.1744 12.1501L16 14.4046V4.36614ZM2 7.41864L6.49493 7.11291C6.43394 7.24219 6.39984 7.38664 6.39984 7.53906V11.6513L2 11.3522V7.41864Z" }))), tt = (e) => /* @__PURE__ */ l.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", "xmlns:svg": "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ l.createElement("path", { d: "M 12,0.75 C 5.7869656,0.75 0.75,5.7869656 0.75,12 0.75,18.213034 5.7869656,23.25 12,23.25 18.213034,23.25 23.25,18.213034 23.25,12 23.25,5.7869656 18.213034,0.75 12,0.75 Z M 12,3 c 5.005454,0 9,3.9945456 9,9 0,5.005454 -3.994546,9 -9,9 C 6.9945456,21 3,17.005454 3,12 3,6.9945456 6.9945456,3 12,3 Z" }), /* @__PURE__ */ l.createElement("circle", { cx: 12, cy: 12, r: 6.75 })), nt = (e) => /* @__PURE__ */ l.createElement("svg", { width: 19, height: 18, viewBox: "0 0 19 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ l.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.48493 2.90037C5.97027 2.90037 3.12107 5.74957 3.12107 9.26423C3.12107 12.7789 5.97027 15.6281 9.48493 15.6281C12.9996 15.6281 15.8488 12.7789 15.8488 9.26423C15.8488 5.74957 12.9996 2.90037 9.48493 2.90037ZM0.875 9.26423C0.875 4.50909 4.7298 0.654297 9.48493 0.654297C14.2401 0.654297 18.0949 4.50909 18.0949 9.26423C18.0949 14.0194 14.2401 17.8742 9.48493 17.8742C4.7298 17.8742 0.875 14.0194 0.875 9.26423ZM10.9823 5.89494C11.6025 5.89494 12.1053 6.39774 12.1053 7.01798V11.5101C12.1053 12.1304 11.6025 12.6332 10.9823 12.6332C10.3621 12.6332 9.85928 12.1304 9.85928 11.5101V7.01798C9.85928 6.39774 10.3621 5.89494 10.9823 5.89494ZM9.1105 7.01798C9.1105 6.39774 8.6077 5.89494 7.98746 5.89494C7.36723 5.89494 6.86443 6.39774 6.86443 7.01798V11.5101C6.86443 12.1304 7.36723 12.6332 7.98746 12.6332C8.6077 12.6332 9.1105 12.1304 9.1105 11.5101V7.01798Z" })), rt = (e) => /* @__PURE__ */ l.createElement("svg", { width: 48, height: 31, viewBox: "0 0 48 31", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ l.createElement("rect", { x: 0.501, y: 0.501, width: 46.998, height: 29.998, rx: 1.502, fill: "white" }), /* @__PURE__ */ l.createElement("rect", { x: 0.501, y: 0.501, width: 46.998, height: 29.998, rx: 1.502, stroke: "#CCCCCC", strokeWidth: 1.002 }), /* @__PURE__ */ l.createElement("g", { clipPath: "url(#clip0_2440_75127)" }, /* @__PURE__ */ l.createElement("path", { d: "M19.4161 12.5452H17.4306C17.2947 12.5452 17.1792 12.6482 17.158 12.7882L16.3549 18.1024C16.339 18.2073 16.4168 18.3018 16.5187 18.3018H17.4666C17.6024 18.3018 17.718 18.1988 17.7392 18.0585L17.9558 16.6252C17.9767 16.4849 18.0925 16.3818 18.2281 16.3818H18.8566C20.1645 16.3818 20.9194 15.7212 21.1165 14.4121C21.2053 13.8394 21.1203 13.3894 20.8633 13.0743C20.5812 12.7282 20.0806 12.5452 19.4161 12.5452ZM19.6452 14.4861C19.5366 15.2297 18.9922 15.2297 18.4659 15.2297H18.1663L18.3764 13.8409C18.3889 13.757 18.4586 13.6952 18.5399 13.6952H18.6772C19.0358 13.6952 19.374 13.6952 19.5488 13.9085C19.653 14.0358 19.6849 14.2249 19.6452 14.4861Z", fill: "#253B80" }), /* @__PURE__ */ l.createElement("path", { d: "M25.3512 14.4621H24.4003C24.3193 14.4621 24.2494 14.5239 24.2369 14.6079L24.1948 14.8854L24.1283 14.7848C23.9225 14.473 23.4635 14.3688 23.0053 14.3688C21.9547 14.3688 21.0573 15.1994 20.8825 16.3645C20.7916 16.9457 20.9208 17.5015 21.2367 17.8891C21.5264 18.2454 21.941 18.3939 22.4343 18.3939C23.2809 18.3939 23.7503 17.8257 23.7503 17.8257L23.7079 18.1015C23.692 18.207 23.7698 18.3015 23.8711 18.3015H24.7275C24.8637 18.3015 24.9787 18.1985 25.0002 18.0582L25.514 14.6615C25.5303 14.557 25.4528 14.4621 25.3512 14.4621ZM24.0258 16.3936C23.9341 16.9606 23.503 17.3412 22.9531 17.3412C22.677 17.3412 22.4563 17.2488 22.3147 17.0736C22.1742 16.8997 22.1207 16.6521 22.1654 16.3764C22.2511 15.8142 22.6895 15.4212 23.2309 15.4212C23.5009 15.4212 23.7204 15.5148 23.865 15.6915C24.0099 15.87 24.0673 16.1191 24.0258 16.3936Z", fill: "#253B80" }), /* @__PURE__ */ l.createElement("path", { d: "M30.415 14.4621H29.4595C29.3684 14.4621 29.2827 14.5094 29.231 14.5885L27.9133 16.6145L27.3547 14.6676C27.3196 14.5457 27.2118 14.4621 27.0899 14.4621H26.151C26.0369 14.4621 25.9576 14.5785 25.9939 14.6906L27.0464 17.9142L26.0569 19.3721C25.9791 19.4869 26.0575 19.6448 26.1919 19.6448H27.1462C27.2368 19.6448 27.3216 19.5988 27.373 19.5212L30.5508 14.7333C30.6269 14.6188 30.5488 14.4621 30.415 14.4621Z", fill: "#253B80" }), /* @__PURE__ */ l.createElement("path", { d: "M33.5783 12.5452H31.5925C31.4569 12.5452 31.3414 12.6482 31.3202 12.7882L30.5172 18.1024C30.5012 18.2073 30.579 18.3018 30.6803 18.3018H31.6994C31.794 18.3018 31.875 18.2297 31.8898 18.1315L32.1177 16.6252C32.1386 16.4849 32.2545 16.3818 32.39 16.3818H33.0183C34.3265 16.3818 35.081 15.7212 35.2785 14.4121C35.3676 13.8394 35.2819 13.3894 35.025 13.0743C34.7431 12.7282 34.2429 12.5452 33.5783 12.5452ZM33.8074 14.4861C33.6991 15.2297 33.1547 15.2297 32.6281 15.2297H32.3288L32.5393 13.8409C32.5517 13.757 32.6208 13.6952 32.7024 13.6952H32.8397C33.198 13.6952 33.5365 13.6952 33.7113 13.9085C33.8155 14.0358 33.8472 14.2249 33.8074 14.4861Z", fill: "#179BD7" }), /* @__PURE__ */ l.createElement("path", { d: "M39.5131 14.4621H38.5629C38.4813 14.4621 38.4119 14.5239 38.3997 14.6079L38.3576 14.8854L38.2909 14.7848C38.085 14.473 37.6263 14.3688 37.1682 14.3688C36.1175 14.3688 35.2204 15.1994 35.0456 16.3645C34.9551 16.9457 35.0837 17.5015 35.3995 17.8891C35.6899 18.2454 36.1039 18.3939 36.5971 18.3939C37.4437 18.3939 37.9132 17.8257 37.9132 17.8257L37.8708 18.1015C37.8548 18.207 37.9326 18.3015 38.0345 18.3015H38.8907C39.0262 18.3015 39.1418 18.1985 39.163 18.0582L39.6772 14.6615C39.6928 14.557 39.615 14.4621 39.5131 14.4621ZM38.1878 16.3936C38.0966 16.9606 37.6649 17.3412 37.1151 17.3412C36.8395 17.3412 36.6183 17.2488 36.4766 17.0736C36.3361 16.8997 36.2833 16.6521 36.3274 16.3764C36.4136 15.8142 36.8514 15.4212 37.3929 15.4212C37.6629 15.4212 37.8824 15.5148 38.027 15.6915C38.1724 15.87 38.2299 16.1191 38.1878 16.3936Z", fill: "#179BD7" }), /* @__PURE__ */ l.createElement("path", { d: "M40.634 12.6909L39.8191 18.1024C39.8031 18.2073 39.8809 18.3018 39.9823 18.3018H40.8016C40.9377 18.3018 41.0533 18.1988 41.0742 18.0585L41.8778 12.7446C41.8937 12.6397 41.8159 12.5449 41.7146 12.5449H40.7972C40.7162 12.5452 40.6465 12.607 40.634 12.6909Z", fill: "#179BD7" }), /* @__PURE__ */ l.createElement("path", { d: "M8.1095 19.3345L8.26133 18.3279L7.92311 18.3197H6.30804L7.43043 10.8915C7.43392 10.8691 7.44524 10.8482 7.46179 10.8333C7.47833 10.8185 7.49953 10.8103 7.52159 10.8103H10.2448C11.1489 10.8103 11.7728 11.0067 12.0985 11.3942C12.2512 11.5761 12.3485 11.7661 12.3955 11.9752C12.4449 12.1945 12.4458 12.4567 12.3976 12.7764L12.3941 12.7997V13.0045L12.5468 13.0948C12.6754 13.1661 12.7776 13.2476 12.856 13.3409C12.9866 13.4964 13.0711 13.6939 13.1068 13.9282C13.1437 14.1691 13.1315 14.4558 13.0711 14.7803C13.0014 15.1536 12.8888 15.4788 12.7367 15.7448C12.5967 15.99 12.4185 16.1933 12.2068 16.3509C12.0048 16.5006 11.7647 16.6142 11.4932 16.687C11.2302 16.7585 10.9303 16.7945 10.6013 16.7945H10.3894C10.2379 16.7945 10.0907 16.8515 9.97511 16.9536C9.85927 17.0579 9.78262 17.2003 9.75911 17.3561L9.74314 17.4467L9.47488 19.2209L9.46269 19.2861C9.4595 19.3067 9.45398 19.317 9.44585 19.3239C9.43859 19.3303 9.42814 19.3345 9.41798 19.3345H8.1095Z", fill: "#253B80" }), /* @__PURE__ */ l.createElement("path", { d: "M12.6914 12.8233C12.6832 12.8775 12.674 12.933 12.6635 12.99C12.3044 14.9145 11.0757 15.5794 9.50653 15.5794H8.70757C8.51566 15.5794 8.35395 15.7248 8.32405 15.9224L7.91499 18.6303L7.79915 19.3979C7.7797 19.5275 7.8755 19.6445 8.00092 19.6445H9.41799C9.58579 19.6445 9.72834 19.5172 9.75476 19.3445L9.7687 19.2694L10.0355 17.5021L10.0526 17.4051C10.0788 17.2318 10.2216 17.1045 10.3894 17.1045H10.6013C11.9743 17.1045 13.0491 16.5227 13.3632 14.8391C13.4944 14.1357 13.4265 13.5485 13.0792 13.1354C12.9741 13.0109 12.8438 12.9075 12.6914 12.8233Z", fill: "#179BD7" }), /* @__PURE__ */ l.createElement("path", { d: "M12.3157 12.667C12.2608 12.6503 12.2042 12.6351 12.1461 12.6215C12.0878 12.6082 12.028 12.5963 11.9664 12.586C11.751 12.5497 11.515 12.5324 11.2621 12.5324H9.12765C9.0751 12.5324 9.02516 12.5448 8.98045 12.5673C8.88204 12.6167 8.80887 12.7139 8.79116 12.833L8.3371 15.8348L8.32404 15.9224C8.35394 15.7248 8.51565 15.5794 8.70755 15.5794H9.50652C11.0757 15.5794 12.3044 14.9142 12.6635 12.99C12.6742 12.933 12.6832 12.8776 12.6914 12.8233C12.6005 12.773 12.5021 12.73 12.3961 12.6933C12.37 12.6842 12.343 12.6754 12.3157 12.667Z", fill: "#222D65" }), /* @__PURE__ */ l.createElement("path", { d: "M8.79116 12.833C8.80887 12.7139 8.88203 12.6167 8.98045 12.5676C9.02545 12.5452 9.07509 12.5327 9.12764 12.5327H11.2621C11.515 12.5327 11.751 12.55 11.9664 12.5864C12.028 12.5967 12.0878 12.6085 12.1461 12.6218C12.2042 12.6355 12.2608 12.6506 12.3157 12.6673C12.343 12.6758 12.37 12.6845 12.3964 12.6933C12.5024 12.73 12.6008 12.7733 12.6916 12.8233C12.7985 12.1121 12.6908 11.6279 12.3224 11.1894C11.9162 10.7067 11.1831 10.5 10.2451 10.5H7.52187C7.33025 10.5 7.1668 10.6455 7.13719 10.8433L6.0029 18.3479C5.98055 18.4964 6.09029 18.6303 6.23371 18.6303H7.91496L8.33709 15.8348L8.79116 12.833Z", fill: "#253B80" })), /* @__PURE__ */ l.createElement("defs", null, /* @__PURE__ */ l.createElement("clipPath", { id: "clip0_2440_75127" }, /* @__PURE__ */ l.createElement("rect", { width: 36, height: 10, fill: "white", transform: "translate(6 10.5)" })))), ot = (e) => /* @__PURE__ */ l.createElement("svg", { width: 18, height: 19, viewBox: "0 0 18 19", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ l.createElement("g", { id: "icons-in-use", clipPath: "url(#clip0_1384_7139)" }, /* @__PURE__ */ l.createElement("path", { id: "Union", fillRule: "evenodd", clipRule: "evenodd", d: "M8.98493 2.66404C5.47027 2.66404 2.62107 5.51324 2.62107 9.0279C2.62107 12.5426 5.47027 15.3918 8.98493 15.3918C12.4996 15.3918 15.3488 12.5426 15.3488 9.0279C15.3488 5.51324 12.4996 2.66404 8.98493 2.66404ZM0.375 9.0279C0.375 4.27277 4.2298 0.417969 8.98493 0.417969C13.7401 0.417969 17.5949 4.27277 17.5949 9.0279C17.5949 13.783 13.7401 17.6378 8.98493 17.6378C4.2298 17.6378 0.375 13.783 0.375 9.0279ZM8.98489 4.91011C9.60512 4.91011 10.1079 5.41291 10.1079 6.03314V7.90468H11.9797C12.5999 7.90468 13.1027 8.40748 13.1027 9.02772C13.1027 9.64795 12.5999 10.1508 11.9797 10.1508H10.1079V12.0227C10.1079 12.6429 9.60512 13.1457 8.98489 13.1457C8.36465 13.1457 7.86185 12.6429 7.86185 12.0227V10.1508H5.99017C5.36994 10.1508 4.86714 9.64795 4.86714 9.02772C4.86714 8.40748 5.36994 7.90468 5.99017 7.90468H7.86185V6.03314C7.86185 5.41291 8.36465 4.91011 8.98489 4.91011Z" })), /* @__PURE__ */ l.createElement("defs", null, /* @__PURE__ */ l.createElement("clipPath", { id: "clip0_1384_7139" }, /* @__PURE__ */ l.createElement("rect", { width: 18, height: 18, fill: "white", transform: "translate(0 0.294922)" })))), it = (e) => /* @__PURE__ */ l.createElement("svg", { width: 18, height: 19, viewBox: "0 0 18 19", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ l.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.4605 1.83661C16.5012 1.87211 16.5393 1.91049 16.5745 1.95144C16.6422 2.03012 16.6972 2.11595 16.7396 2.20626C16.8075 2.35099 16.8455 2.51261 16.8455 2.68309V7.17523C16.8455 7.79547 16.3427 8.29827 15.7225 8.29827C15.1023 8.29827 14.5995 7.79547 14.5995 7.17523V5.39429L8.28097 11.7128C7.8424 12.1514 7.13133 12.1514 6.69276 11.7128C6.25419 11.2742 6.25419 10.5631 6.69276 10.1246L13.0112 3.80613H11.2304C10.6101 3.80613 10.1073 3.30333 10.1073 2.68309C10.1073 2.06286 10.6101 1.56006 11.2304 1.56006H15.7223C15.7223 1.56006 15.7224 1.56006 15.7225 1.56006C15.8833 1.56006 16.0361 1.59383 16.1744 1.65468C16.2763 1.69944 16.373 1.76008 16.4605 1.83661ZM3.74346 6.0522C3.64418 6.0522 3.54896 6.09164 3.47876 6.16184C3.40856 6.23204 3.36912 6.32726 3.36912 6.42654V14.6621C3.36912 14.7614 3.40856 14.8566 3.47876 14.9268C3.54896 14.997 3.64418 15.0365 3.74346 15.0365H11.979C12.0783 15.0365 12.1735 14.997 12.2438 14.9268C12.314 14.8566 12.3534 14.7614 12.3534 14.6621V10.17C12.3534 9.54976 12.8562 9.04696 13.4764 9.04696C14.0967 9.04696 14.5995 9.54976 14.5995 10.17V14.6621C14.5995 15.3571 14.3234 16.0236 13.832 16.515C13.3405 17.0065 12.674 17.2825 11.979 17.2825H3.74346C3.04848 17.2825 2.38197 17.0065 1.89055 16.515C1.39913 16.0236 1.12305 15.3571 1.12305 14.6621V6.42654C1.12305 5.73157 1.39913 5.06505 1.89055 4.57363C2.38197 4.08221 3.04848 3.80613 3.74346 3.80613H8.2356C8.85583 3.80613 9.35863 4.30893 9.35863 4.92916C9.35863 5.5494 8.85583 6.0522 8.2356 6.0522H3.74346Z" })), st = (e) => /* @__PURE__ */ l.createElement("svg", { width: 17, height: 17, viewBox: "0 0 17 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ l.createElement("g", { transform: "translate(0.00, 0.50)" }, /* @__PURE__ */ l.createElement("path", { d: "M8.61589 2C10.872 2 12 3.28748 12 4.75653C12 7.43054 9.21854 7.24897 9.21854 9.09766V9.51032H6.99338V8.99862C6.99338 6.14305 9.45033 6.34113 9.45033 4.98762C9.45033 4.3934 9.04856 4.04677 8.36865 4.04677C7.7351 4.04677 7.117 4.37689 6.56071 5.05365L5 3.76616C5.88079 2.66025 7.02428 2 8.61589 2ZM8.13687 11.0124C8.90949 11.0124 9.52759 11.6891 9.52759 12.4979C9.52759 13.3232 8.90949 14 8.13687 14C7.36424 14 6.74614 13.3232 6.74614 12.4979C6.74614 11.6891 7.36424 11.0124 8.13687 11.0124Z" }))), ct = (e) => /* @__PURE__ */ l.createElement("svg", { width: 17, height: 17, viewBox: "0 0 17 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ l.createElement("path", { d: "M2 3.89286C2 2.34428 3.68436 1.38245 5.01758 2.17021L13.0518 6.91825C14.3617 7.69239 14.3617 9.58748 13.0518 10.3616L5.01758 15.1097C3.68435 15.8974 2 14.9356 2 13.387V3.89286ZM4 13.387L12.0342 8.63993L4 3.89286V13.387Z" })), at = (e) => /* @__PURE__ */ l.createElement("svg", { width: 27, height: 28, viewBox: "0 0 27 28", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ l.createElement("circle", { cx: 13.5, cy: 14.21, r: 12.9375, fill: "white", stroke: "#919191", strokeWidth: 1.125 }), /* @__PURE__ */ l.createElement("circle", { cx: 13.4882, cy: 14.2689, r: 6.75, fill: "#357C00" })), lt = (e) => /* @__PURE__ */ l.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ l.createElement("g", { id: "icon-new" }, /* @__PURE__ */ l.createElement("path", { id: "Vector", d: "M13.9974 13.5H4.66406", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ l.createElement("path", { id: "Vector_2", d: "M14 10H2", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ l.createElement("path", { id: "Vector_3", d: "M13.9974 6.5H4.66406", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ l.createElement("path", { id: "Vector_4", d: "M14 3H2", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }))), ut = (e) => /* @__PURE__ */ l.createElement("svg", { width: 18, height: 18, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", "xmlns:svg": "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ l.createElement("g", { id: "g172" }, /* @__PURE__ */ l.createElement("path", { d: "m 7.2832031,1.0820312 c -3.4075754,0 -6.2011718,2.760278 -6.2011719,6.1503907 0,3.3901121 2.7935966,6.1503901 6.2011719,6.1503911 3.4075749,-1e-6 6.2011719,-2.760278 6.2011719,-6.1503911 0,-3.3901128 -2.793597,-6.1503907 -6.2011719,-6.1503907 z m 0,2.0000001 c 2.3372567,0 4.2011719,1.8518356 4.2011719,4.1503906 0,2.2985548 -1.8639152,4.1503901 -4.2011719,4.1503911 -2.3372569,0 -4.2011718,-1.8518362 -4.2011718,-4.1503911 0,-2.2985551 1.863915,-4.1503907 4.2011718,-4.1503906 z" }), /* @__PURE__ */ l.createElement("path", { d: "m 11.324219,10.238281 a 1.000005,1.000005 0 0 0 -0.707031,0.296875 1.000005,1.000005 0 0 0 0.0078,1.414063 l 4.623047,4.578125 a 1.000005,1.000005 0 0 0 1.414062,-0.0078 1.000005,1.000005 0 0 0 -0.0078,-1.414062 L 12.03125,10.527344 a 1.000005,1.000005 0 0 0 -0.707031,-0.289063 z" }))), dt = (e) => /* @__PURE__ */ l.createElement("svg", { width: 49, height: 31, viewBox: "0 0 49 31", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ l.createElement("rect", { x: 1.45901, y: 0.501, width: 46.998, height: 29.998, rx: 1.502, fill: "white" }), /* @__PURE__ */ l.createElement("rect", { x: 1.45901, y: 0.501, width: 46.998, height: 29.998, rx: 1.502, stroke: "#CCCCCC", strokeWidth: 1.002 }), /* @__PURE__ */ l.createElement("path", { d: "M6.71753 13.2189C6.71753 13.0217 6.81879 12.9205 6.81879 12.7233C7.01599 11.5348 7.51164 11.0391 8.6042 10.8419C9.98989 10.5435 11.3809 10.5435 12.7666 10.7407C14.1523 10.9378 14.7492 11.732 14.7492 13.0217V13.6186H12.3722V13.5174C12.271 12.6273 12.0738 12.5261 11.1837 12.5261H10.1924C9.5955 12.6273 9.30238 12.8245 9.30238 13.5174C9.30238 14.1143 9.49957 14.4074 10.1924 14.4074C10.7893 14.4074 11.3809 14.4074 11.9778 14.5087L13.7632 14.8071C14.5573 15.0043 14.9517 15.6012 15.053 16.3953C15.053 17.0882 15.053 17.8823 14.9517 18.5751C14.8505 19.3692 14.3548 19.8649 13.662 20.0621C13.0651 20.2593 12.5694 20.3605 11.9778 20.4565H10.1924C9.5955 20.3552 9.00392 20.3552 8.40701 20.2593C7.51697 20.0621 6.92005 19.4652 6.81879 18.5751C6.81879 18.4739 6.71753 18.2767 6.71753 18.1807V17.2854H9.09452C9.19579 18.1754 9.39298 18.4739 9.98457 18.4739H11.77C12.3669 18.4739 12.5641 18.0795 12.5641 17.4826C12.5641 16.8857 12.2656 16.5925 11.77 16.5925C10.8799 16.4913 9.88863 16.3953 8.99326 16.2941C7.7035 16.1928 7.11192 15.6012 6.90939 14.3115C6.90939 14.2102 6.80813 14.1143 6.80813 14.013C6.71753 13.7146 6.71753 13.5174 6.71753 13.2189ZM25.9467 20.4565V11.0391C25.9467 10.6447 26.0479 10.5435 26.4423 10.5435C28.1265 10.5435 29.8106 10.5435 31.5001 10.6447C33.2855 10.746 34.1755 11.636 34.2768 13.4214C34.3781 14.2155 34.2768 15.0096 34.1755 15.7984C33.9783 16.9869 33.083 17.781 31.7985 17.781H28.4249V20.3605C27.6308 20.4565 26.7408 20.4565 25.9467 20.4565ZM28.4249 15.6012H30.706C31.3029 15.6012 31.5001 15.3028 31.5001 14.7112V13.7199C31.5001 13.027 31.2016 12.7286 30.5088 12.6273H28.7234C28.6221 12.6273 28.4249 12.8245 28.4249 12.8245V15.6012ZM33.1842 20.4565C33.7812 18.3726 34.474 16.1928 35.0656 14.1143C35.46 12.9258 35.7584 11.7373 36.1581 10.5435H39.9262C40.0274 10.5435 40.2246 10.7407 40.2246 10.8419L42.9001 19.7636C43.0013 19.9608 43.0973 20.2593 43.1985 20.4565H40.5177C40.3206 19.9608 40.2193 19.4652 40.0221 18.9695C39.9208 18.8683 39.8249 18.6711 39.7236 18.6711H36.5525C36.4513 18.6711 36.2541 18.7723 36.2541 18.8683C36.0569 19.3639 35.9556 19.9608 35.8544 20.4565H33.1842ZM38.242 12.6273H38.1408C37.7464 14.013 37.3466 15.5 36.9523 16.891H39.5318C39.1321 15.3987 38.6364 14.013 38.242 12.6273Z", fill: "#26367E" }), /* @__PURE__ */ l.createElement("path", { d: "M22.6727 18.8683C21.0845 18.8683 19.896 18.1755 19.4003 17.0829H22.9712L23.3656 15.9903H19.0006V15.2016L23.4615 15.3988L23.9571 14.1143H19.1978C19.6935 12.7286 20.9832 12.0305 22.6674 12.0305C23.3815 12.0251 24.0851 12.1637 24.7513 12.4249L25.1456 11.0392C24.7513 10.842 23.8559 10.6448 22.5661 10.6448C19.8907 10.6448 17.8068 11.9345 17.114 14.2156H15.9255L15.4298 15.3082H16.9168V16.1929H16.0267L15.4298 17.2854H17.114C17.7162 19.268 19.6029 20.4565 22.2783 20.4565C23.5681 20.4565 24.5594 20.2593 24.9538 20.0568L24.6553 18.6711C24.2609 18.7724 23.4668 18.8737 22.6727 18.8683Z", fill: "#FCBD0C" })), ht = (e) => /* @__PURE__ */ l.createElement("svg", { width: 18, height: 19, viewBox: "0 0 18 19", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ l.createElement("g", { clipPath: "url(#clip0_289_147)" }, /* @__PURE__ */ l.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.5 3.11597C12.8096 3.11597 12.25 3.67561 12.25 4.36597C12.25 4.57993 12.3038 4.78133 12.3985 4.95741C12.4063 4.96953 12.4138 4.98187 12.4212 4.99443C12.4285 5.00693 12.4355 5.01953 12.4422 5.03222C12.6635 5.38298 13.0546 5.61597 13.5 5.61597C14.1904 5.61597 14.75 5.05632 14.75 4.36597C14.75 3.67561 14.1904 3.11597 13.5 3.11597ZM11.3324 6.78761C11.9075 7.30272 12.6672 7.61597 13.5 7.61597C15.2949 7.61597 16.75 6.16089 16.75 4.36597C16.75 2.57104 15.2949 1.11597 13.5 1.11597C11.7051 1.11597 10.25 2.57104 10.25 4.36597C10.25 4.60426 10.2756 4.83656 10.3243 5.06027L6.66753 7.19429C6.09244 6.67921 5.3328 6.36597 4.5 6.36597C2.70507 6.36597 1.25 7.82104 1.25 9.61597C1.25 11.4109 2.70507 12.866 4.5 12.866C5.33301 12.866 6.09283 12.5526 6.66797 12.0372L10.3251 14.1683C10.2759 14.3931 10.25 14.6265 10.25 14.866C10.25 16.6609 11.7051 18.116 13.5 18.116C15.2949 18.116 16.75 16.6609 16.75 14.866C16.75 13.071 15.2949 11.616 13.5 11.616C12.6684 11.616 11.9098 11.9283 11.335 12.442L7.67579 10.3097C7.72439 10.0862 7.75 9.85407 7.75 9.61597C7.75 9.37766 7.72435 9.14534 7.67566 8.92162L11.3324 6.78761ZM5.55773 8.94955C5.56445 8.96228 5.57147 8.97493 5.5788 8.98748C5.58616 9.0001 5.59375 9.01249 5.60157 9.02466C5.69627 9.20071 5.75 9.40206 5.75 9.61597C5.75 9.82981 5.6963 10.0311 5.60166 10.2071C5.5937 10.2195 5.58597 10.2321 5.57848 10.245C5.57124 10.2574 5.5643 10.2699 5.55765 10.2825C5.33624 10.6331 4.94531 10.866 4.5 10.866C3.80964 10.866 3.25 10.3063 3.25 9.61597C3.25 8.92561 3.80964 8.36597 4.5 8.36597C4.94537 8.36597 5.33633 8.59888 5.55773 8.94955ZM12.3757 14.319C12.3946 14.2928 12.4124 14.2654 12.429 14.2369C12.4448 14.2099 12.4591 14.1823 12.4721 14.1545C12.6978 13.8291 13.074 13.616 13.5 13.616C14.1904 13.616 14.75 14.1756 14.75 14.866C14.75 15.5563 14.1904 16.116 13.5 16.116C12.8096 16.116 12.25 15.5563 12.25 14.866C12.25 14.6698 12.2952 14.4842 12.3757 14.319Z" })), /* @__PURE__ */ l.createElement("defs", null, /* @__PURE__ */ l.createElement("clipPath", { id: "clip0_289_147" }, /* @__PURE__ */ l.createElement("rect", { width: 18, height: 18, fill: "white", transform: "translate(0 0.615967)" })))), ft = (e) => /* @__PURE__ */ l.createElement("svg", { width: 19, height: 19, viewBox: "0 0 19 19", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ l.createElement("g", { clipPath: "url(#clip0_164_69547)" }, /* @__PURE__ */ l.createElement("path", { d: "M15.1689 1.04712C16.1712 1.04735 16.9834 1.86022 16.9834 2.86255V10.7278C16.9834 10.8233 16.9711 10.916 16.9502 11.0051C16.9723 11.1232 16.9834 11.2444 16.9834 11.3674C16.9832 12.7039 15.6287 13.7874 13.958 13.7874C12.2875 13.7872 10.9338 12.7038 10.9336 11.3674C10.9336 10.0309 12.2874 8.94672 13.958 8.94653C14.1652 8.94653 14.368 8.96362 14.5635 8.99536V3.46704H7.30273V13.718C7.38037 13.9323 7.42383 14.1585 7.42383 14.3928C7.42353 15.7292 6.06904 16.8127 4.39844 16.8127C2.72796 16.8126 1.37334 15.7292 1.37305 14.3928C1.37305 13.0563 2.72777 11.972 4.39844 11.9719C4.56335 11.9719 4.72506 11.9858 4.88281 12.0061V2.86255C4.88281 1.86008 5.69577 1.04712 6.69824 1.04712H15.1689Z" })), /* @__PURE__ */ l.createElement("defs", null, /* @__PURE__ */ l.createElement("clipPath", { id: "clip0_164_69547" }, /* @__PURE__ */ l.createElement("rect", { width: 18, height: 18, fill: "white", transform: "translate(0.25 0.25)" })))), Ct = (e) => /* @__PURE__ */ l.createElement("svg", { width: 18, height: 19, viewBox: "0 0 18 19", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ l.createElement("path", { d: "M9.75002 2.17432L9.80471 2.17627C11.6138 2.27607 13.3224 3.03967 14.6035 4.3208C15.8847 5.60194 16.6483 7.31057 16.7481 9.11963C16.7491 9.13785 16.75 9.15607 16.75 9.17432V9.54639L16.7383 9.97607C16.682 10.9738 16.4201 11.9503 15.9688 12.8452L15.9698 12.8462C15.3576 14.071 14.4165 15.1015 13.252 15.8218C12.0878 16.5417 10.7458 16.9225 9.37698 16.9233L9.37795 16.9243L9.376 16.9233L9.37502 16.9243V16.9233C8.37181 16.9256 7.38067 16.7213 6.46291 16.3237L2.56643 17.6226C2.2071 17.7423 1.81082 17.6492 1.54299 17.3813C1.27517 17.1135 1.18201 16.7172 1.30178 16.3579L2.60061 12.4614C2.20269 11.5429 1.99741 10.5505 2.00002 9.54639C2.00103 8.17792 2.38277 6.83628 3.10256 5.67236C3.82279 4.50786 4.85336 3.56672 6.07815 2.95459C7.10048 2.439 8.23002 2.17272 9.37502 2.17529V2.17432H9.75002ZM6.9717 4.74365C6.07908 5.18982 5.32861 5.87636 4.80373 6.7251C4.27896 7.57374 4.00049 8.55153 4.00002 9.54932V9.55225C3.99817 10.2806 4.14694 11.0002 4.43557 11.6665L4.56741 11.9487L4.60842 12.0396C4.69153 12.2551 4.69768 12.4942 4.62405 12.7153L3.8301 15.0933L6.20901 14.3003C6.43015 14.2267 6.66921 14.2328 6.88479 14.3159L6.97561 14.3569L7.25784 14.4888C7.92411 14.7774 8.64377 14.9262 9.37209 14.9243H9.37502L9.74807 14.9116C10.6153 14.8509 11.4567 14.5798 12.1992 14.1206C13.048 13.5957 13.7345 12.8453 14.1807 11.9526L15.0752 12.3989L14.9307 12.3267L14.1807 11.9526L14.1826 11.9487L14.3145 11.6665C14.6031 11.0002 14.7519 10.2806 14.75 9.55225V9.20361C14.6715 7.89571 14.1164 6.66177 13.1895 5.73486C12.2623 4.80772 11.028 4.25257 9.71975 4.17432H9.37209C8.53981 4.1722 7.71851 4.36646 6.97561 4.7417L6.9717 4.74365L6.53323 3.86475L6.52444 3.84912L6.9717 4.74365Z" })), mt = (e) => /* @__PURE__ */ l.createElement("svg", { width: 14, height: 17, viewBox: "0 0 14 17", fill: "none", ...e }, /* @__PURE__ */ l.createElement("style", null, `
    @keyframes stroke-offset-animation {
      to {
        stroke-dashoffset: 240;
      }
    }

    mask path {
      stroke-miterlimit: 50;
      stroke-dasharray: 60;
      animation: stroke-offset-animation 4s linear infinite;
      animation-direction: reverse;
      stroke-width: 2;
    }
  `), /* @__PURE__ */ l.createElement("defs", { id: "defs79" }, /* @__PURE__ */ l.createElement("mask", { maskUnits: "userSpaceOnUse", id: "mask6031" }, /* @__PURE__ */ l.createElement("path", { style: {
  display: "inline",
  fill: "none",
  stroke: "#fff",
  strokeWidth: 2,
  strokeOpacity: 1
}, d: "M 7.6355932,16.207627 C 2.8813559,10.661017 1.1370534,9.786973 1.2245763,5.8347458 1.2785241,3.398654 4.7953789,1.1065425 7.3474576,1.2245763 9.8434648,1.3400168 12.470245,3.8044802 12.894068,6.2669491 13.342313,8.8713176 9.1483051,13.254237 9.1483051,13.254237 c 0,0 -3.8177966,-3.8898302 -4.3940678,-4.9703387 C 4.1779661,7.2033898 4.3801992,4.8079258 6.7711864,4.6101695 7.5774278,4.4844471 9.220339,6.4110169 9.220339,6.4110169 l 1.440678,-1.5847457" }))), /* @__PURE__ */ l.createElement("g", { mask: "url(#mask6031)", id: "g70" }, /* @__PURE__ */ l.createElement("path", { d: "M 9.76552,13.5516 C 10.1858,13.0878 10.6623,12.5572 11.3035,11.8392 13.4913,9.40443 13.8942,6.85371 13.1707,4.74891 12.4862,2.76452 9.91715,0.588379 7.03185,0.588379 4.06858,0.610675 1.47788,2.66642 0.819372,4.75337 0.377479,6.15806 -0.047084,8.76229 2.78622,11.8838 l 4.23697,4.7046 0.90978,-1.0078 c 0,0 -2.98061,-3.3222 -4.06368,-4.5262 C 2.99417,9.94401 1.47788,7.96408 2.10606,5.35984 2.34433,4.36541 4.06858,1.95293 7.03619,1.96185 9.99946,1.97076 11.6154,4.49027 11.884,5.23498 c 0.6195,1.72575 0.2729,3.66109 -1.6723,5.80602 -0.69312,0.7625 -0.32921,0.3701 -1.03537,1.146 0,0 -2.86797,-3.20174 -3.60445,-4.03117 C 5.02601,7.54044 4.93936,6.55047 5.53722,5.94401 6.12641,5.35092 7.03619,5.17255 7.76834,5.89496 L 8.63046,6.86263 C 9.07669,7.33977 9.26298,7.33531 9.67454,6.8983 9.99513,6.55939 10.7359,5.71658 10.9266,5.49808 10.5973,5.16809 10.333,4.90053 9.9778,4.53487 9.76552,4.76675 9.28464,5.30633 9.16767,5.43119 8.70411,4.91837 8.11926,4.0711 6.71993,4.05772 5.8708,4.05772 5.11699,4.42784 4.59712,4.9585 3.88662,5.76118 3.76099,6.44345 3.74799,6.81803 3.722,7.59395 3.80431,8.23163 4.74008,9.28403 6.26937,10.9875 8.14092,13.0611 8.59581,13.5605 9.04636,14.051 9.32363,14.0421 9.76552,13.5516 Z" }))), pt = (e) => /* @__PURE__ */ l.createElement("svg", { width: 19, height: 17, viewBox: "0 0 19 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ l.createElement("path", { d: "M9.48469 0.17382C9.912 0.173959 10.3023 0.416857 10.4915 0.800044L12.5434 4.95659L17.1332 5.62887C17.556 5.69067 17.9072 5.98688 18.0391 6.39328C18.1709 6.79983 18.0612 7.24663 17.755 7.54483L14.4342 10.7779L15.2183 15.3469C15.2906 15.7682 15.1167 16.1945 14.7709 16.4458C14.4251 16.6967 13.9668 16.7301 13.5886 16.5313L9.48359 14.3719L5.37969 16.5313C5.00148 16.73 4.54313 16.6968 4.19743 16.4458C3.85156 16.1945 3.67881 15.7682 3.75107 15.3469L4.53303 10.7779L1.21437 7.54483C0.908214 7.24663 0.797409 6.79983 0.929228 6.39328C1.06109 5.98683 1.41228 5.69068 1.83511 5.62887L6.42376 4.95659L8.47681 0.800044C8.66601 0.416748 9.05724 0.17382 9.48469 0.17382ZM8.17741 6.48102C8.0139 6.81191 7.69817 7.0418 7.33294 7.09518L4.4102 7.5218L6.52466 9.58143C6.78949 9.83943 6.91069 10.2117 6.84819 10.5761L6.34919 13.4824L8.96156 12.1094C9.28863 11.9374 9.67961 11.9375 10.0067 12.1094L12.6191 13.4835L12.1212 10.5761C12.0587 10.2117 12.1798 9.83944 12.4447 9.58143L14.5581 7.5218L11.6353 7.09518C11.2701 7.04179 10.9544 6.81199 10.7909 6.48102L9.48359 3.83355L8.17741 6.48102Z" })), gt = (e) => /* @__PURE__ */ l.createElement("svg", { width: 19, height: 19, viewBox: "0 0 19 19", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ l.createElement("g", { clipPath: "url(#clip0_1661_26179)" }, /* @__PURE__ */ l.createElement("g", { clipPath: "url(#clip1_1661_26179)" }, /* @__PURE__ */ l.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.12107 9.13825C3.12107 5.62359 5.97027 2.77439 9.48493 2.77439C12.9996 2.77439 15.8488 5.62359 15.8488 9.13825C15.8488 12.6529 12.9996 15.5021 9.48493 15.5021C5.97027 15.5021 3.12107 12.6529 3.12107 9.13825ZM9.48493 0.52832C4.7298 0.52832 0.875 4.38312 0.875 9.13825C0.875 13.8934 4.7298 17.7482 9.48493 17.7482C14.2401 17.7482 18.0949 13.8934 18.0949 9.13825C18.0949 4.38312 14.2401 0.52832 9.48493 0.52832ZM7.23882 5.76897C6.61858 5.76897 6.11578 6.27177 6.11578 6.892V11.3841C6.11578 12.0044 6.61858 12.5072 7.23882 12.5072H11.731C12.3512 12.5072 12.854 12.0044 12.854 11.3841V6.892C12.854 6.27177 12.3512 5.76897 11.731 5.76897H7.23882ZM8.36185 10.2611V8.01504H10.6079V10.2611H8.36185Z" }))), /* @__PURE__ */ l.createElement("defs", null, /* @__PURE__ */ l.createElement("clipPath", { id: "clip0_1661_26179" }, /* @__PURE__ */ l.createElement("rect", { width: 18, height: 18, fill: "white", transform: "translate(0.5 0.5)" })), /* @__PURE__ */ l.createElement("clipPath", { id: "clip1_1661_26179" }, /* @__PURE__ */ l.createElement("rect", { width: 17.9686, height: 17.9686, fill: "white", transform: "translate(0.5 0.153809)" })))), wt = (e) => /* @__PURE__ */ l.createElement("svg", { width: 17, height: 17, viewBox: "0 0 17 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ l.createElement("g", { transform: "translate(0.50, 0.50)" }, /* @__PURE__ */ l.createElement("g", { clipPath: "url(#clip0_5667_1175)" }, /* @__PURE__ */ l.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1 4.00016C1 3.44788 1.44772 3.00016 2 3.00016H14C14.5523 3.00016 15 3.44788 15 4.00016C15 4.55245 14.5523 5.00016 14 5.00016H2C1.44772 5.00016 1 4.55245 1 4.00016Z" }), /* @__PURE__ */ l.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.66667 2.3335C6.57826 2.3335 6.49348 2.36861 6.43096 2.43113C6.36845 2.49364 6.33333 2.57842 6.33333 2.66683V3.00016H9.66667V2.66683C9.66667 2.57842 9.63155 2.49364 9.56904 2.43113C9.50652 2.36861 9.42174 2.3335 9.33333 2.3335H6.66667ZM11.6667 3.00016V2.66683C11.6667 2.04799 11.4208 1.4545 10.9832 1.01691C10.5457 0.579329 9.95217 0.333496 9.33333 0.333496H6.66667C6.04783 0.333496 5.45434 0.579329 5.01675 1.01691C4.57917 1.4545 4.33333 2.04799 4.33333 2.66683V3.00016H3.33333C2.78105 3.00016 2.33333 3.44788 2.33333 4.00016V13.3335C2.33333 13.9523 2.57917 14.5458 3.01675 14.9834C3.45434 15.421 4.04783 15.6668 4.66667 15.6668H11.3333C11.9522 15.6668 12.5457 15.421 12.9832 14.9834C13.4208 14.5458 13.6667 13.9523 13.6667 13.3335V4.00016C13.6667 3.44788 13.219 3.00016 12.6667 3.00016H11.6667ZM4.33333 5.00016V13.3335C4.33333 13.4219 4.36845 13.5067 4.43096 13.5692C4.49348 13.6317 4.57826 13.6668 4.66667 13.6668H11.3333C11.4217 13.6668 11.5065 13.6317 11.569 13.5692C11.6315 13.5067 11.6667 13.4219 11.6667 13.3335V5.00016H4.33333Z" }), /* @__PURE__ */ l.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.33333 6.3335C9.88562 6.3335 10.3333 6.78121 10.3333 7.3335V11.3335C10.3333 11.8858 9.88562 12.3335 9.33333 12.3335C8.78105 12.3335 8.33333 11.8858 8.33333 11.3335V7.3335C8.33333 6.78121 8.78105 6.3335 9.33333 6.3335Z" }), /* @__PURE__ */ l.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.66667 6.3335C7.21895 6.3335 7.66667 6.78121 7.66667 7.3335V11.3335C7.66667 11.8858 7.21895 12.3335 6.66667 12.3335C6.11438 12.3335 5.66667 11.8858 5.66667 11.3335V7.3335C5.66667 6.78121 6.11438 6.3335 6.66667 6.3335Z" })), /* @__PURE__ */ l.createElement("defs", null, /* @__PURE__ */ l.createElement("clipPath", { id: "clip0_5667_1175" }, /* @__PURE__ */ l.createElement("rect", { width: 16.028, height: 16.028, fill: "white", transform: "translate(0 0.251953)" }))))), _t = (e) => /* @__PURE__ */ l.createElement("svg", { viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ l.createElement("g", { clipPath: "url(#clip0_371_2681)" }, /* @__PURE__ */ l.createElement("path", { d: "M1.12305 14.0684V11.0732C1.12305 10.453 1.62585 9.9502 2.24608 9.9502C2.86632 9.9502 3.36912 10.453 3.36912 11.0732V14.0684C3.36921 14.1675 3.40867 14.2625 3.47879 14.3327C3.54891 14.4028 3.64395 14.4422 3.7431 14.4423H14.2255C14.3246 14.4422 14.4197 14.4028 14.4898 14.3327C14.5599 14.2625 14.5994 14.1675 14.5995 14.0684V11.0732C14.5995 10.453 15.1023 9.9502 15.7225 9.9502C16.3427 9.9502 16.8455 10.453 16.8455 11.0732V14.0684C16.8454 14.7632 16.5692 15.4294 16.0778 15.9207C15.5865 16.412 14.9203 16.6883 14.2255 16.6884H3.7431C3.04825 16.6883 2.38208 16.412 1.89075 15.9207C1.39941 15.4294 1.12314 14.7632 1.12305 14.0684Z" }), /* @__PURE__ */ l.createElement("path", { d: "M8.18984 1.29466C8.62835 0.856147 9.3393 0.856269 9.77788 1.29466L13.5221 5.03774C13.9605 5.47619 13.9603 6.18718 13.5221 6.62578C13.0835 7.06436 12.3726 7.06435 11.934 6.62578L8.98386 3.67562L6.0348 6.62578C5.59623 7.06436 4.88533 7.06436 4.44676 6.62578C4.00837 6.1872 4.00825 5.47625 4.44676 5.03774L8.18984 1.29466Z" }), /* @__PURE__ */ l.createElement("path", { d: "M7.86121 11.0731V2.08886C7.86121 1.46862 8.36401 0.96582 8.98424 0.96582C9.60448 0.96582 10.1073 1.46862 10.1073 2.08886V11.0731C10.1073 11.6934 9.60448 12.1962 8.98424 12.1962C8.36401 12.1962 7.86121 11.6934 7.86121 11.0731Z" })), /* @__PURE__ */ l.createElement("defs", null, /* @__PURE__ */ l.createElement("clipPath", { id: "clip0_371_2681" }, /* @__PURE__ */ l.createElement("rect", { width: 18, height: 18 })))), vt = (e) => /* @__PURE__ */ l.createElement("svg", { width: 16, height: 18, viewBox: "0 0 16 18", fill: "none", ...e }, /* @__PURE__ */ l.createElement("path", { d: "m 8,0.5 c -2.381386,0 -4.3339844,1.9525984 -4.3339844,4.3339844 0,2.381386 1.9525948,4.3320312 4.3339844,4.3320312 2.38139,0 4.333984,-1.9506271 4.333984,-4.3320312 C 12.333984,2.4525803 10.381386,0.5 8,0.5 Z m 0,2 c 1.3005103,0 2.333984,1.0334921 2.333984,2.3339844 0,1.3004922 -1.0334773,2.3320312 -2.333984,2.3320312 -1.3005067,0 -2.3339844,-1.0315209 -2.3339844,-2.3320312 C 5.6660156,3.533474 6.6994897,2.5 8,2.5 Z m -3.3339844,8 c -1.1488976,0 -2.2520727,0.457177 -3.0644531,1.269531 -0.81241753,0.812392 -1.26757812,1.915605 -1.26757812,3.064453 V 16.5 a 1,1 0 0 0 1.00000002,1 1,1 0 0 0 1,-1 v -1.666016 c 0,-0.61915 0.2457725,-1.212583 0.6835937,-1.65039 C 3.4554364,12.745749 4.046795,12.5 4.6660156,12.5 h 6.6679684 c 0.619143,0 1.210626,0.245782 1.648438,0.683594 0.437812,0.437812 0.683594,1.031248 0.683594,1.65039 V 16.5 a 1,1 0 0 0 1,1 1,1 0 0 0 1,-1 v -1.666016 c 0,-1.148855 -0.457145,-2.252066 -1.269532,-3.064453 C 13.584098,10.957145 12.48284,10.5 11.333984,10.5 Z" })), xt = (e) => /* @__PURE__ */ l.createElement("svg", { width: 18, height: 19, viewBox: "0 0 18 19", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ l.createElement("g", { id: "icons-in-use", clipPath: "url(#clip0_400_13741)" }, /* @__PURE__ */ l.createElement("path", { id: "Union", fillRule: "evenodd", clipRule: "evenodd", d: "M9.04448 2.43367L8.98392 2.43359L8.92341 2.43368L8.75493 2.43428C8.60963 2.43496 8.40112 2.43632 8.14707 2.43904C7.63944 2.44447 6.94783 2.45534 6.21423 2.47714C5.48243 2.49888 4.69984 2.53176 4.01294 2.58186C3.35745 2.62967 2.69351 2.69889 2.25517 2.81612L2.23959 2.82041C1.69697 2.97392 1.20448 3.26792 0.811846 3.67269C0.419215 4.07746 0.140355 4.57868 0.0034326 5.12572C-0.00264338 5.15 -0.00790626 5.17447 -0.0123473 5.1991C-0.259841 6.57151 -0.381094 7.9637 -0.374589 9.35822C-0.383023 10.7633 -0.26176 12.1661 -0.0123389 13.5488C-0.00575995 13.5853 0.00262049 13.6214 0.0127716 13.6571C0.163723 14.1871 0.44883 14.6693 0.840547 15.057C1.23226 15.4446 1.71734 15.7248 2.24893 15.8702L2.25517 15.8719C2.69351 15.9891 3.35745 16.0583 4.01294 16.1061C4.69984 16.1562 5.48243 16.1891 6.21423 16.2109C6.94783 16.2327 7.63944 16.2435 8.14707 16.249C8.40112 16.2517 8.60963 16.253 8.75493 16.2537L8.92341 16.2543L8.98392 16.2544C8.98399 16.2544 8.98405 16.2544 8.98405 15.1314C8.98405 16.2544 8.98521 16.2544 8.98528 16.2544L9.04469 16.2543L9.21317 16.2537C9.35847 16.253 9.56698 16.2517 9.82103 16.249C10.3287 16.2435 11.0203 16.2327 11.7539 16.2109C12.4857 16.1891 13.2683 16.1562 13.9552 16.1061C14.6106 16.0583 15.2746 15.9891 15.7129 15.8719L15.7285 15.8676C16.2711 15.7141 16.7636 15.4201 17.1563 15.0153C17.5489 14.6105 17.8277 14.1093 17.9647 13.5623C17.9707 13.538 17.976 13.5135 17.9805 13.4889C18.2261 12.1266 18.3473 10.7447 18.3427 9.36047C18.3512 7.95518 18.2299 6.55211 17.9804 5.1691L16.8752 5.36846L17.9647 5.09578C17.8277 4.54874 17.5489 4.04752 17.1563 3.64274C16.7636 3.23797 16.2711 2.94398 15.7285 2.79046C15.7155 2.78677 15.7024 2.78331 15.6892 2.7801C15.2597 2.67523 14.604 2.61241 13.9481 2.56873C13.2632 2.52312 12.4821 2.49315 11.751 2.47331C11.0182 2.45343 10.3272 2.44352 9.81998 2.43856C9.56616 2.43608 9.35785 2.43484 9.21271 2.43422L9.04448 2.43367ZM15.544 5.20659C15.6543 5.32026 15.7346 5.45936 15.7779 5.61136C15.9978 6.84588 16.1044 8.09793 16.0966 9.35192L16.0966 9.36301C16.101 10.598 15.9944 11.8309 15.7778 13.0467C15.7346 13.1987 15.6543 13.3378 15.544 13.4515C15.4285 13.5706 15.2839 13.6577 15.1247 13.7042C14.9153 13.7586 14.4557 13.8176 13.7918 13.866C13.1507 13.9128 12.4041 13.9445 11.6872 13.9658C10.972 13.987 10.2954 13.9977 9.797 14.003C9.54802 14.0057 9.34405 14.007 9.20263 14.0077L9.03973 14.0083H8.92837L8.76547 14.0077C8.62405 14.007 8.42008 14.0057 8.1711 14.003C7.67269 13.9977 6.99607 13.987 6.28095 13.9658C5.56403 13.9445 4.81743 13.9128 4.17633 13.866C3.50728 13.8172 3.04575 13.7577 2.83864 13.7029C2.68086 13.6592 2.5369 13.5757 2.42051 13.4605C2.31421 13.3553 2.23416 13.2269 2.18652 13.0856C1.9691 11.8579 1.86372 10.6129 1.87155 9.36603L1.87148 9.35342C1.86533 8.10892 1.97203 6.86646 2.19026 5.64129C2.23354 5.48929 2.3138 5.3502 2.42406 5.23653C2.53964 5.11737 2.68417 5.03031 2.84345 4.98383C3.05283 4.92944 3.5124 4.87041 4.17633 4.82198C4.81743 4.77522 5.56403 4.74352 6.28095 4.72222C6.99607 4.70097 7.67269 4.69031 8.1711 4.68498C8.42008 4.68232 8.62405 4.68099 8.76547 4.68032L8.92837 4.67974L9.03995 4.67974L9.20309 4.68027C9.34467 4.68087 9.54884 4.68209 9.79804 4.68452C10.2969 4.68939 10.9741 4.69913 11.6901 4.71856C12.4076 4.73803 13.1558 4.76701 13.7988 4.80984C14.4502 4.85322 14.9126 4.9063 15.1358 4.95719C15.2906 5.00444 15.4311 5.0902 15.544 5.20659ZM7.8547 5.93471C7.50706 5.73702 7.08053 5.7391 6.73484 5.94018C6.38916 6.14127 6.17649 6.51101 6.17649 6.91093V11.8074C6.17649 12.2073 6.38916 12.577 6.73484 12.7781C7.08053 12.9792 7.50706 12.9813 7.8547 12.7836L12.1597 10.3354C12.5107 10.1357 12.7275 9.76298 12.7275 9.35914C12.7275 8.95531 12.5107 8.58256 12.1597 8.38293L7.8547 5.93471ZM9.33274 9.35914L8.42256 9.87676V8.84153L9.33274 9.35914Z" })), /* @__PURE__ */ l.createElement("defs", null, /* @__PURE__ */ l.createElement("clipPath", { id: "clip0_400_13741" }, /* @__PURE__ */ l.createElement("rect", { width: 18, height: 18, fill: "white", transform: "translate(0 0.75)" })))), bt = (e) => /* @__PURE__ */ l.createElement("svg", { width: 17, height: 17, viewBox: "0 0 17 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ l.createElement("g", { clipPath: "url(#clip0_7320_27996)" }, /* @__PURE__ */ l.createElement("path", { d: "M6.70837 2.60809C7.00854 2.36796 7.4205 2.32146 7.76697 2.48798C8.11326 2.65456 8.33337 3.00505 8.33337 3.38934V12.7224C8.33337 13.1066 8.11318 13.4571 7.76697 13.6237C7.4205 13.7902 7.00854 13.7437 6.70837 13.5036L3.64978 11.0563H1.33337C0.781198 11.0563 0.33355 10.6085 0.333374 10.0563V6.05634C0.333374 5.50405 0.781089 5.05634 1.33337 5.05634H3.6488L6.70837 2.60809ZM4.62439 6.83661C4.44718 6.97835 4.22729 7.05626 4.00037 7.05634H2.33337V9.05634H4.00037L4.16833 9.07001C4.33439 9.09835 4.4914 9.16876 4.62439 9.27509L6.33337 10.6413V5.46942L4.62439 6.83661Z" }), /* @__PURE__ */ l.createElement("path", { d: "M13.6657 8.05558C13.6656 6.55324 13.0686 5.11225 12.0065 4.04972C11.6161 3.65914 11.616 3.02613 12.0065 2.63566C12.3971 2.2452 13.0301 2.24509 13.4206 2.63566C14.8578 4.07327 15.6656 6.02282 15.6657 8.05558C15.6657 10.0885 14.8579 12.0388 13.4206 13.4765C13.0301 13.867 12.3971 13.8669 12.0065 13.4765C11.616 13.086 11.6161 12.453 12.0065 12.0624C13.0688 10.9998 13.6657 9.55811 13.6657 8.05558ZM10.3356 8.05265C10.3356 7.43404 10.0903 6.84077 9.65302 6.40324C9.26262 6.01272 9.26264 5.37966 9.65302 4.98917C10.0436 4.59871 10.6766 4.59861 11.0671 4.98917C11.8795 5.80178 12.3356 6.90362 12.3356 8.05265C12.3356 9.20168 11.8794 10.3035 11.0671 11.1161C10.6766 11.5067 10.0436 11.5066 9.65302 11.1161C9.26268 10.7256 9.26264 10.0926 9.65302 9.70206C10.0903 9.26452 10.3356 8.67126 10.3356 8.05265Z" })), /* @__PURE__ */ l.createElement("defs", null, /* @__PURE__ */ l.createElement("clipPath", { id: "clip0_7320_27996" }, /* @__PURE__ */ l.createElement("rect", { width: 16.028, height: 16.028, fill: "white", transform: "translate(0 0.280273)" })))), Lt = (e) => /* @__PURE__ */ l.createElement("svg", { width: 17, height: 17, viewBox: "0 0 17 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ l.createElement("g", { transform: "translate(0.50, -0.28)" }, /* @__PURE__ */ l.createElement("g", { clipPath: "url(#clip0_4332_2222)" }, /* @__PURE__ */ l.createElement("g", { clipPath: "url(#clip1_4332_2222)" }, /* @__PURE__ */ l.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.6687 3.10921C12.1648 1.61064 10.1647 0.78494 8.0336 0.78418C3.64227 0.78418 0.068376 4.34054 0.066848 8.71195C0.066084 10.1094 0.433176 11.4734 1.13031 12.6755L0 16.7842L4.22327 15.6817C5.3868 16.3136 6.69702 16.6462 8.03018 16.6466H8.0336C12.4242 16.6466 15.9985 13.0898 16 8.71841C16.0008 6.59982 15.173 4.60779 13.6687 3.10921ZM8.0336 15.3077H8.03093C6.84293 15.3073 5.67751 14.9895 4.66067 14.3892L4.41885 14.2463L1.91262 14.9005L2.58148 12.4686L2.4241 12.2193C1.76135 11.1701 1.41107 9.95732 1.41183 8.71235C1.41336 5.07918 4.38371 2.12309 8.03631 2.12309C9.80489 2.12385 11.4673 2.81003 12.7176 4.0558C13.9678 5.3012 14.6558 6.95717 14.655 8.71766C14.6535 12.3512 11.6832 15.3077 8.0336 15.3077ZM11.6656 10.3725C11.4665 10.2733 10.4879 9.79424 10.3053 9.72812C10.1227 9.66195 9.99018 9.62891 9.8576 9.82733C9.72507 10.0258 9.34347 10.4721 9.22733 10.604C9.1112 10.7363 8.99507 10.7526 8.79604 10.6534C8.59707 10.5542 7.95569 10.3451 7.19516 9.67031C6.60347 9.14493 6.20387 8.49641 6.08778 8.29795C5.97164 8.09953 6.07556 7.99231 6.17484 7.89385C6.26422 7.8049 6.37387 7.66234 6.47356 7.54677C6.57329 7.43119 6.60613 7.34835 6.67258 7.21641C6.73907 7.08411 6.70582 6.96858 6.65618 6.86932C6.60649 6.77011 6.20849 5.79499 6.04231 5.39851C5.88071 5.01228 5.71649 5.06474 5.59462 5.05828C5.47849 5.05257 5.34596 5.05143 5.21302 5.05143C5.08009 5.05143 4.86462 5.10085 4.68204 5.2993C4.49947 5.49772 3.98529 5.97709 3.98529 6.95182C3.98529 7.92654 4.69849 8.86897 4.79818 9.00127C4.89787 9.13356 6.20196 11.1343 8.19862 11.9927C8.67347 12.1968 9.04436 12.3189 9.33351 12.4101C9.81027 12.561 10.2442 12.5398 10.5872 12.4888C10.9696 12.4318 11.7649 12.0094 11.9307 11.5468C12.0964 11.0841 12.0964 10.6872 12.0468 10.6047C11.9972 10.5222 11.8646 10.4717 11.6656 10.3725Z" }))), /* @__PURE__ */ l.createElement("defs", null, /* @__PURE__ */ l.createElement("clipPath", { id: "clip0_4332_2222" }, /* @__PURE__ */ l.createElement("rect", { width: 16.028, height: 16.028, fill: "white", transform: "translate(0 0.78418)" })), /* @__PURE__ */ l.createElement("clipPath", { id: "clip1_4332_2222" }, /* @__PURE__ */ l.createElement("rect", { width: 16.028, height: 16.028, fill: "white", transform: "translate(0 0.78418)" }))))), Et = (e) => /* @__PURE__ */ l.createElement("svg", { width: 48, height: 31, viewBox: "0 0 48 31", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ l.createElement("rect", { x: 0.501, y: 0.501, width: 46.998, height: 29.998, rx: 1.502, fill: "white" }), /* @__PURE__ */ l.createElement("rect", { x: 0.501, y: 0.501, width: 46.998, height: 29.998, rx: 1.502, stroke: "#CCCCCC", strokeWidth: 1.002 }), /* @__PURE__ */ l.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.418 13.9485L15.4421 13.9929L15.5229 13.9485H16.1352V15.2593H17.009V19.6287H16.1352V21.3764H13.5135V23.998H34.4864V21.3764H31.8648V19.6287H30.991V15.2593H31.8648V13.9485H32.4771L32.5579 13.9929L32.582 13.9485H33.6126V11.3269H32.3005L24.791 7.20493C24.298 6.9343 23.702 6.93429 23.209 7.20493L15.6995 11.3269H14.3874V13.9485H15.418ZM20.299 11.3269L24 9.29544L27.701 11.3269H20.299ZM24.2637 8.17782L24 9.29544L24.2602 8.18412L24.2637 8.17782ZM19.6306 15.2593V19.6287H22.2523V15.2593H19.6306ZM25.7477 19.6287V15.2593H28.3693V19.6287H25.7477Z", fill: "black" })), kt = (e) => /* @__PURE__ */ l.createElement("svg", { fill: "none", height: 16, viewBox: "0 0 16 16", width: 16, xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ l.createElement("path", { clipRule: "evenodd", d: "m12.7071 4.70711c.3905-.39053.3905-1.02369 0-1.41422-.3905-.39052-1.0237-.39052-1.4142 0l-3.2929 3.2929-3.29289-3.2929c-.39053-.39052-1.02369-.39052-1.41422 0-.39052.39053-.39052 1.02369 0 1.41422l3.2929 3.29289-3.2929 3.2929c-.39052.3905-.39052 1.0237 0 1.4142.39053.3905 1.02369.3905 1.41422 0l3.29289-3.29289 3.2929 3.29289c.3905.3905 1.0237.3905 1.4142 0s.3905-1.0237 0-1.4142l-3.29289-3.2929z", fillRule: "evenodd" })), yt = {
  accessibility: E3,
  alertCircle: k3,
  alertInfo: y3,
  alertTriangle: j3,
  applePay: M3,
  arrowRight: N3,
  arrowUp: H3,
  centeredText: T3,
  check: z3,
  chevronDown: I3,
  chevronLeft: S3,
  chevronRight: V3,
  chevronUp: P3,
  checkCircle: R3,
  creditCard: A3,
  crown: $3,
  edit: O3,
  ellipse: B3,
  euroSign: D3,
  facebook: Z3,
  gear: F3,
  googlePay: W3,
  heart: U3,
  image: q3,
  information: K3,
  instagram: Y3,
  link: X3,
  linkedin: J3,
  leftAlignedText: G3,
  logo: Q3,
  megaphone: et,
  nestedEllipse: tt,
  pause: nt,
  payPal: rt,
  plus: ot,
  popup: it,
  question: st,
  play: ct,
  radio: at,
  rightAlignedText: lt,
  search: ut,
  sepa: dt,
  share: ht,
  sound: ft,
  speechBubble: Ct,
  spinner: mt,
  star: pt,
  stop: gt,
  trashCan: wt,
  upload: _t,
  user: vt,
  x: kt,
  video: xt,
  volume: bt,
  whatsapp: Lt,
  wireTransfer: Et
}, jt = "_icon_r529q_1", Mt = {
  icon: jt
}, Nt = {
  facebook: "#1877F2",
  instagram: "#E1306C",
  linkedin: "#0077B5"
};
function _1({
  size: e = "300",
  color: t,
  title: n,
  name: r,
  className: o,
  style: i,
  minTargetSizeInRem: a = 0,
  ...c
}) {
  const u = yt[r] ?? null;
  if (!u)
    throw new Error(`Icon ${r} does not exist`);
  const h = { fill: t && `var(--betterplace-color-${t})` || Nt[r] };
  return /* @__PURE__ */ s.jsx(
    u,
    {
      ...c,
      "aria-label": n,
      "aria-hidden": !n,
      className: b(Mt.icon, o),
      style: {
        width: `var(--betterplace-sizing-${e})`,
        height: `var(--betterplace-sizing-${e})`,
        padding: `calc((${a}rem - var(--betterplace-sizing-${e})) / 2)`,
        boxSizing: "content-box",
        ...h,
        ...i
      }
    }
  );
}
const Ht = "_accordion_tsidy_1", Tt = "_accordionItem_tsidy_6", zt = "_content_tsidy_11", Rt = "_wrapper_tsidy_15", It = "_accordionSummary_tsidy_25", St = "_accordionIcon_tsidy_41", Vt = "_open_tsidy_59", M1 = {
  accordion: Ht,
  accordionItem: Tt,
  content: zt,
  wrapper: Rt,
  accordionSummary: It,
  accordionIcon: St,
  open: Vt
}, Pt = "_popupContainer_y7ppu_1", At = "_spyElement_y7ppu_15", $t = "_nonFocusableOutline_y7ppu_21", R2 = {
  popupContainer: Pt,
  spyElement: At,
  nonFocusableOutline: $t
}, c1 = {
  TOP: "top",
  BOTTOM: "bottom",
  LEFT: "left",
  RIGHT: "right"
}, x1 = {
  LEFT: "left",
  CENTER: "center",
  RIGHT: "right",
  JUSTIFY: "justify"
}, Ot = {
  a: "link",
  area: "link",
  article: "article",
  aside: "complementary",
  button: "button",
  details: "group",
  dfn: "term",
  dialog: "dialog",
  fieldset: "group",
  figure: "figure",
  footer: "contentinfo",
  form: "form",
  h1: "heading",
  h2: "heading",
  h3: "heading",
  h4: "heading",
  h5: "heading",
  h6: "heading",
  header: "banner",
  hr: "separator",
  iframe: "document",
  img: "img",
  input: null,
  // for type purposes this value needs to be included
  li: "listitem",
  main: "main",
  menu: "list",
  menuitem: "menuitem",
  meter: "meter",
  nav: "navigation",
  ol: "list",
  option: "option",
  progress: "progressbar",
  section: "region",
  select: "listbox",
  summary: "button",
  table: "table",
  tbody: "rowgroup",
  td: "cell",
  textarea: "textbox",
  tfoot: "rowgroup",
  th: "columnheader",
  thead: "rowgroup",
  tr: "row",
  ul: "list"
}, Bt = {
  button: "button",
  checkbox: "checkbox",
  radio: "radio",
  range: "slider",
  text: "textbox",
  password: "textbox",
  email: "textbox",
  search: "searchbox",
  number: "spinbutton",
  tel: "textbox",
  url: "textbox",
  submit: "button",
  reset: "button",
  image: "button",
  file: "textbox"
}, y1 = ["a", "button", "input", "textarea", "select", "details", "area", "label"];
function Dt(e) {
  return !e || !e.trim() ? /* @__PURE__ */ new Set() : new Set(e.trim().split(/\s+/));
}
function Zt(e, t) {
  return [...Dt(e).add(t)].join(" ");
}
function Ft(e) {
  const t = e.getAttribute("role");
  if (t) return t;
  const n = e.tagName.toLowerCase();
  if (n === "input") {
    const o = e.getAttribute("type");
    return o ? Bt[o] : "textbox";
  }
  const r = Ot[n];
  return r || "button";
}
function _e(e, t = y1) {
  if (!(!e || !(e instanceof HTMLElement)))
    return e.querySelectorAll(`${t.join(",")},[tabindex]:not([tabindex="-1"])`);
}
function ve(e, t = y1) {
  if (!e) return !1;
  const n = e.getAttribute("tabindex");
  if (!n && !t.includes(e.tagName.toLowerCase()) || n && parseInt(n) < 0 || e.hasAttribute("disabled")) return !1;
  const o = window.getComputedStyle(e);
  return !(o.display === "none" || o.visibility === "hidden");
}
function d2(e, t = y1) {
  if (!e || !(e instanceof HTMLElement)) return null;
  const n = e.querySelectorAll(
    `${t.join(",")}:not([tabindex="-1"]):not([disabled]):not([inert]),[tabindex]:not([tabindex="-1"]):not([disabled]):not([inert])`
  );
  for (const r of n)
    if (ve(r, t))
      return r;
  return null;
}
function I2(e, t = y1) {
  return !e || !(e instanceof HTMLElement) ? null : ve(e, t) ? e : d2(e, t);
}
function xe(e, t, n = y1) {
  if (!t || !(t instanceof HTMLElement)) return null;
  let r = t, o = null;
  for (; (r = e(r)) && !(o = I2(r, n)); )
    ;
  return o;
}
function be(e, t = y1) {
  return xe((n) => (n == null ? void 0 : n.nextElementSibling) ?? null, e, t);
}
function Wt(e, t = y1) {
  return xe((n) => (n == null ? void 0 : n.previousElementSibling) ?? null, e, t);
}
function Le(e, t = y1) {
  if (!e || !(e instanceof HTMLElement)) return null;
  let n = e;
  for (; ; ) {
    const r = be(n, t);
    if (r) return r;
    if (n = (n == null ? void 0 : n.parentElement) ?? null, !n || n === e) return null;
  }
}
async function Ut() {
  return new Promise((e) => {
    setTimeout(() => window.requestAnimationFrame(() => e()));
  });
}
const S2 = "data-popup", H2 = "data-popup-id";
function K2(e) {
  let t = e;
  for (; t; ) {
    if (t != null && t.hasAttribute(S2)) return t;
    t = (t == null ? void 0 : t.parentElement) ?? null;
  }
  return null;
}
function qt(e, t) {
  if (!t || !e) return !1;
  const n = K2(t);
  if (!n) return !1;
  const r = n.getAttribute(S2);
  if (!r) return !1;
  if (e.getAttribute(H2) === r) return !0;
  const o = K2(e);
  return o ? !!o.querySelector(`[${H2}="${r}"]`) : !1;
}
function q1(e) {
  return e ? e.clientHeight && e.scrollHeight > e.clientHeight || e.tagName === "DIALOG" ? e.tagName === "HTML" ? window : e : q1(e.parentNode) : null;
}
const Ee = c2({
  initialised: !1,
  open: !1,
  inDOM: !1,
  setInDOM: () => {
  },
  showPopup: () => {
  },
  hidePopup: () => {
  },
  togglePopup: () => {
  },
  hasClickTrigger: !1,
  hasKeypressTrigger: !1,
  hasFocusTrigger: !1,
  hasHoverTrigger: !1
});
function K1() {
  return a2(Ee);
}
function Kt(e, t) {
  return JSON.stringify(e) === JSON.stringify(t);
}
function ke(e) {
  return (t) => t === e || t && Kt(t, e) ? t : e;
}
const K = {
  Enter: "Enter",
  Space: " ",
  Tab: "Tab",
  Escape: "Escape",
  Down: "ArrowDown",
  Up: "ArrowUp",
  Left: "ArrowLeft",
  Right: "ArrowRight",
  Home: "Home",
  End: "End"
};
function r2() {
  const e = document.getElementById("bp-portal-target");
  if (e) return e;
  const t = document.createElement("div");
  return t.id = "bp-portal-target", t.style.position = "absolute", t.setAttribute("role", "popup"), document.body.appendChild(t), t;
}
function Yt(e) {
  if (!e) return null;
  const { height: t, width: n } = e;
  return {
    height: t,
    width: n
  };
}
function Gt({ triggerRect: e, id: t, onCloseTransitionEnd: n, onPopupLeave: r, children: o }) {
  const {
    popupRef: i,
    spyRef: a,
    preferredPopupPosition: c,
    alignPopup: u,
    hasHoverTrigger: d,
    Anchor: h,
    contentClassName: m,
    contentWrapperClassName: f,
    popupOpenWrapperClassName: x,
    anchorClassName: _,
    marginInPx: v
  } = K1(), [w, C] = P(null), [L, H] = P(null), [k, M] = P(null), [S, A] = P(!1), { open: g, hidePopup: T, popupRef: O } = K1();
  V(() => {
    if (!g) return A(!1);
    const R = window.requestAnimationFrame(() => {
      A(!0);
    });
    return () => window.cancelAnimationFrame(R);
  }, [g, A]);
  const F = E(() => {
    var q;
    const R = Yt((q = i == null ? void 0 : i.current) == null ? void 0 : q.getBoundingClientRect());
    C(ke(R));
  }, [i]), W = E(() => {
    const R = q1(r2()) ?? document.body, G = (R === window ? document.body : R).getBoundingClientRect();
    H(G.width), M(G.height);
  }, []), z = E(
    (R) => {
      var G;
      if (R.key !== K.Escape) return;
      R.preventDefault();
      const q = (G = a == null ? void 0 : a.current) == null ? void 0 : G.nextElementSibling;
      q == null || q.focus(), T();
    },
    [T, a]
  );
  V(() => {
    const R = i == null ? void 0 : i.current;
    if (!R) return;
    const q = _e(R);
    return q == null || q.forEach((G, m1) => {
      G.addEventListener("keydown", z);
    }), () => {
      q == null || q.forEach((G, m1) => {
        G.removeEventListener("keydown", z);
      });
    };
  }, [o, z, i]), n2(() => {
    F(), W();
  }, [F, W]);
  const y = E(() => {
    window.requestAnimationFrame(() => {
      F(), W();
    });
  }, [F, W]), B = E(
    (R) => {
      d && r(R);
    },
    [r, d]
  ), Q = E(
    (R) => {
      var G, m1, $;
      const q = (m1 = (G = O == null ? void 0 : O.current) == null ? void 0 : G.firstElementChild) == null ? void 0 : m1.firstElementChild;
      if (R.target !== q && !(($ = i == null ? void 0 : i.current) != null && $.contains(R.relatedTarget))) {
        if (qt(q, R.relatedTarget))
          return R.preventDefault();
        r(R);
      }
    },
    [r, O, i]
  );
  V(() => (window.addEventListener("resize", y), () => {
    window.removeEventListener("resize", y);
  }), [y]);
  const e1 = i1(() => h ? 17 : 0, [h]);
  V(() => {
    if (g) return;
    const R = i == null ? void 0 : i.current;
    if (!x) return n();
    R == null || R.addEventListener("transitionend", n);
    const q = setTimeout(n, 300);
    return () => {
      clearTimeout(q), R == null || R.removeEventListener("transitionend", n);
    };
  }, [i, g, n, x]);
  const {
    x: t1,
    y: J,
    anchorOffsetX: p,
    position: N,
    width: Z
  } = i1(
    () => e4({
      triggerRect: e,
      popupSize: w,
      bodyWidth: L,
      bodyHeight: k,
      anchorSize: e1,
      preferredPopupPosition: c,
      alignPopup: u,
      originalMargin: v
    }),
    [e, w, L, k, e1, c, u, v]
  );
  return N2(
    /* @__PURE__ */ s.jsx(
      "div",
      {
        id: t,
        className: R2.popupContainer,
        ref: i,
        onPointerLeave: B,
        onBlur: Q,
        style: {
          transform: `translate3d(${t1}px, ${J}px, 0)`
        },
        children: /* @__PURE__ */ s.jsxs(
          "div",
          {
            className: b(
              f,
              x && { [x]: S }
            ),
            children: [
              h && N === c1.BOTTOM && /* @__PURE__ */ s.jsx(h, { position: N, x: p, className: _ }),
              /* @__PURE__ */ s.jsx(
                "div",
                {
                  tabIndex: -1,
                  className: m,
                  style: {
                    ...u === x1.JUSTIFY ? { minWidth: Z, overflowX: "hidden" } : {}
                  },
                  [S2]: t,
                  children: o
                }
              ),
              h && N === c1.TOP && /* @__PURE__ */ s.jsx(h, { position: N, x: p, className: _ })
            ]
          }
        )
      }
    ),
    r2()
  );
}
function Xt(e, t, n) {
  V(() => {
    var h;
    if (!(n != null && n.current)) return;
    const r = (h = n == null ? void 0 : n.current) == null ? void 0 : h.nextElementSibling;
    if (!r) return;
    n.current.setAttribute("id", "tooltip-spy");
    const o = d2(r), i = o ?? r;
    r.setAttribute(H2, e);
    const c = i.getAttribute("aria-roledescription") ?? Ft(i) ?? "button";
    i.setAttribute("role", "button"), o || (i == null || i.setAttribute("tabindex", "0"), i == null || i.classList.add(R2.nonFocusableOutline)), i.setAttribute("aria-roledescription", c);
    const u = i.getAttribute("aria-describedby");
    (u == null ? void 0 : u.includes(e)) || i.setAttribute("aria-describedby", `${Zt(u, e)} tooltip-spy`);
  }, [t, e, n]);
}
function Jt(e, t, n) {
  if (!e) return null;
  const { left: r, top: o, bottom: i, width: a } = e;
  return {
    left: r,
    top: o,
    bottom: i,
    width: a,
    offsetX: n,
    offsetY: t
  };
}
function Qt({ children: e, content: t, id: n }) {
  const {
    showPopup: r,
    hidePopup: o,
    togglePopup: i,
    open: a,
    spyRef: c,
    popupRef: u,
    hasClickTrigger: d,
    hasFocusTrigger: h,
    hasHoverTrigger: m,
    hasKeypressTrigger: f,
    setInDOM: x
  } = K1(), [_, v] = P(null), w = i1(() => !!_, [_]);
  Xt(n, e, c);
  const C = E(() => {
    var y;
    const g = (y = c == null ? void 0 : c.current) == null ? void 0 : y.nextSibling;
    let T = g == null ? void 0 : g.getBoundingClientRect();
    T != null && T.height || (T = void 0);
    let O = 0, F = 0;
    const W = q1(r2()) ?? window;
    if (W !== window) {
      const B = W;
      O = -B.getBoundingClientRect().top + B.scrollTop, F = -B.getBoundingClientRect().left + B.scrollLeft;
    }
    const z = Jt(T, O, F);
    v(ke(z)), x(!0);
  }, [x, c]), L = E(() => {
    v(null), x(!1);
  }, [x]), H = E(() => {
    w && C();
  }, [C, w]), k = E(
    (g) => {
      const T = u == null ? void 0 : u.current;
      if (g.relatedTarget instanceof Node && (T != null && T.contains(g.relatedTarget)))
        return g.preventDefault();
      o();
    },
    [o, u]
  ), M = E(
    (g) => {
      var T, O;
      if (g.relatedTarget instanceof Node && ((O = (T = c == null ? void 0 : c.current) == null ? void 0 : T.nextSibling) != null && O.contains(g.relatedTarget)))
        return g.preventDefault();
      o();
    },
    [o, c]
  ), S = E(
    (g) => {
      var O, F, W;
      const T = g.target instanceof Node;
      T && ((O = u == null ? void 0 : u.current) != null && O.contains(g.target)) || T && ((W = (F = c == null ? void 0 : c.current) == null ? void 0 : F.nextElementSibling) != null && W.contains(g.target)) || M(g);
    },
    [M, u, c]
  ), A = E(
    (g) => {
      if (g.key === K.Enter || g.key === K.Space)
        return g.preventDefault(), i();
      if (g.key === K.Escape) return o();
    },
    [o, i]
  );
  return V(() => {
    if (d)
      return document.addEventListener("pointerdown", S), () => {
        document.removeEventListener("pointerdown", S);
      };
  }, [d, S]), V(() => {
    var T;
    if (!d) return;
    const g = (T = c == null ? void 0 : c.current) == null ? void 0 : T.nextElementSibling;
    return g == null || g.addEventListener("pointerdown", i), () => {
      g == null || g.removeEventListener("pointerdown", i);
    };
  }, [d, i, c, e]), V(() => {
    var T;
    if (!m) return;
    const g = (T = c == null ? void 0 : c.current) == null ? void 0 : T.nextElementSibling;
    return g == null || g.addEventListener("mouseover", r), g == null || g.addEventListener("mouseleave", k), () => {
      g == null || g.removeEventListener("mouseover", r), g == null || g.removeEventListener("mouseleave", k);
    };
  }, [m, k, r, c, e]), V(() => {
    var T;
    const g = (T = c == null ? void 0 : c.current) == null ? void 0 : T.nextElementSibling;
    return g == null || g.addEventListener("focusout", k), () => g == null ? void 0 : g.removeEventListener("focusout", k);
  }, [k, c, e]), V(() => {
    var T;
    if (!h) return;
    const g = (T = c == null ? void 0 : c.current) == null ? void 0 : T.nextElementSibling;
    return g == null || g.addEventListener("focus", r), g == null || g.addEventListener("focusin", r), () => {
      g == null || g.removeEventListener("focus", r), g == null || g.removeEventListener("focusin", r);
    };
  }, [h, r, e, c]), V(() => {
    var T;
    if (!f) return;
    const g = (T = c == null ? void 0 : c.current) == null ? void 0 : T.nextElementSibling;
    return g == null || g.addEventListener("keydown", A), () => {
      g == null || g.removeEventListener("keydown", A);
    };
  }, [f, A, c, e]), V(() => {
    if (!a) return;
    window.addEventListener("resize", H, { passive: !0 });
    const g = q1(r2()) ?? window;
    return g.addEventListener("scroll", H, { passive: !0 }), () => {
      window.removeEventListener("resize", H), g.removeEventListener("scroll", H);
    };
  }, [a, H]), n2(() => {
    H();
  }, [e, H]), V(() => {
    a && C();
  }, [a, C]), /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
    /* @__PURE__ */ s.jsx("div", { ref: c, className: R2.spyElement }),
    e,
    w && /* @__PURE__ */ s.jsx(
      Gt,
      {
        triggerRect: _,
        onCloseTransitionEnd: L,
        id: n,
        onPopupLeave: M,
        children: t
      }
    )
  ] });
}
function ye({
  children: e,
  content: t,
  id: n,
  triggerEvents: r = ["hover", "focus"],
  inactive: o,
  ...i
}) {
  const [a, c] = P(!1), [u, d] = P(!1), [h, m] = P(!1), f = I(null), x = I(null), _ = K1(), v = v1(), w = i1(() => n ?? v, [n]), C = i1(() => r == null ? void 0 : r.includes("click"), [r]), L = i1(() => r == null ? void 0 : r.includes("focus"), [r]), H = i1(() => r == null ? void 0 : r.includes("hover"), [r]), k = i1(() => r == null ? void 0 : r.includes("keypress"), [r]), M = E(() => {
    d(!1);
  }, []), S = E(() => {
    d(!0);
  }, []), A = E(() => {
    d((g) => !g);
  }, []);
  return V(() => (c(!0), () => {
    c(!1);
  }), []), !a || o ? e : /* @__PURE__ */ s.jsx(
    Ee.Provider,
    {
      value: {
        open: u,
        showPopup: S,
        hidePopup: M,
        togglePopup: A,
        spyRef: x,
        popupRef: f,
        hasClickTrigger: C,
        hasHoverTrigger: H,
        hasFocusTrigger: L,
        hasKeypressTrigger: k,
        inDOM: h,
        setInDOM: m,
        initialised: !0,
        parentContext: _,
        ...i
      },
      children: /* @__PURE__ */ s.jsx(Qt, { content: t, id: w, children: e })
    }
  );
}
function e4({
  triggerRect: e,
  popupSize: t,
  bodyWidth: n,
  bodyHeight: r,
  originalMargin: o = 20,
  anchorSize: i = 17,
  preferredPopupPosition: a = c1.TOP,
  alignPopup: c = x1.CENTER
}) {
  let u = 0, d = 0, h = 0, m = 0, f = a, x = (t == null ? void 0 : t.width) ?? 0;
  if (!e || !t || !n || !r)
    return { x: u, y: d, anchorOffsetX: m, position: f, width: x };
  let _ = 0, v = t.width / 2;
  const w = e.width / 2;
  c === x1.CENTER ? u = e.left + e.offsetX - v + w : c === x1.LEFT || c === x1.JUSTIFY ? (u = e.left + e.offsetX, c === x1.JUSTIFY && (x = e.width, v = w)) : c === x1.RIGHT && (u = e.left + e.offsetX + e.width - x);
  const C = t.width > n ? 0 : Math.min(o, (n - x) / 2);
  if (_ = u, h = u + t.width, u < C ? u = C : h > n - C && (u -= h - (n - C)), i) {
    m = _ - u + v - i;
    const L = m + 2 * i - x;
    if (L > 0) {
      const H = Math.min(L, C);
      u += H, m -= H;
    }
  }
  return a === c1.TOP ? (d = e.top + e.offsetY - t.height, d < Math.abs(e.offsetY) && (f = c1.BOTTOM, d = e.bottom)) : (d = e.bottom + e.offsetY, d + t.height > r + e.offsetY && (f = c1.TOP, d = e.top + e.offsetY - t.height)), { x: u, y: d, anchorOffsetX: m, position: f, width: x };
}
const je = c2({
  activeKey: void 0,
  prevKey: void 0,
  onTransitionFinished: (e) => {
  },
  scrollOnOpen: !0
});
function t4() {
  return a2(je);
}
function n4({
  label: e,
  id: t,
  className: n,
  children: r,
  onClick: o
}) {
  const { activeKey: i, onTransitionFinished: a, prevKey: c, scrollOnOpen: u } = t4(), [d, h] = P(i === t || c === t), m = I(null), f = I(null), x = E(
    (v) => {
      v.preventDefault(), o(t);
    },
    [o, t]
  ), _ = E(
    (v) => {
      v.propertyName === "opacity" && v.target === m.current && i === t && (a(t), u && window.requestAnimationFrame(() => {
        if (!f.current) return;
        const w = q1(f.current);
        if (!w) return;
        const { top: C } = f.current.getBoundingClientRect(), L = w === window ? 0 : w.offsetTop;
        w.scrollBy({ behavior: "smooth", top: C - L });
      }));
    },
    [i, t, a, u]
  );
  return V(() => {
    if (i === c) return;
    const v = setTimeout(() => h(i === t), 1);
    return () => clearTimeout(v);
  }, [t, i, c]), // eslint-disable-next-line jsx-a11y/role-supports-aria-props
  /* @__PURE__ */ s.jsxs(
    "details",
    {
      open: !0,
      id: t,
      "aria-expanded": i === t ? "true" : "false",
      className: b(M1.accordionItem, { [M1.open]: d }, n),
      ref: f,
      children: [
        /* @__PURE__ */ s.jsxs("summary", { onClick: x, className: M1.accordionSummary, children: [
          e,
          /* @__PURE__ */ s.jsx(_1, { name: "chevronDown", className: M1.accordionIcon, size: "400" })
        ] }),
        /* @__PURE__ */ s.jsx("div", { className: M1.wrapper, onTransitionEnd: _, ref: m, children: /* @__PURE__ */ s.jsx("div", { className: M1.content, inert: i !== t, children: r }) })
      ]
    }
  );
}
function r4({
  defaultKey: e,
  children: t,
  activeKey: n,
  onTransitionFinished: r,
  className: o,
  space: i = "300",
  animationSpeedInMs: a = 500,
  scrollOnOpen: c = !0
}) {
  const [u, d] = P(void 0), [h, m] = P(n ?? e), f = E(
    (x) => {
      r == null || r(x, u), d(x);
    },
    [r, u]
  );
  return V(() => {
    typeof n == "string" && (m(n), d(h));
  }, [n]), /* @__PURE__ */ s.jsx(
    l1,
    {
      className: b(M1.accordion, o),
      space: i,
      style: {
        "--animation-speed": `${a}ms`,
        "--space": `var(--betterplace-spacing-${i})`
      },
      children: /* @__PURE__ */ s.jsx(je.Provider, { value: { activeKey: h, onTransitionFinished: f, prevKey: u, scrollOnOpen: c }, children: t })
    }
  );
}
const o4 = u2(we), i4 = u2(T0);
function s4() {
  const e = window.location.hostname;
  if (!e) return "";
  const t = e.split(".");
  return t.length <= 2 ? e : t.slice(1).join(".");
}
const c4 = () => {
  const e = s4(), t = new Date(2099, 1, 1).getTime();
  document.cookie = `betterplace-tracking-accepted=edit; path=/; max-age=${t}; domain=.${e}`;
};
function a4(e) {
  if (!e.length) return [];
  const t = e.length > 1 ? e.sort(({ column: r }, { column: o }) => r - o) : e;
  let n = 0;
  return t.map((r) => {
    n = r.column ?? n;
    const o = {
      ...r,
      column: r.column ?? n
    };
    return n++, o;
  });
}
function l4(e) {
  const t = e.reduce(
    (n, r) => (n[r.column] = [...n[r.column] ?? [], r], n),
    {}
  );
  return Object.values(t);
}
function V2({ ...e }) {
  const { className: t } = z2({
    kind: "secondary",
    size: "small",
    className: b(e.className, r1.footerLink)
  });
  return /* @__PURE__ */ s.jsx(E1, { ...e, doNotOpenInNewTab: !0, className: t });
}
function Me({
  cookieSettingsLink: e,
  Link: t = C1,
  section: n
}) {
  return n.title !== e.section ? null : /* @__PURE__ */ s.jsx(V2, { Link: t, onClick: c4, className: r1.cookieSettingsLink, children: e.label }, "cookie");
}
function u4({
  children: e,
  Link: t = C1,
  links: n,
  mobile: r
}) {
  return r || /* @__PURE__ */ s.jsxs(l1, { space: "200", className: r1.accordionContent, children: [
    n.map((o, i) => /* @__PURE__ */ s.jsx(V2, { Link: t, ...o }, i)),
    e
  ] });
}
function d4({
  links: e,
  Link: t = C1,
  desktop: n,
  children: r
}) {
  return n || /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
    e.map((o, i) => /* @__PURE__ */ s.jsx(V2, { Link: t, ...o }, i)),
    r
  ] });
}
function h4({ text: e, Link: t = C1 }) {
  const n = l4(a4(e.sections));
  return /* @__PURE__ */ s.jsx("nav", { className: r1.wideOnly, children: /* @__PURE__ */ s.jsx(U1, { className: r1.grid, flex: !0, space: "300", justify: "space-between", wrap: !0, children: n.map((r, o) => /* @__PURE__ */ s.jsx(l1, { className: r1.item, space: "300", children: r.map((i) => /* @__PURE__ */ s.jsxs(l1, { children: [
    /* @__PURE__ */ s.jsx("p", { children: /* @__PURE__ */ s.jsx("strong", { children: i.title }) }, "title"),
    /* @__PURE__ */ s.jsx(d4, { links: i.links, desktop: i.desktop, Link: t, children: /* @__PURE__ */ s.jsx(Me, { cookieSettingsLink: e.cookieSettingsLink, section: i }, "cookie") })
  ] }, i.title)) }, o)) }) });
}
function f4({ text: e, Link: t = C1 }) {
  const n = "", [r, o] = P(n);
  return /* @__PURE__ */ s.jsx("nav", { className: r1.mobileOnly, children: /* @__PURE__ */ s.jsx(
    r4,
    {
      defaultKey: n,
      activeKey: r,
      scrollOnOpen: !1,
      space: "none",
      animationSpeedInMs: 300,
      children: e.sections.map((i) => /* @__PURE__ */ s.jsx(
        n4,
        {
          id: i.title,
          onClick: (a) => o((c) => a === c ? "" : a),
          label: /* @__PURE__ */ s.jsx("span", { className: r1.accordionLabel, children: i.title }),
          children: /* @__PURE__ */ s.jsx(u4, { links: i.links, mobile: i.mobile, Link: t, children: /* @__PURE__ */ s.jsx(Me, { cookieSettingsLink: e.cookieSettingsLink, section: i }, "cookie") })
        },
        i.title
      ))
    }
  ) });
}
function T9({
  children: e,
  href: t,
  className: n,
  Link: r = C1
}) {
  const [o, i] = P(!0), [a, c] = P(!1);
  return V(() => {
    i(!t), c(!e);
  }, [t, e]), a ? null : /* @__PURE__ */ s.jsx(r, { disabled: o, href: t, className: b(r1.localeSwitchLink, n), children: e });
}
function z9({ text: e, Link: t = C1, Image: n = l2, localeSwitchLink: r }) {
  return /* @__PURE__ */ s.jsxs($0, { as: "footer", className: b("bp-shared", r1.footer), centeredChildren: !0, children: [
    /* @__PURE__ */ s.jsx(i3, { label: e.taxReceiptHint.label, href: e.taxReceiptHint.href, Link: t, children: e.taxReceiptHint.children }),
    /* @__PURE__ */ s.jsxs(l1, { className: r1.footerContent, flex: !0, children: [
      /* @__PURE__ */ s.jsx(h4, { text: e, Link: t }),
      /* @__PURE__ */ s.jsx(f4, { text: e, Link: t }),
      /* @__PURE__ */ s.jsx(n, { src: o4, alt: "", width: 190, className: r1.logo }),
      /* @__PURE__ */ s.jsxs(U1, { alignment: "intrinsic", justify: "space-between", className: r1.textContent, children: [
        /* @__PURE__ */ s.jsxs(l1, { className: r1.organizationInfo, flex: !0, children: [
          /* @__PURE__ */ s.jsx("p", { children: /* @__PURE__ */ s.jsx("strong", { children: e.organizationInfo }) }),
          /* @__PURE__ */ s.jsx("p", { className: r1.organizationInfoDetails, children: e.organizationInfoDetails })
        ] }),
        /* @__PURE__ */ s.jsxs(l1, { className: r1.socialLinks, children: [
          /* @__PURE__ */ s.jsxs(U1, { justify: "space-between", align: "center", children: [
            /* @__PURE__ */ s.jsxs(U1, { space: "200", align: "center", children: [
              /* @__PURE__ */ s.jsxs(
                E1,
                {
                  Link: t,
                  href: e.facebookLink.href,
                  title: e.facebookLink.label,
                  external: !0,
                  className: r1.socialLink,
                  children: [
                    /* @__PURE__ */ s.jsx(_1, { name: "facebook", size: "400", "aria-hidden": "true" }),
                    /* @__PURE__ */ s.jsx("span", { className: "sr-only", children: e.facebookLink.label })
                  ]
                },
                "facebook"
              ),
              /* @__PURE__ */ s.jsxs(
                E1,
                {
                  Link: t,
                  href: e.instagramLink.href,
                  title: e.instagramLink.label,
                  external: !0,
                  className: r1.socialLink,
                  children: [
                    /* @__PURE__ */ s.jsx(_1, { name: "instagram", size: "400", "aria-hidden": "true" }),
                    /* @__PURE__ */ s.jsx("span", { className: "sr-only", children: e.instagramLink.label })
                  ]
                },
                "instagram"
              ),
              /* @__PURE__ */ s.jsxs(
                E1,
                {
                  Link: t,
                  href: e.linkedinLink.href,
                  title: e.linkedinLink.label,
                  external: !0,
                  className: r1.socialLink,
                  children: [
                    /* @__PURE__ */ s.jsx(_1, { name: "linkedin", size: "400", "aria-hidden": "true" }),
                    /* @__PURE__ */ s.jsx("span", { className: "sr-only", children: e.linkedinLink.label })
                  ]
                },
                "linkedin"
              )
            ] }),
            r
          ] }),
          /* @__PURE__ */ s.jsx(
            E1,
            {
              Link: t,
              href: e.transparentCivilSocietyLink.href,
              className: r1.transparentCivilSocietyLink,
              children: /* @__PURE__ */ s.jsx(n, { src: i4, alt: e.transparentCivilSocietyLink.label, width: 240 })
            }
          )
        ] })
      ] })
    ] })
  ] });
}
const C4 = "_form_1i53q_1", m4 = "_inputContainer_1i53q_7", p4 = "_resetButton_1i53q_17", g4 = "_open_1i53q_29", w4 = "_input_1i53q_7", _4 = "_searchButton_1i53q_56", I1 = {
  form: C4,
  inputContainer: m4,
  resetButton: p4,
  open: g4,
  input: w4,
  searchButton: _4
}, v4 = "_iconButton_t9ddf_1", x4 = "_iconOnly_t9ddf_9", b4 = "_iconSlot_t9ddf_14", L4 = "_hasIcon_t9ddf_24", o2 = {
  iconButton: v4,
  iconOnly: x4,
  iconSlot: b4,
  hasIcon: L4
}, E4 = "_button_1k55h_1", k4 = "_ghost_1k55h_142", y4 = "_idle_1k55h_167", j4 = "_busy_1k55h_271", M4 = "_srOnly_1k55h_423", N1 = {
  button: E4,
  "kind-primary": "_kind-primary_1k55h_17",
  "size-large": "_size-large_1k55h_29",
  "size-default": "_size-default_1k55h_33",
  "size-small": "_size-small_1k55h_37",
  "size-input": "_size-input_1k55h_41",
  "kind-secondary": "_kind-secondary_1k55h_58",
  "kind-secondary-danger": "_kind-secondary-danger_1k55h_100",
  ghost: k4,
  idle: y4,
  "kind-danger": "_kind-danger_1k55h_177",
  "kind-plain": "_kind-plain_1k55h_222",
  busy: j4,
  "kind-plain-danger": "_kind-plain-danger_1k55h_318",
  srOnly: M4
};
function N4(e) {
  return N1[`size-${e}`];
}
function H4(e, t) {
  return [
    {
      [N1.ghost]: t
    },
    N1[`kind-${e}`]
  ];
}
function T4({
  children: e,
  kind: t = "primary",
  size: n = "default",
  as: r = "button",
  className: o,
  ghost: i,
  busy: a,
  id: c,
  "aria-disabled": u,
  "aria-describedby": d,
  disabledReason: h,
  disabled_: m,
  disabled: f,
  fullWidth: x,
  ..._
}) {
  const w = f || m || u || a, C = w && h ? `${c}-disabled-reason` : void 0, L = d ?? C, H = b(
    N1.button,
    N4(n),
    o,
    ...H4(t, i),
    {
      [N1.busy]: a,
      [N1.idle]: !a,
      fullWidth: x && x !== "mobile-only",
      fullWidthOnMobile: x && x === "mobile-only"
    }
  ), k = /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
    C && /* @__PURE__ */ s.jsx("span", { id: C, className: N1.srOnly, children: h }),
    e
  ] });
  return {
    className: H,
    children: k,
    "aria-disabled": w,
    "aria-describedby": L,
    "aria-busy": a,
    disabled: m,
    id: c,
    ..._
  };
}
const Ne = U(function({ id: t, ...n }, r) {
  const o = v1(), i = t || o, { children: a, ...c } = T4({ ...n, id: i });
  return n.as === "a" ? /* @__PURE__ */ s.jsx("a", { ref: r, ...c, children: a }) : /* @__PURE__ */ s.jsx("button", { ref: r, ...c, children: a });
}), z4 = {
  small: "200",
  default: "300",
  input: "300",
  large: "400"
};
function Y2({ enabled: e, ...t }) {
  const n = `var(--betterplace-sizing-${t.size})`;
  return /* @__PURE__ */ s.jsx(
    "span",
    {
      className: b(o2.iconSlot, { [o2.hasIcon]: e }),
      style: { "--icon-size": n, width: n },
      children: e && /* @__PURE__ */ s.jsx(_1, { ...t })
    }
  );
}
function R4({
  children: e,
  size: t = "default",
  className: n,
  iconName: r,
  iconPosition: o = "left",
  iconProps: i = {},
  ...a
}) {
  const c = b(o2.iconButton, {
    [n]: n,
    [o2.iconOnly]: !e && !!r
  }), u = !!r, d = u && o === "right", h = u && o === "left", m = i.size ?? z4[t], f = /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
    /* @__PURE__ */ s.jsx(Y2, { ...i, name: r, size: m, enabled: h }),
    e,
    /* @__PURE__ */ s.jsx(Y2, { ...i, name: r, size: m, enabled: d })
  ] });
  return { ...a, children: f, className: c, size: t };
}
const I4 = U(function(t, n) {
  const { children: r, ...o } = R4(t);
  return /* @__PURE__ */ s.jsx(Ne, { ref: n, ...o, children: r });
}), H1 = U(function({
  onKeyDown: t,
  onKeyUp: n,
  onKeyDownCapture: r,
  onKeyUpCapture: o,
  onClick: i,
  ...a
}, c) {
  const { disabled: u } = a, d = u ? s1 : t, h = u ? s1 : n, m = u ? s1 : o, f = u ? s1 : i;
  return /* @__PURE__ */ s.jsx(
    I4,
    {
      ...a,
      onClick: f,
      onChange: d,
      onKeyUp: h,
      onKeyUpCapture: m,
      ref: c
    }
  );
});
function S4() {
  const [e, t] = P(!1);
  return V(() => {
    t(!0);
  }, []), e;
}
function V4({ text: { url: e, label: t, placeholder: n }, onShowSearch: r, onHideSearch: o, open: i, className: a }) {
  const c = I(null), u = I(null), d = S4();
  V(() => {
    !i || !u.current || u.current.focus();
  }, [i]);
  const h = E(
    (_) => {
      if (_.key === K.Enter || _.key === K.Space || _.key === K.Space) return o == null ? void 0 : o();
    },
    [o]
  ), m = E(() => {
    o == null || o();
  }, [o]), f = E(
    (_) => {
      _.key === K.Escape && (o == null || o());
    },
    [o]
  ), x = E(
    (_) => {
      var v;
      d && (i || (r == null || r(), _.preventDefault()), (v = u.current) != null && v.value || _.preventDefault());
    },
    [d, r, i]
  );
  return /* @__PURE__ */ s.jsxs("form", { action: e, method: "POST", ref: c, className: b(I1.form, a), children: [
    /* @__PURE__ */ s.jsxs("div", { className: b(I1.inputContainer, { [I1.open]: i }), children: [
      /* @__PURE__ */ s.jsx(
        "input",
        {
          onKeyUp: f,
          name: "query",
          placeholder: n,
          "aria-label": n,
          ref: u,
          id: "header-search-input",
          className: I1.input,
          tabIndex: i ? 0 : -1
        }
      ),
      /* @__PURE__ */ s.jsx(
        H1,
        {
          type: "reset",
          iconName: "x",
          onClick: m,
          onKeyUp: h,
          className: I1.resetButton,
          tabIndex: i ? 0 : -1,
          kind: "plain",
          "aria-label": "Reset"
        }
      )
    ] }),
    /* @__PURE__ */ s.jsx(
      H1,
      {
        size: "large",
        type: "submit",
        iconName: "search",
        disabled_: !d,
        onClick: x,
        className: I1.searchButton,
        title: t,
        children: /* @__PURE__ */ s.jsx("span", { className: "sr-only", children: t })
      }
    )
  ] });
}
const P4 = "_navigationLink_nb818_1", A4 = "_headerLink_nb818_19", Y1 = {
  navigationLink: P4,
  headerLink: A4
}, $4 = "_links_5flc4_1", O4 = "_linkItem_5flc4_12", B4 = "_search_5flc4_35", D4 = "_searchOpen_5flc4_46", D1 = {
  links: $4,
  linkItem: O4,
  search: B4,
  searchOpen: D4
};
function R9({
  Link: e = C1,
  Image: t = l2,
  children: n,
  text: { links: r, searchLabel: o, searchPlaceholder: i, searchUrl: a, ...c }
}) {
  const [u, d] = P(!1), h = E(() => d(!0), []), m = E(() => d(!1), []);
  return /* @__PURE__ */ s.jsxs(
    H0,
    {
      Link: e,
      Image: t,
      text: c,
      hideClaim: u,
      className: b({ [D1.searchOpen]: u, [D1.searchClosed]: !u }),
      children: [
        /* @__PURE__ */ s.jsx("ul", { className: D1.links, children: r.map((f, x) => /* @__PURE__ */ s.jsx("li", { className: D1.linkItem, children: /* @__PURE__ */ s.jsx(
          E1,
          {
            Link: e,
            "data-axe-expect": "color-contrast",
            className: b(Y1.navigationLink, Y1.headerLink),
            ...f
          }
        ) }, x)) }),
        n,
        /* @__PURE__ */ s.jsx(
          V4,
          {
            open: u,
            text: { placeholder: i, label: o, url: a },
            onShowSearch: h,
            onHideSearch: m,
            className: D1.search
          }
        )
      ]
    }
  );
}
const Z4 = "_tooltipArrow_1nc0z_1", F4 = "_bottomTooltipArrow_1nc0z_33", W4 = "_topTooltipArrow_1nc0z_38", x2 = {
  tooltipArrow: Z4,
  bottomTooltipArrow: F4,
  topTooltipArrow: W4
};
function He({ x: e, position: t, className: n }) {
  return /* @__PURE__ */ s.jsx(
    "div",
    {
      className: b(x2.tooltipArrow, n, {
        [x2.bottomTooltipArrow]: t === c1.BOTTOM,
        [x2.topTooltipArrow]: t === c1.TOP
      }),
      style: { transform: `translateX(${e}px) ${t === c1.BOTTOM ? " rotate(180deg)" : ""}` }
    }
  );
}
const U4 = "data:image/svg+xml,%3csvg%20height='66'%20viewBox='0%200%2066%2066'%20width='66'%20xmlns='http://www.w3.org/2000/svg'%3e%3ccircle%20cx='33'%20cy='33'%20fill='%239ecb09'%20r='33'/%3e%3cg%20fill='%23fff'%3e%3ccircle%20cx='33.22'%20cy='19.721'%20r='11.391'/%3e%3cpath%20d='m-173.769%20496.644a21.27%2021.27%200%200%200%20.108-2.145%2020.981%2020.981%200%200%200%20-12.08-19c-2.7-1.267-5.941-.19-9.122-.19-3.011%200-5.65-1.151-8.239-.009a20.984%2020.984%200%200%200%20-12.517%2019.2%2021.2%2021.2%200%200%200%20.136%202.4s8.568%207.864%2020.619%207.864c12.499.002%2021.095-8.12%2021.095-8.12z'%20transform='translate(227.86%20-441.616)'/%3e%3c/g%3e%3c/svg%3e", q4 = "_link_p694b_1", K4 = "_active_p694b_18", Y4 = "_image_p694b_22", G4 = "_login_p694b_38", X4 = "_label_p694b_52", J4 = "_caret_p694b_74", Q4 = "_trigger_p694b_80", en = "_loginLink_p694b_117", tn = "_dropdownMenu_p694b_123", nn = "_icon_p694b_132", rn = "_arrow_p694b_138", o1 = {
  link: q4,
  active: K4,
  image: Y4,
  login: G4,
  label: X4,
  caret: J4,
  trigger: Q4,
  loginLink: en,
  dropdownMenu: tn,
  icon: nn,
  arrow: rn
};
function G2(e, t = !1) {
  if (typeof e == "string") return !1;
  const n = e.active === "active";
  if (!t || !e.href) return n;
  let r = e.href;
  try {
    r = new URL(e.href).pathname;
  } catch {
  }
  return r === window.location.pathname || n;
}
function on(e) {
  const [t, n] = P(G2(e, !1));
  return V(() => {
    n(G2(e, !0));
  }, [e]), t;
}
const sn = "_selectContainer_3pybv_1", cn = "_select_3pybv_1", X2 = {
  selectContainer: sn,
  select: cn
}, an = "_dropdownContent_1n9sv_1", ln = "_scaleTransition_1n9sv_26", un = "_scaleTransitionOpen_1n9sv_34", dn = "_dropdownMenu_1n9sv_39", hn = "_dropdownMenuSeparator_1n9sv_50", fn = "_dropdownMenuItem_1n9sv_59", A1 = {
  dropdownContent: an,
  scaleTransition: ln,
  scaleTransitionOpen: un,
  dropdownMenu: dn,
  dropdownMenuSeparator: hn,
  dropdownMenuItem: fn
}, Cn = "_label_tdq75_1", mn = "_required_tdq75_8", pn = "_description_tdq75_12", gn = "_error_tdq75_19", wn = "_warning_tdq75_27", _n = "_hint_tdq75_57", S1 = {
  label: Cn,
  required: mn,
  description: pn,
  error: gn,
  warning: wn,
  hint: _n
}, vn = ["click", "keypress"];
function xn({ children: e, className: t }) {
  return /* @__PURE__ */ s.jsx("ul", { className: b(A1.dropdownMenu, t), children: e });
}
function bn({
  children: e,
  style: t,
  className: n
}) {
  const r = I(null), { preferredPopupPosition: o, hidePopup: i, parentContext: a, spyRef: c } = h2(), u = E(
    (d) => {
      var f, x;
      const h = a && o, m = h && Te[h].close;
      if (d.key === K.Down || d.key === K.Up) {
        d.preventDefault();
        const _ = d.key === K.Up ? Wt(r.current) : be(r.current);
        _ == null || _.focus();
        return;
      }
      d.key === m && (d.preventDefault(), (x = I2((f = c == null ? void 0 : c.current) == null ? void 0 : f.nextElementSibling)) == null || x.focus(), i()), d.key === K.Enter && d.target instanceof HTMLElement && "click" in d.target && d.target.click();
    },
    [i, a, o, c]
  );
  return V(() => {
    const d = d2(r.current);
    if (d)
      return d.addEventListener("keydown", u), d.addEventListener("click", i), () => {
        d.removeEventListener("keydown", u), d.removeEventListener("click", i);
      };
  }, [i, u]), /* @__PURE__ */ s.jsx("li", { ref: r, style: t, className: b(A1.dropdownMenuItem, n), children: e });
}
function Ln() {
  return /* @__PURE__ */ s.jsx("li", { className: A1.dropdownMenuSeparator });
}
const Te = {
  [c1.BOTTOM]: { open: K.Down, close: K.Down },
  [c1.TOP]: { open: K.Up, close: K.Down },
  [c1.RIGHT]: { open: K.Right, close: K.Left },
  [c1.LEFT]: { open: K.Left, close: K.Right }
};
function En({ children: e }) {
  const { spyRef: t, popupRef: n, showPopup: r, preferredPopupPosition: o } = h2(), i = E(
    (a) => {
      const c = o ?? c1.BOTTOM, u = Te[c].open;
      a.key === u && (a.preventDefault(), r(), Ut().then(() => {
        var h;
        let d = d2(n == null ? void 0 : n.current);
        if (d) {
          d.focus();
          return;
        }
        a.key === K.Tab && (d = Le((h = t == null ? void 0 : t.current) == null ? void 0 : h.nextElementSibling), d == null || d.focus());
      }));
    },
    [n, o, r, t]
  );
  return V(() => {
    var c;
    const a = (c = t == null ? void 0 : t.current) == null ? void 0 : c.nextElementSibling;
    if (a)
      return a.addEventListener("keydown", i), () => a.removeEventListener("keydown", i);
  }, [i, t]), e;
}
function kn({ children: e }) {
  const { spyRef: t, popupRef: n, hidePopup: r, open: o } = h2(), i = E(
    (c) => {
      var u, d;
      c.key !== K.Tab || !c.shiftKey || (c.preventDefault(), (d = I2((u = t == null ? void 0 : t.current) == null ? void 0 : u.nextElementSibling)) == null || d.focus(), r());
    },
    [t, r]
  ), a = E(
    (c) => {
      var d;
      if (c.key !== K.Tab || c.shiftKey) return;
      c.preventDefault();
      const u = Le((d = t == null ? void 0 : t.current) == null ? void 0 : d.nextElementSibling);
      u == null || u.focus();
    },
    [t]
  );
  return V(() => {
    const c = n == null ? void 0 : n.current;
    if (!c) return;
    const u = _e(c);
    if (!u || !u.length) return;
    const d = u.item(0), h = u.item(u.length - 1);
    return d.addEventListener("keydown", i), h.addEventListener("keydown", a), () => {
      d.removeEventListener("keydown", i), h.removeEventListener("keydown", a);
    };
  }, [i, a, t, n, e, o]), e;
}
function yn({
  trigger: e,
  children: t,
  className: n,
  alignContent: r = x1.JUSTIFY,
  wrapperClassName: o,
  anchorClassName: i,
  preferredPopupPosition: a,
  marginInPx: c,
  Anchor: u
}) {
  const { parentContext: d } = h2(), h = a ?? (d ? d.preferredPopupPosition ?? c1.RIGHT : c1.BOTTOM);
  return /* @__PURE__ */ s.jsx(
    ye,
    {
      content: /* @__PURE__ */ s.jsx(kn, { children: t }),
      contentClassName: b(A1.dropdownContent, n),
      contentWrapperClassName: b(A1.scaleTransition, o),
      popupOpenWrapperClassName: A1.scaleTransitionOpen,
      triggerEvents: vn,
      preferredPopupPosition: h,
      alignPopup: r,
      anchorClassName: i,
      Anchor: u,
      marginInPx: c,
      children: /* @__PURE__ */ s.jsx(En, { children: e })
    }
  );
}
function h2() {
  const {
    showPopup: e,
    hidePopup: t,
    togglePopup: n,
    spyRef: r,
    popupRef: o,
    inDOM: i,
    parentContext: a,
    alignPopup: c,
    preferredPopupPosition: u
  } = K1(), d = a && a.initialised ? a : void 0;
  return {
    open: i,
    showPopup: e,
    hidePopup: t,
    togglePopup: n,
    spyRef: r,
    popupRef: o,
    parentContext: d,
    alignPopup: c,
    preferredPopupPosition: u
  };
}
const jn = u2(U4);
function Mn({
  link: e,
  Link: t,
  shouldSetActiveClass: n = !1,
  MenuItemComponent: r
}) {
  const o = on(e);
  return e === "separator" ? /* @__PURE__ */ s.jsx(Ln, {}) : /* @__PURE__ */ s.jsx(r, { children: /* @__PURE__ */ s.jsx(
    t,
    {
      "data-axe-expect": "color-contrast",
      className: b(o1.link, { [o1.active]: n && o }),
      href: e.href,
      children: e.name
    }
  ) });
}
function I9({
  text: { avatar: e = jn, name: t, links: n, myProfile: r },
  Link: o = C1,
  Image: i = l2
}) {
  return /* @__PURE__ */ s.jsx(
    yn,
    {
      wrapperClassName: o1.dropdownMenu,
      Anchor: He,
      marginInPx: 5,
      anchorClassName: o1.arrow,
      alignContent: x1.RIGHT,
      trigger: /* @__PURE__ */ s.jsxs(
        "button",
        {
          "data-axe-expect": "aria-valid-attr-value",
          className: b(o1.trigger, o1.login, Y1.navigationLink),
          id: "header-login-dropdown-toggle",
          children: [
            /* @__PURE__ */ s.jsx(i, { className: o1.image, height: 36, width: 36, src: e, alt: `${t} - Avatar` }),
            /* @__PURE__ */ s.jsx("span", { className: o1.label, children: r }),
            /* @__PURE__ */ s.jsx(_1, { name: "chevronDown", size: "400", color: "fg-content-primary", className: o1.caret })
          ]
        }
      ),
      children: /* @__PURE__ */ s.jsx(xn, { children: n.map((a, c) => /* @__PURE__ */ s.jsx(Mn, { link: a, Link: o, MenuItemComponent: bn }, c)) })
    }
  );
}
const Nn = "_container_1empx_1", J2 = {
  container: Nn,
  "size-small": "_size-small_1empx_8"
}, $1 = U(function({ as: t = "div", className: n, children: r, size: o, ...i }, a) {
  return /* @__PURE__ */ s.jsx(
    t,
    {
      ...i,
      className: b(J2.container, n, J2[`size-${o}`]),
      ref: a,
      children: r
    }
  );
}), Hn = "_hideSteps_fdmq0_1", Tn = {
  hideSteps: Hn
}, P2 = function({
  label: t,
  name: n,
  description: r,
  error: o,
  warning: i,
  id: a,
  required: c,
  children: u,
  invisibleLabel: d,
  errorDisplay: h,
  className: m,
  hint: f,
  fullWidth: x
}) {
  return /* @__PURE__ */ s.jsxs(
    "div",
    {
      className: b(
        {
          fullWidth: x && x !== "mobile-only",
          fullWidthOnMobile: x && x === "mobile-only"
        },
        m
      ),
      children: [
        t && /* @__PURE__ */ s.jsxs("label", { htmlFor: a || n, className: b(S1.label, d && "sr-only"), children: [
          t,
          c && /* @__PURE__ */ s.jsx("span", { "aria-hidden": !0, className: S1.required, children: "*" }),
          f ? /* @__PURE__ */ s.jsx("div", { className: b(S1.hint), id: `${a}-hint`, children: f }) : null
        ] }),
        r && /* @__PURE__ */ s.jsx("p", { id: `${n}-description`, className: S1.description, children: r }),
        u,
        o && h === "all" && /* @__PURE__ */ s.jsx("p", { id: `${n}-error`, className: S1.error, "aria-live": "polite", children: o }),
        i && h === "all" && /* @__PURE__ */ s.jsx("p", { id: `${n}-warning`, className: S1.warning, "aria-live": "polite", children: i })
      ]
    }
  );
}, zn = "_input_14n0x_1", Rn = "_inputLarge_14n0x_34", In = "_inputContainer_14n0x_55", Sn = "_hasSuffix_14n0x_64", Z1 = {
  input: zn,
  "input--error": "_input--error_14n0x_30",
  inputLarge: Rn,
  inputContainer: In,
  hasSuffix: Sn
}, A2 = U(
  ({
    label: e,
    name: t,
    description: n,
    error: r,
    warning: o,
    id: i,
    required: a,
    className: c,
    children: u,
    invisibleLabel: d,
    inputSize: h = "default",
    errorDisplay: m = "all",
    "aria-disabled": f,
    disabled: x,
    disabled_: _,
    readOnly: v,
    fullWidth: w,
    inputContainerClassName: C,
    ...L
  }, H) => {
    const k = [];
    u && k.push(`${t}-suffix`), r && k.push(`${t}-error`), o && k.push(`${t}-warning`), n && k.push(`${t}-description`);
    const S = f || (_ || x);
    return /* @__PURE__ */ s.jsx(
      P2,
      {
        label: e,
        name: t,
        description: n,
        error: r,
        warning: o,
        id: i || t,
        required: a,
        errorDisplay: m,
        invisibleLabel: d,
        fullWidth: w,
        children: /* @__PURE__ */ s.jsxs("div", { className: b(Z1.inputContainer, C), children: [
          /* @__PURE__ */ s.jsx(
            "input",
            {
              ...L,
              ref: H,
              id: i || t,
              name: t,
              "aria-describedby": k.length ? k.join(" ") : void 0,
              "aria-invalid": !!r,
              "aria-required": a,
              "aria-disabled": S,
              "aria-readonly": v,
              disabled: _,
              readOnly: v,
              className: b(Z1.input, c, {
                [Z1["input--error"]]: !!r,
                [Z1.hasSuffix]: !!u,
                [Z1.inputLarge]: h === "large",
                fullWidth: w && w !== "mobile-only",
                fullWidthOnMobile: w && w === "mobile-only"
              })
            }
          ),
          u
        ] })
      }
    );
  }
);
A2.displayName = "TextInput";
const Vn = (e, t) => Number(e === "en" ? String(t).replace(/[^0-9.]/g, "") : String(t).replace(/[^0-9,]/g, "").replace(/,/g, ".")), Q2 = {}, Pn = (e, t, n, r) => {
  const i = `${e}-${t ? "currency" : "noCurrency"}-${n}-${r}`;
  let a = Q2[i];
  return a || (a = new Intl.NumberFormat(e ?? "de", {
    minimumFractionDigits: n,
    maximumFractionDigits: n,
    ...t ? { style: "currency", currency: "EUR" } : {},
    ...r ? {} : { useGrouping: !1 }
  }), Q2[i] = a), a;
};
function T2(e, t, n = {}) {
  const r = (n == null ? void 0 : n.precision) === void 0 ? 2 : n == null ? void 0 : n.precision, o = typeof t == "number" ? t || 0 : Vn(e, t), i = (n == null ? void 0 : n.thousandSeparator) ?? !0;
  return Pn(e, !(n != null && n.format), r, i).format(o).replace(/\u00A0/, " ");
}
function ee(e) {
  if (!e)
    return 0;
  const t = e.replace(/,/g, "."), n = parseFloat(t) || 0;
  return Math.round(n * 100);
}
function i2(e, t = 2) {
  return e.replace(/[^\d.,]/g, "").replace(/^([.,]{1,1})/, "0$1").replace(/^0{2,}/, "0").replace(/^0([\d]+)([\d,.]*)/, "$1$2").replace(/[.,]([^.,]*)(?=[.,])/g, "$1").replace(new RegExp(`([.,]\\d{${t}}).*$`), "$1");
}
function s2(e) {
  return Object.keys(e);
}
const An = () => {
};
function f2(e) {
  const t = I(null), n = E(
    (r) => {
      if (t.current = r, !!e) {
        if (typeof e == "function") return e(r);
        e.current = r;
      }
    },
    [e]
  );
  return [t, n];
}
const te = {
  width: void 0,
  height: void 0
};
function $n(e) {
  const { ref: t, box: n = "content-box" } = e, [{ width: r, height: o }, i] = P(te), a = I({ ...te }), c = I(void 0);
  return c.current = e.onResize, V(() => {
    if (!t || !t.current || !window || typeof window > "u" || !("ResizeObserver" in window)) return;
    const u = new ResizeObserver(([h]) => {
      if (!t.current) return;
      const m = n === "border-box" ? "borderBoxSize" : n === "device-pixel-content-box" ? "devicePixelContentBoxSize" : "contentBoxSize";
      if (!h) return;
      const f = ne(h, m, "inlineSize"), x = ne(h, m, "blockSize");
      if (a.current.width !== f || a.current.height !== x) {
        const v = { width: f, height: x };
        a.current.width = f, a.current.height = x, c.current ? c.current(v) : i(v);
      }
    });
    u.observe(t.current, { box: n });
    const d = { width: t.current.clientWidth, height: t.current.clientHeight };
    return i(d), c.current && c.current(d), () => {
      u.disconnect();
    };
  }, [n, t]), { width: r, height: o };
}
function ne(e, t, n) {
  var o;
  const r = e[t];
  return Array.isArray(r) && r.length > 0 ? (o = r[0]) == null ? void 0 : o[n] : r && typeof r == "object" && n in r ? r[n] : n === "inlineSize" ? e.contentRect.width : e.contentRect.height;
}
function re(e) {
  if (typeof e > "u") return;
  let t;
  if (typeof e != "number" ? t = parseFloat(e) : t = e, !isNaN(t))
    return Math.round(t * 100);
}
const On = U(
  ({
    label: e,
    locale: t = "de",
    name: n,
    id: r,
    min: o = 0,
    onChange: i,
    onBlur: a,
    onFocus: c,
    defaultValue: u,
    value: d,
    step: h,
    children: m,
    className: f,
    hideSteps: x,
    max: _,
    ...v
  }, w) => {
    const C = i1(() => Bn(h), [h]), [L, H] = P(
      i2(
        T2(t, d ?? u ?? "", { precision: C, format: "%v", thousandSeparator: !1 }),
        C
      )
    ), k = i1(() => re(_), [_]), M = i1(() => re(o), [o]), [S, A] = P(null), [g, T] = f2(w), O = E(
      (y) => {
        const B = oe(y.target.value, t, C), Q = ee(B);
        if (typeof k < "u" && Q > k || typeof M < "u" && Q < M) {
          const J = y.target.selectionStart ? y.target.selectionStart : 0;
          return A(J), y.preventDefault();
        }
        A(y.target.selectionStart);
        let e1 = y.target.value;
        B.startsWith(y.target.value) || (e1 = B);
        const t1 = ee(y.target.value);
        y.target.value && !isNaN(t1) && Q === t1 && (i == null || i(y)), H(e1);
      },
      [t, C, M, k, i]
    ), F = E(
      (y) => {
        const B = oe(y.target.value, t, C);
        B !== y.target.value && (y.target.value = B), A(null), a == null || a(y);
      },
      [a, C, t]
    ), W = E(
      (y) => {
        A(y.target.selectionStart), c == null || c(y);
      },
      [c]
    ), z = i1(
      () => u ? { defaultValue: L } : { value: L },
      [u, L]
    );
    return V(() => {
      if (typeof u < "u") return;
      const y = d ?? u;
      if (typeof d > "u")
        return H("");
      const B = i2(
        T2(t, y, { precision: C, format: "%v", thousandSeparator: !1 }),
        C
      );
      H(B);
    }, [d, C, u, t]), V(() => {
      const y = (L == null ? void 0 : L.length) ?? 0, B = (S ?? 0) > y ? y : S;
      S === null || !g.current || document.activeElement !== g.current || g.current.setSelectionRange(B, B);
    }, [S, g, L]), /* @__PURE__ */ s.jsx(
      A2,
      {
        ...v,
        ...z,
        onFocus: W,
        onBlur: F,
        onChange: O,
        step: h,
        ref: T,
        id: r || n,
        name: n,
        label: e,
        pattern: "[0-9]*[.,]?[0-9]*",
        type: "text",
        inputMode: "decimal",
        className: b(f, { [Tn.hideSteps]: x }),
        children: m
      }
    );
  }
);
On.displayName = "ClientAmountField";
function oe(e, t, n = 2) {
  if (typeof e > "u" || e === null)
    return e;
  const r = String(e), o = i2(r, n), i = T2(t, o, { precision: n, format: "%v", thousandSeparator: !1 }), a = i2(i, n);
  if (!n)
    return a;
  const c = a.search(/[.,]/);
  if (c < 0)
    return a;
  const u = n - (a.length - 1 - c);
  return a.concat("0".repeat(u));
}
function Bn(e) {
  var n;
  return e === void 0 ? void 0 : ((n = String(e).split(".")[1]) == null ? void 0 : n.length) ?? 0;
}
const Dn = U(function({
  onKeyDown: t,
  onKeyUp: n,
  onKeyDownCapture: r,
  onKeyUpCapture: o,
  onClick: i,
  ...a
}, c) {
  const { disabled: u, busy: d } = a, h = u || d, m = h ? s1 : t, f = h ? s1 : n, x = h ? s1 : o, _ = h ? s1 : i;
  return /* @__PURE__ */ s.jsx(
    Ne,
    {
      ...a,
      onClick: _,
      onChange: m,
      onKeyUp: f,
      onKeyUpCapture: x,
      ref: c
    }
  );
}), Zn = "_checkmark_11dof_1", Fn = "_checkboxContainer_11dof_26", Wn = "_labelContent_11dof_42", Un = "_checkboxWrapper_11dof_91", qn = "_checkbox_11dof_26", Kn = "_disabledLabel_11dof_101", V1 = {
  checkmark: Zn,
  checkboxContainer: Fn,
  labelContent: Wn,
  checkboxWrapper: Un,
  checkbox: qn,
  disabledLabel: Kn
}, Yn = U(function({
  id: t,
  name: n,
  error: r = !1,
  classNames: o,
  "aria-disabled": i,
  "aria-required": a,
  children: c,
  required: u,
  checked: d,
  disabled_: h,
  disabled: m,
  fullWidth: f,
  ...x
}, _) {
  const v = v1(), w = t || n || v, C = i || m || h;
  return /* @__PURE__ */ s.jsx(
    "label",
    {
      htmlFor: w,
      className: b(V1.checkboxContainer, o == null ? void 0 : o.label, {
        [V1.disabledLabel]: m,
        fullWidth: f && f !== "mobile-only",
        fullWidthOnMobile: f && f === "mobile-only"
      }),
      children: /* @__PURE__ */ s.jsxs(
        "div",
        {
          className: b(V1.checkboxWrapper, {
            fullWidth: f && f !== "mobile-only",
            fullWidthOnMobile: f && f === "mobile-only"
          }),
          children: [
            /* @__PURE__ */ s.jsxs("div", { className: V1.checkbox, children: [
              /* @__PURE__ */ s.jsx(
                "input",
                {
                  tabIndex: 0,
                  ...x,
                  type: "checkbox",
                  ref: _,
                  id: w,
                  name: n,
                  required: u,
                  disabled: h,
                  "aria-disabled": C,
                  "aria-required": u,
                  "aria-invalid": r,
                  "aria-checked": d,
                  "aria-describedby": r ? `${n}-error` : void 0
                }
              ),
              /* @__PURE__ */ s.jsx("span", { className: b(V1.checkmark, o == null ? void 0 : o.checkmark) })
            ] }),
            /* @__PURE__ */ s.jsx("div", { className: b(V1.labelContent, o == null ? void 0 : o.labelContent), children: c })
          ]
        }
      )
    }
  );
});
U(function({ onChange: t, onClick: n, ...r }, o) {
  const { disabled: i } = r, a = i ? s1 : t, c = i ? s1 : n;
  return /* @__PURE__ */ s.jsx(Yn, { ...r, onChange: a, onClick: c, ref: o });
});
const Gn = "_swatch_yqwd0_7", Xn = "_activeSwatch_yqwd0_19", Jn = "_swatchInner_yqwd0_34", b2 = {
  swatch: Gn,
  activeSwatch: Xn,
  swatchInner: Jn
}, Qn = (e) => e.substring(1, 3) === "00" && e.length === 9 ? "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAAABlBMVEX////Z5exdL3Q7AAAAGklEQVQY02NgAAFGRkaa0gzo4gzo6hgGiTsANBAAYf1ZdsIAAAAASUVORK5CYII=')" : e;
U(function({
  onClick: t,
  color: n,
  triggerSwatch: r = !1,
  className: o,
  "aria-describedby": i,
  ...a
}, c) {
  return /* @__PURE__ */ s.jsxs(
    "button",
    {
      ...a,
      className: b(b2.swatch, o, {
        [b2.activeSwatch]: r
      }),
      onClick: t,
      ref: c,
      type: "button",
      "aria-roledescription": r ? "colour well" : "button",
      "aria-describedby": i,
      children: [
        /* @__PURE__ */ s.jsx(
          "div",
          {
            style: {
              background: Qn(n)
            },
            className: b2.swatchInner
          }
        ),
        /* @__PURE__ */ s.jsx("span", { className: "sr-only", children: n })
      ]
    }
  );
});
const e5 = "_crossFade_10hxa_1", t5 = "_hidden_10hxa_8", n5 = "_container_10hxa_17", F1 = {
  crossFade: e5,
  hidden: t5,
  container: n5
};
async function r5({ frames: e }) {
  return new Promise((t) => e.push(window.requestAnimationFrame(t)));
}
async function o5(e, t) {
  const n = new Array(e).fill(0).map((r, o) => () => r5({ frames: t }));
  for await (const r of n)
    await r();
}
function i5({ children: e, className: t }) {
  const n = I(null), r = I(null), [o, i] = P(0), a = I(o);
  a.current = o;
  const c = I(null), u = I(null), d = I([c, u]), h = I(null), [m, f] = P(!1), x = E(async (_, v) => {
    if (_ === n.current) return;
    n.current = _, r.current = _;
    const C = a.current === 0 ? 1 : 0;
    i(C), await o5(4, v), h.current.style.maxWidth = `${d.current[C].current.clientWidth}px`, h.current.style.minWidth = `${d.current[C].current.clientWidth}px`;
  }, []);
  return V(() => {
    f(!0);
    const _ = [];
    return x(e, _).then().catch(), () => {
      _.forEach((v) => cancelAnimationFrame(v)), n.current = e;
    };
  }, [e, x]), /* @__PURE__ */ s.jsxs("div", { className: F1.container, ref: h, children: [
    /* @__PURE__ */ s.jsx("div", { className: b(F1.crossFade, t, { [F1.hidden]: o !== 0 }), ref: c }),
    /* @__PURE__ */ s.jsx("div", { className: b(F1.crossFade, t, { [F1.hidden]: o !== 1 }), ref: u }),
    m && N2(r.current ?? null, d.current[o].current),
    m && N2(n.current ?? null, d.current[o === 0 ? 1 : 0].current)
  ] });
}
T1(i5);
const s5 = [0, 0, 1], c5 = [
  // dual axis rotations (a bit more realistic)
  [1, 1, 0],
  [1, 0, 1],
  [0, 1, 1],
  // single axis rotations (a bit dumber)
  [1, 0, 0],
  [0, 1, 0],
  s5
];
c5.reduce((e, t, n) => ({
  ...e,
  [`--confetti-rotation-3d-${n}-50`]: t.map((r) => r / 2).join(),
  [`--confetti-rotation-3d-${n}-100`]: t.join()
}), {});
const a5 = "_amountContainer_1nipm_1", l5 = "_header_1nipm_14", u5 = "_timestamp_1nipm_27", d5 = "_showMoreButton_1nipm_32", h5 = "_commentContainer_1nipm_41", f5 = "_comment_1nipm_41", C5 = "_noComment_1nipm_67", m5 = "_clickArea_1nipm_73", p5 = "_expanded_1nipm_77", g5 = "_skeletonContainer_1nipm_83", w5 = "_card_1nipm_87", _5 = "_secondSlotWrapper_1nipm_97", u1 = {
  amountContainer: a5,
  header: l5,
  timestamp: u5,
  showMoreButton: d5,
  commentContainer: h5,
  comment: f5,
  noComment: C5,
  clickArea: m5,
  expanded: p5,
  skeletonContainer: g5,
  card: w5,
  secondSlotWrapper: _5
}, v5 = "_skeleton_17wk3_1", x5 = "_dark_17wk3_13", ie = {
  skeleton: v5,
  dark: x5
};
function k1({
  as: e = "div",
  width: t,
  height: n,
  borderRadius: r,
  style: o,
  className: i,
  dark: a,
  ...c
}) {
  return /* @__PURE__ */ s.jsx(
    e,
    {
      className: b(ie.skeleton, i, { [ie.dark]: a }),
      style: {
        width: t,
        height: n,
        borderRadius: r,
        ...o
      },
      ...c
    }
  );
}
const b5 = "_tooltipContent_upgbl_1", L5 = "_opacityTransition_upgbl_18", E5 = "_opacityTransitionOpen_upgbl_23", L2 = {
  tooltipContent: b5,
  opacityTransition: L5,
  opacityTransitionOpen: E5
};
function k5(e) {
  return /* @__PURE__ */ s.jsx(
    ye,
    {
      ...e,
      Anchor: He,
      triggerEvents: ["hover", "focus"],
      contentClassName: L2.tooltipContent,
      contentWrapperClassName: L2.opacityTransition,
      popupOpenWrapperClassName: L2.opacityTransitionOpen,
      preferredPopupPosition: c1.TOP
    }
  );
}
function y5() {
  return /* @__PURE__ */ s.jsx(k1, { width: "6.25rem", height: "3.527rem", className: u1.skeletonContainer });
}
function j5({ amount: e, skeleton: t = !1 }) {
  return t ? /* @__PURE__ */ s.jsx(y5, {}) : /* @__PURE__ */ s.jsx("div", { className: u1.amountContainer, children: e });
}
function ze({ children: e }) {
  return /* @__PURE__ */ s.jsx(s.Fragment, { children: e });
}
ze.AmountContainer = j5;
const se = 1;
function M5({
  handleEnter: e,
  isTooLong: t,
  isExpanded: n,
  toggleIsExpanded: r,
  comment: o
}) {
  const i = n ? "chevronUp" : "chevronDown";
  return n || !t ? /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
    o,
    t && /* @__PURE__ */ s.jsx(
      H1,
      {
        kind: "plain",
        size: "default",
        iconName: i,
        onClick: r,
        className: u1.showMoreButton
      }
    )
  ] }) : /* @__PURE__ */ s.jsxs("div", { className: u1.clickArea, onClick: r, onKeyUp: e, role: "button", tabIndex: 0, children: [
    o,
    t && /* @__PURE__ */ s.jsx(H1, { kind: "plain", size: "default", iconName: i, className: u1.showMoreButton })
  ] });
}
function N5({ comment: e }) {
  const [t, n] = P(!1), [r, o] = P(!1), i = I(null);
  V(() => {
    const u = i.current;
    if (!u) {
      o(!1);
      return;
    }
    const d = parseFloat(getComputedStyle(u).lineHeight), h = Math.ceil(u.scrollHeight / Math.round(d));
    o(h > se);
  }, [o]);
  const a = E(() => {
    n((u) => !u);
  }, []), c = E(
    (u) => {
      u.key === K.Enter && a();
    },
    [a]
  );
  return e ? /* @__PURE__ */ s.jsx(
    "div",
    {
      ref: i,
      className: b(u1.comment, { [u1.expanded]: t }),
      style: { "--max-preview-lines": se },
      children: /* @__PURE__ */ s.jsx(
        M5,
        {
          handleEnter: c,
          isTooLong: r,
          isExpanded: t,
          toggleIsExpanded: a,
          comment: e
        }
      )
    }
  ) : null;
}
function H5({ comment: e }) {
  return /* @__PURE__ */ s.jsx(
    "div",
    {
      className: b(u1.commentContainer, {
        [u1.noComment]: !e
      }),
      children: /* @__PURE__ */ s.jsx(N5, { comment: e })
    }
  );
}
function T5({ header: e }) {
  const [t, n] = P(!1), r = I(null);
  return V(() => {
    const o = r.current;
    if (!o) {
      n(!1);
      return;
    }
    n(o.scrollWidth > Math.round(o.clientWidth));
  }, [e]), t ? /* @__PURE__ */ s.jsx(k5, { content: e, children: /* @__PURE__ */ s.jsx("div", { className: u1.header, children: e }) }) : /* @__PURE__ */ s.jsx("div", { ref: r, className: u1.header, children: e });
}
function z5() {
  return /* @__PURE__ */ s.jsxs(l1, { className: u1.skeletonContainer, space: "200", children: [
    /* @__PURE__ */ s.jsx(k1, { width: "5.7rem", height: "1.3rem" }),
    /* @__PURE__ */ s.jsx(k1, { width: "5.7rem", height: "1.1rem" })
  ] });
}
function R5({ header: e, timestamp: t, comment: n, cta: r, skeleton: o }) {
  return o ? /* @__PURE__ */ s.jsx(z5, {}) : r ? /* @__PURE__ */ s.jsx("div", { className: u1.secondSlotWrapper, children: r }) : /* @__PURE__ */ s.jsxs(l1, { space: "none", className: u1.secondSlotWrapper, children: [
    /* @__PURE__ */ s.jsx(T5, { header: e }),
    /* @__PURE__ */ s.jsx("div", { className: u1.timestamp, children: t }),
    /* @__PURE__ */ s.jsx(H5, { comment: n })
  ] });
}
function Re({ children: e }) {
  return /* @__PURE__ */ s.jsx(s.Fragment, { children: e });
}
Re.DetailsContainer = R5;
const Ie = U(function({ children: t, className: n, style: r }, o) {
  return /* @__PURE__ */ s.jsx("div", { style: { ...r, overflow: "visible" }, children: /* @__PURE__ */ s.jsx($1, { className: b(u1.card, n), ref: o, children: t }) });
});
Ie.FirstSlot = ze;
Ie.SecondSlot = Re;
const I5 = "_card_1wret_1", S5 = "_amountContainer_1wret_10", V5 = "_ctaAmountContainer_1wret_24", P5 = "_heading_1wret_30", A5 = "_timestamp_1wret_39", $5 = "_commentContainer_1wret_44", O5 = "_comment_1wret_44", B5 = "_showMoreButton_1wret_62", D5 = "_expanded_1wret_72", Z5 = "_ctaContainer_1wret_78", d1 = {
  card: I5,
  amountContainer: S5,
  ctaAmountContainer: V5,
  heading: P5,
  timestamp: A5,
  commentContainer: $5,
  comment: O5,
  showMoreButton: B5,
  expanded: D5,
  ctaContainer: Z5
};
function F5({
  style: e,
  onChangeSize: t
}) {
  const n = I(null), r = I(null);
  if (e != null && e.height) {
    const i = typeof e.height == "number" ? e.height : parseFloat(e.height);
    r.current = i;
  }
  const o = E(
    (i) => {
      if (!t || !i) return;
      const a = Math.round(i);
      typeof r.current == "number" && r.current > 0 && a !== r.current && (t(a), r.current = a);
    },
    [t]
  );
  return $n({
    ref: n,
    box: "border-box",
    onResize: ({ height: i }) => o(i)
  }), n;
}
function Se() {
  return /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
    /* @__PURE__ */ s.jsx(k1, { width: "6.25rem", height: "3rem" }),
    /* @__PURE__ */ s.jsxs(l1, { space: "200", children: [
      /* @__PURE__ */ s.jsx(k1, { width: "5.7rem", height: "1.3rem" }),
      /* @__PURE__ */ s.jsx(k1, { width: "5.7rem", height: "1.1rem" })
    ] })
  ] });
}
function W5({ className: e }) {
  return /* @__PURE__ */ s.jsx($1, { className: b(d1.card, e), children: /* @__PURE__ */ s.jsx(Se, {}) });
}
const U5 = U(function({ className: t, style: n }, r) {
  return /* @__PURE__ */ s.jsx("div", { style: { ...n, overflow: "visible" }, ref: r, children: /* @__PURE__ */ s.jsx($1, { className: b(d1.card, t), children: /* @__PURE__ */ s.jsx(Se, {}) }) });
}), q5 = U(function(t, n) {
  return t.onChangeSize ? /* @__PURE__ */ s.jsx(U5, { ref: n, ...t }) : /* @__PURE__ */ s.jsx(W5, { ...t });
});
function K5({
  className: e,
  amount: t,
  ctaText: n,
  ctaLink: r
}) {
  return /* @__PURE__ */ s.jsxs($1, { className: b(d1.card, e), children: [
    /* @__PURE__ */ s.jsx("div", { className: b(d1.amountContainer, d1.ctaAmountContainer), children: t }),
    /* @__PURE__ */ s.jsx("div", { className: d1.ctaContainer, children: /* @__PURE__ */ s.jsx(ge, { href: r, children: n }) })
  ] });
}
function Y5({
  comment: e,
  showMoreLabel: t,
  showLessLabel: n,
  maxPreviewLines: r = 2
}) {
  const [o, i] = P(!1), [a, c] = P(!1), u = o ? n : t, d = I(null);
  V(() => {
    const m = d.current;
    if (!m) {
      c(!1);
      return;
    }
    const f = parseFloat(getComputedStyle(m).lineHeight), x = Math.ceil(m.scrollHeight / f);
    c(x > r);
  }, [r, c]);
  const h = E(() => {
    i((m) => !m);
  }, []);
  return /* @__PURE__ */ s.jsxs("div", { className: d1.commentContainer, children: [
    /* @__PURE__ */ s.jsx(
      "div",
      {
        ref: d,
        className: b(d1.comment, { [d1.expanded]: o }),
        style: { "--max-preview-lines": r },
        children: e
      }
    ),
    a && /* @__PURE__ */ s.jsx(
      H1,
      {
        kind: "plain",
        size: "small",
        iconName: o ? "chevronUp" : "chevronDown",
        iconPosition: "right",
        onClick: h,
        className: d1.showMoreButton,
        children: u
      }
    )
  ] });
}
function Ve({
  amount: e,
  heading: t,
  timestamp: n,
  comment: r,
  showMoreLabel: o,
  showLessLabel: i,
  maxPreviewLines: a
}) {
  return /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
    /* @__PURE__ */ s.jsx("div", { className: d1.amountContainer, children: /* @__PURE__ */ s.jsx("div", { children: e }) }),
    /* @__PURE__ */ s.jsxs(l1, { space: "none", children: [
      /* @__PURE__ */ s.jsx("div", { className: d1.heading, children: t }),
      /* @__PURE__ */ s.jsx("div", { className: d1.timestamp, children: n }),
      r && /* @__PURE__ */ s.jsx(
        Y5,
        {
          comment: r,
          showMoreLabel: o,
          showLessLabel: i,
          maxPreviewLines: a
        }
      )
    ] })
  ] });
}
function G5({ className: e, ...t }) {
  return /* @__PURE__ */ s.jsx($1, { className: b(d1.card, e), children: /* @__PURE__ */ s.jsx(Ve, { ...t }) });
}
const X5 = U(function({ className: t, style: n, onChangeSize: r, ...o }, i) {
  const a = F5({ style: n, onChangeSize: r });
  return /* @__PURE__ */ s.jsx("div", { style: { ...n, overflow: "visible" }, ref: i, children: /* @__PURE__ */ s.jsx($1, { className: b(d1.card, t), ref: a, children: /* @__PURE__ */ s.jsx(Ve, { ...o }) }) });
}), J5 = U(function(t, n) {
  return t.onChangeSize ? /* @__PURE__ */ s.jsx(X5, { ref: n, ...t }) : /* @__PURE__ */ s.jsx(G5, { ...t });
});
U(function({ variant: t, amount: n, ctaText: r, ctaLink: o, className: i, ...a }, c) {
  if (t === "cta") return /* @__PURE__ */ s.jsx(K5, { amount: n, ctaText: r, ctaLink: o, className: i });
  if (t === "skeleton") return /* @__PURE__ */ s.jsx(q5, { ref: c, className: i, ...a });
  const u = { variant: t, amount: n, ctaText: r, ctaLink: o, className: i, ...a };
  return /* @__PURE__ */ s.jsx(J5, { ...u });
});
const Q5 = "_content_1yans_1", e6 = "_container_1yans_8", t6 = "_open_1yans_21", E2 = {
  content: Q5,
  container: e6,
  open: t6
};
U(function({ children: t, open: n, className: r, contentClassName: o }, i) {
  const a = I(null), [c, u] = P(0), d = E(() => {
    if (!a.current) return;
    const h = a.current;
    u(h.scrollHeight);
  }, []);
  return pe(i, () => ({
    checkSize: d
  })), V(() => {
    if (n)
      return d(), window.addEventListener("resize", d), () => {
        window.removeEventListener("resize", d);
      };
  }, [d, n]), /* @__PURE__ */ s.jsx(
    "div",
    {
      className: b(E2.container, r, { [E2.open]: n }),
      style: { "--height": `${c}px` },
      children: /* @__PURE__ */ s.jsx("div", { className: b(E2.content, o), ref: a, children: t })
    }
  );
});
const n6 = "_input_slzhp_1", r6 = "_hide_slzhp_5", o6 = "_clearButton_slzhp_9", i6 = "_hiddenInput_slzhp_34", W1 = {
  input: n6,
  hide: r6,
  clearButton: o6,
  hiddenInput: i6
}, Pe = (e) => e instanceof File, ce = (e) => e ? Pe(e) ? 1 : e.length : 0, s6 = (e, t = 0) => {
  var n;
  return e ? Pe(e) ? t === 0 ? e.name : "" : ((n = e[t]) == null ? void 0 : n.name) || "" : "";
}, c6 = U(
  ({
    label: e,
    name: t,
    description: n,
    error: r,
    warning: o,
    id: i,
    required: a,
    className: c,
    invisibleLabel: u,
    accept: d,
    multiple: h = !1,
    maxSize: m,
    fullWidth: f,
    placeholder: x = "",
    buttonText: _ = "",
    onFileChange: v,
    disabled: w,
    readOnly: C,
    multipleFilesSelectedLabel: L,
    onChange: H,
    files: k,
    tabIndex: M,
    displayText: S,
    ...A
  }, g) => {
    const T = v1(), O = i || t || T, [F, W] = f2(g), z = () => {
      const J = ce(k);
      return J === 0 ? S ?? x : J === 1 ? s6(k, 0) : `${J} ${L}`;
    }, y = E(
      (J) => {
        const p = J.target.files;
        if (m && p)
          for (let N = 0; N < p.length; N++) {
            const Z = p[N];
            if (Z && Z.size > m) {
              console.warn(`File ${Z.name} exceeds maximum size of ${m} bytes`);
              return;
            }
          }
        v == null || v(p), H == null || H(J);
      },
      [m, v, H]
    ), B = E(() => {
      v == null || v(null);
    }, [v]), Q = E(() => {
      var J;
      !w && !C && ((J = F.current) == null || J.click());
    }, [w, F, C]), e1 = z(), t1 = ce(k) > 0 || e1 !== x;
    return /* @__PURE__ */ s.jsxs(l1, { space: "50", className: c, children: [
      /* @__PURE__ */ s.jsx(
        A2,
        {
          label: e,
          name: `${t}-display`,
          description: n,
          error: r,
          warning: o,
          id: `${O}-display`,
          required: a,
          invisibleLabel: u,
          disabled_: !0,
          value: e1,
          readOnly: !0,
          fullWidth: f,
          inputContainerClassName: W1.input,
          children: /* @__PURE__ */ s.jsx(
            "button",
            {
              type: "button",
              className: b(W1.clearButton, {
                [W1.hide]: !t1 || w || C
              }),
              onClick: B,
              "aria-label": "Clear selected file",
              tabIndex: M,
              children: /* @__PURE__ */ s.jsx(_1, { size: "300", name: "x" })
            }
          )
        }
      ),
      /* @__PURE__ */ s.jsx(
        "input",
        {
          ...A,
          ref: W,
          type: "file",
          id: O,
          name: t,
          accept: d,
          multiple: h,
          disabled: w,
          onChange: y,
          className: W1.hiddenInput,
          "aria-describedby": n ? `${O}-description` : void 0,
          tabIndex: -1
        }
      ),
      /* @__PURE__ */ s.jsx(
        H1,
        {
          type: "button",
          kind: "secondary",
          size: "default",
          disabled: w || C,
          onClick: Q,
          className: W1.browseButton,
          iconName: "upload",
          tabIndex: M,
          children: _
        }
      )
    ] });
  }
);
c6.displayName = "FileUploadInput";
const a6 = U(function({
  id: t,
  name: n,
  children: r,
  label: o,
  hint: i,
  required: a,
  disabled: c,
  disabled_: u,
  "aria-disabled": d,
  description: h,
  error: m,
  warning: f,
  errorDisplay: x = "all",
  fullWidth: _,
  ...v
}, w) {
  const C = v1(), L = t || n || C, k = d || (u || c);
  return /* @__PURE__ */ s.jsx(
    P2,
    {
      label: o,
      name: n,
      description: h,
      error: m,
      warning: f,
      id: L || n,
      required: a,
      errorDisplay: x,
      fullWidth: _,
      hint: i,
      children: /* @__PURE__ */ s.jsxs("div", { className: X2.selectContainer, children: [
        /* @__PURE__ */ s.jsx(
          "select",
          {
            ...v,
            ref: w,
            className: b(X2.select, {
              fullWidth: _ && _ !== "mobile-only",
              fullWidthOnMobile: _ && _ === "mobile-only"
            }),
            id: L,
            name: n,
            "aria-disabled": k,
            disabled: u,
            children: r
          }
        ),
        /* @__PURE__ */ s.jsx(_1, { name: "chevronDown" })
      ] })
    }
  );
});
U(function({ onChange: t, onClick: n, ...r }, o) {
  const { disabled: i } = r, a = i ? s1 : t, c = i ? s1 : n;
  return /* @__PURE__ */ s.jsx(a6, { ...r, onChange: a, onClick: c, ref: o });
});
const l6 = {
  "heading-md": "h1",
  "heading-sm": "h1",
  "heading-xs": "h2",
  "text-md-important": "h3",
  "text-md-default": "h4"
}, u6 = "_flex_owtzc_24", ae = {
  "heading-md": "_heading-md_owtzc_4",
  "heading-sm": "_heading-sm_owtzc_8",
  "heading-xs": "_heading-xs_owtzc_12",
  "text-md-important": "_text-md-important_owtzc_16",
  "text-md-default": "_text-md-default_owtzc_20",
  flex: u6
};
function d6({
  as: e,
  level: t,
  children: n,
  subtitle: r,
  className: o,
  flex: i,
  ["aria-describedby"]: a,
  ...c
}) {
  const u = e || l6[t], d = v1();
  return /* @__PURE__ */ s.jsxs(l1, { space: "50", children: [
    /* @__PURE__ */ s.jsx(
      u,
      {
        ...c,
        className: b(ae[t], o, { [ae.flex]: i }),
        "aria-describedby": r ? d : a,
        children: n
      }
    ),
    r ? /* @__PURE__ */ s.jsx("div", { id: d, "aria-hidden": !0, children: r }) : null
  ] });
}
const h6 = "_modal_10wv4_1", f6 = "_modalInner_10wv4_53", C6 = "_modalHeader_10wv4_57", m6 = "_closeButton_10wv4_72", p6 = "_modalContent_10wv4_78", g6 = "_modalActions_10wv4_82", w6 = "_portalTarget_10wv4_91", _6 = "_portalTargetInert_10wv4_98", L1 = {
  modal: h6,
  modalInner: f6,
  modalHeader: C6,
  closeButton: m6,
  modalContent: p6,
  modalActions: g6,
  portalTarget: w6,
  portalTargetInert: _6
};
function v6(e) {
  e && (!("close" in e) || typeof e.close != "function" || e.close());
}
U(function({
  id: t,
  isOpen: n,
  onClose: r,
  onOpen: o,
  onCloseComplete: i,
  onOpenComplete: a,
  title: c,
  customActions: u,
  children: d,
  manualFocusRef: h,
  closeText: m,
  closeOnClickOutside: f = !0,
  hideHeader: x = !1,
  hideActions: _ = !1,
  classNames: v = {}
}, w) {
  const [C, L] = f2(w), H = I(null), [k, M] = P(!0), S = E(() => h || (H.current ? H : C), [h, C]), A = v1(), g = t || A, T = E(
    (z) => {
      var e1;
      if (z.key === "Escape") return r(z);
      if (z.key !== "Tab") return;
      const y = (e1 = C.current) == null ? void 0 : e1.querySelectorAll(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      ), B = y == null ? void 0 : y[0], Q = y == null ? void 0 : y[y.length - 1];
      if (z.shiftKey && document.activeElement === B) {
        z.preventDefault(), Q == null || Q.focus();
        return;
      }
      !z.shiftKey && document.activeElement === Q && (z.preventDefault(), B == null || B.focus());
    },
    [C, r]
  ), O = E(() => {
    i == null || i(), M(!0);
  }, [i]), F = E(() => {
    var z;
    a == null || a(), M(!0), (z = C.current) == null || z.removeAttribute("inert");
  }, [C, a]);
  V(() => {
    var y;
    M(!1);
    const z = C.current;
    if (z) {
      if (n) {
        try {
          z.showModal();
        } catch (Q) {
          console.error(Q);
        }
        const B = S();
        (y = B == null ? void 0 : B.current) == null || y.focus(), z.removeEventListener("transitionend", O), z.addEventListener("keydown", T), z.addEventListener("transitionend", F), o == null || o();
      } else
        z.removeEventListener("keydown", T), z.removeEventListener("transitionend", F), z.addEventListener("transitionend", O), v6(z), z.setAttribute("inert", "");
      return () => {
        z == null || z.removeEventListener("keydown", T), z.removeEventListener("transitionend", O), z.removeEventListener("transitionend", F);
      };
    }
  }, [S, T, n, C, O, o, F]);
  const W = E(
    (z) => {
      const { current: y } = C;
      z.target === y && r(z);
    },
    [C, r]
  );
  return (
    // Disabled because HTML dialog brings keyboard interaction with it
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions
    /* @__PURE__ */ s.jsxs(
      "dialog",
      {
        id: g,
        ref: L,
        className: b(L1.modal, v.modal),
        onCancel: r,
        onClick: f ? W : void 0,
        "aria-labelledby": `modal-title-${g}`,
        "aria-modal": "true",
        title: c,
        tabIndex: -1,
        children: [
          /* @__PURE__ */ s.jsxs(l1, { space: "400", className: b(L1.modalInner, v.modalInner), children: [
            !x && /* @__PURE__ */ s.jsxs("div", { className: b(L1.modalHeader, v.titleContainer), children: [
              /* @__PURE__ */ s.jsx(d6, { level: "heading-xs", as: "h2", id: `modal-title-${g}`, children: c }),
              /* @__PURE__ */ s.jsx(
                H1,
                {
                  kind: "plain",
                  className: L1.closeButton,
                  onClick: r,
                  ref: H,
                  type: "button",
                  iconName: "x",
                  iconProps: { title: m, color: "fg-content-primary" }
                }
              )
            ] }),
            /* @__PURE__ */ s.jsx("div", { className: b(L1.modalContent, v.contentContainer), children: (n || !k) && d }),
            !_ && /* @__PURE__ */ s.jsx("div", { className: b(L1.modalActions, v.actionsContainer), children: u || /* @__PURE__ */ s.jsx(Dn, { onClick: r, type: "button", children: m }) })
          ] }),
          n && /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
            /* @__PURE__ */ s.jsx("div", { id: "bp-portal-target", className: L1.portalTarget, role: "alert" }),
            /* @__PURE__ */ s.jsx("div", { id: "bp-portal-target-inert", className: L1.portalTargetInert, role: "alert" })
          ] })
        ]
      }
    )
  );
});
const x6 = "_row_1kh5u_1", b6 = "_headerCell_1kh5u_16", L6 = "_table_1kh5u_21", E6 = "_resizeHandle_1kh5u_35", k6 = "_resizing_1kh5u_56", y6 = "_touchEnabled_1kh5u_66", j6 = "_fixed_1kh5u_72", M6 = "_firstColFixed_1kh5u_82", N6 = "_container_1kh5u_88", H6 = "_overflow_1kh5u_92", p1 = {
  row: x6,
  headerCell: b6,
  table: L6,
  resizeHandle: E6,
  resizing: k6,
  touchEnabled: y6,
  fixed: j6,
  firstColFixed: M6,
  container: N6,
  overflow: H6
};
function Ae({
  children: e,
  className: t,
  as: n = "td",
  maxWidth: r,
  ...o
}) {
  const i = n === "th" ? p1.headerCell : p1.cell, a = r === Number.POSITIVE_INFINITY ? void 0 : r;
  return /* @__PURE__ */ s.jsx(
    n,
    {
      className: b(i, t),
      style: { ...o, maxWidth: a, "--cell-width": o.width },
      children: e
    }
  );
}
function T6({
  label: e,
  width: t,
  minWidth: n,
  maxWidth: r,
  children: o,
  className: i
}) {
  return /* @__PURE__ */ s.jsxs(Ae, { as: "th", className: i, width: t, minWidth: n, maxWidth: r, children: [
    e,
    o
  ] });
}
const k2 = {
  Init: "@@INIT",
  SetData: "SET_DATA",
  SetConfig: "SET_CONFIG"
};
function $e(e, t, n, r) {
  if (!(r(e) === r(t))) return !1;
  for (const i of n) {
    const a = e[i], c = t[i];
    if (!a || !c) return !1;
    if (typeof a == "object" && typeof c == "object")
      return $e(
        a,
        c,
        s2(a),
        () => "1"
      );
    if (a !== c)
      return !1;
  }
  return !0;
}
function z6(e, t) {
  for (const n of s2(e).concat(s2(t)))
    if (e[n] !== t[n]) return !1;
  return !0;
}
function Oe(e, t, n, r) {
  const o = { ...e.entities }, i = [];
  let a = !1, c = e.idx.length !== t.length;
  for (let u = 0; u < t.length; u++) {
    const d = t[u], h = e.idx[u], m = n(d);
    h !== m && (c = !0, a = !0), i.push(m), (!o[m] || !r(o[m], d)) && (a = !0, o[m] = d);
  }
  return a ? [{ entities: o, idx: c ? i : e.idx }, a || c] : [e, !1];
}
function le(e, t) {
  function n(i, a) {
    return $e(i, a, e.config.columns.idx, e.config.getRowId);
  }
  const [r, o] = Oe(e.data, t, e.config.getRowId, n);
  return o ? {
    ...e,
    data: r
  } : e;
}
function R6(e) {
  return {
    ...e,
    width: e.width ?? 0,
    minWidth: e.minWidth ?? 0,
    maxWidth: e.maxWidth ?? Number.POSITIVE_INFINITY,
    resizable: e.resizable ?? !1,
    lastResizable: void 0
  };
}
function ue(e, t) {
  const n = t.columns.map((c) => R6(c)), r = n.findLast((c) => c.resizable);
  r && (r.lastResizable = !0);
  const [o, i] = Oe(
    e.config.columns,
    n,
    (c) => c.field,
    z6
  );
  let a = i;
  if (!a) {
    for (const c of s2(t))
      if (c !== "columns" && e.config[c] !== t[c]) {
        a = !0;
        break;
      }
  }
  return a ? {
    ...e,
    config: { ...e.config, ...t, columns: o }
  } : e;
}
function I6(e, t) {
  switch (t.type) {
    case k2.Init: {
      const { data: n, config: r } = t.payload;
      return le(ue(S6(), r), n);
    }
    case k2.SetData:
      return le(e, t.payload);
    case k2.SetConfig:
      return ue(e, t.payload);
    default:
      return e;
  }
}
function S6() {
  return {
    data: { entities: {}, idx: [] },
    config: { columns: { entities: {}, idx: [] }, getRowId: (e) => "" }
  };
}
function V6(e, t = (n, r) => n === r) {
  let n = null, r = null;
  return (...o) => (n && t(n, o) || (n = o, r = e(...o)), r);
}
function P6(e, t) {
  const n = I(e), [r, o] = i0(t, n.current()), i = E(
    (a) => {
      o(a);
    },
    [o]
  );
  return [r, i];
}
const Be = c2(null), A6 = Be.Provider;
function $6({
  children: e,
  getInitialState: t,
  reducer: n
}) {
  const [r, o] = P6(t, n);
  return /* @__PURE__ */ s.jsx(A6, { value: [r, o], children: e });
}
function De() {
  const e = a2(Be);
  if (!e)
    throw new Error("Store not found");
  return e;
}
function O6(e) {
  const t = i1(() => V6(e), [e]), [n] = De();
  return t(n);
}
function B6() {
  const [, e] = De();
  return e;
}
function D6(e) {
  return {
    Provider: function({
      children: n,
      getInitialState: r
    }) {
      return /* @__PURE__ */ s.jsx($6, { getInitialState: r, reducer: e, children: n });
    },
    useSelector: O6,
    useDispatch: B6
  };
}
const Z6 = D6(I6);
var F6 = (e, t, n) => {
  if (t.length === 1 && t[0] === n) {
    let r = !1;
    try {
      const o = {};
      e(o) === o && (r = !0);
    } catch {
    }
    if (r) {
      let o;
      try {
        throw new Error();
      } catch (i) {
        ({ stack: o } = i);
      }
      console.warn(
        `The result function returned its own inputs without modification. e.g
\`createSelector([state => state.todos], todos => todos)\`
This could lead to inefficient memoization and unnecessary re-renders.
Ensure transformation logic is in the result function, and extraction logic is in the input selectors.`,
        { stack: o }
      );
    }
  }
}, W6 = (e, t, n) => {
  const { memoize: r, memoizeOptions: o } = t, { inputSelectorResults: i, inputSelectorResultsCopy: a } = e, c = r(() => ({}), ...o);
  if (!(c.apply(null, i) === c.apply(null, a))) {
    let d;
    try {
      throw new Error();
    } catch (h) {
      ({ stack: d } = h);
    }
    console.warn(
      `An input selector returned a different result when passed same arguments.
This means your output selector will likely run more frequently than intended.
Avoid returning a new reference inside your input selector, e.g.
\`createSelector([state => state.todos.map(todo => todo.id)], todoIds => todoIds.length)\``,
      {
        arguments: n,
        firstInputs: i,
        secondInputs: a,
        stack: d
      }
    );
  }
}, U6 = {
  inputStabilityCheck: "once",
  identityFunctionCheck: "once"
};
function q6(e, t = `expected a function, instead received ${typeof e}`) {
  if (typeof e != "function")
    throw new TypeError(t);
}
function K6(e, t = `expected an object, instead received ${typeof e}`) {
  if (typeof e != "object")
    throw new TypeError(t);
}
function Y6(e, t = "expected all items to be functions, instead received the following types: ") {
  if (!e.every((n) => typeof n == "function")) {
    const n = e.map(
      (r) => typeof r == "function" ? `function ${r.name || "unnamed"}()` : typeof r
    ).join(", ");
    throw new TypeError(`${t}[${n}]`);
  }
}
var de = (e) => Array.isArray(e) ? e : [e];
function G6(e) {
  const t = Array.isArray(e[0]) ? e[0] : e;
  return Y6(
    t,
    "createSelector expects all input-selectors to be functions, but received the following types: "
  ), t;
}
function he(e, t) {
  const n = [], { length: r } = e;
  for (let o = 0; o < r; o++)
    n.push(e[o].apply(null, t));
  return n;
}
var X6 = (e, t) => {
  const { identityFunctionCheck: n, inputStabilityCheck: r } = {
    ...U6,
    ...t
  };
  return {
    identityFunctionCheck: {
      shouldRun: n === "always" || n === "once" && e,
      run: F6
    },
    inputStabilityCheck: {
      shouldRun: r === "always" || r === "once" && e,
      run: W6
    }
  };
}, J6 = class {
  constructor(e) {
    this.value = e;
  }
  deref() {
    return this.value;
  }
}, Q6 = typeof WeakRef < "u" ? WeakRef : J6, e7 = 0, fe = 1;
function e2() {
  return {
    s: e7,
    v: void 0,
    o: null,
    p: null
  };
}
function Ze(e, t = {}) {
  let n = e2();
  const { resultEqualityCheck: r } = t;
  let o, i = 0;
  function a() {
    var m;
    let c = n;
    const { length: u } = arguments;
    for (let f = 0, x = u; f < x; f++) {
      const _ = arguments[f];
      if (typeof _ == "function" || typeof _ == "object" && _ !== null) {
        let v = c.o;
        v === null && (c.o = v = /* @__PURE__ */ new WeakMap());
        const w = v.get(_);
        w === void 0 ? (c = e2(), v.set(_, c)) : c = w;
      } else {
        let v = c.p;
        v === null && (c.p = v = /* @__PURE__ */ new Map());
        const w = v.get(_);
        w === void 0 ? (c = e2(), v.set(_, c)) : c = w;
      }
    }
    const d = c;
    let h;
    if (c.s === fe)
      h = c.v;
    else if (h = e.apply(null, arguments), i++, r) {
      const f = ((m = o == null ? void 0 : o.deref) == null ? void 0 : m.call(o)) ?? o;
      f != null && r(f, h) && (h = f, i !== 0 && i--), o = typeof h == "object" && h !== null || typeof h == "function" ? new Q6(h) : h;
    }
    return d.s = fe, d.v = h, h;
  }
  return a.clearCache = () => {
    n = e2(), a.resetResultsCount();
  }, a.resultsCount = () => i, a.resetResultsCount = () => {
    i = 0;
  }, a;
}
function t7(e, ...t) {
  const n = typeof e == "function" ? {
    memoize: e,
    memoizeOptions: t
  } : e, r = (...o) => {
    let i = 0, a = 0, c, u = {}, d = o.pop();
    typeof d == "object" && (u = d, d = o.pop()), q6(
      d,
      `createSelector expects an output function after the inputs, but received: [${typeof d}]`
    );
    const h = {
      ...n,
      ...u
    }, {
      memoize: m,
      memoizeOptions: f = [],
      argsMemoize: x = Ze,
      argsMemoizeOptions: _ = [],
      devModeChecks: v = {}
    } = h, w = de(f), C = de(_), L = G6(o), H = m(function() {
      return i++, d.apply(
        null,
        arguments
      );
    }, ...w);
    let k = !0;
    const M = x(function() {
      a++;
      const A = he(
        L,
        arguments
      );
      if (c = H.apply(null, A), process.env.NODE_ENV !== "production") {
        const { identityFunctionCheck: g, inputStabilityCheck: T } = X6(k, v);
        if (g.shouldRun && g.run(
          d,
          A,
          c
        ), T.shouldRun) {
          const O = he(
            L,
            arguments
          );
          T.run(
            { inputSelectorResults: A, inputSelectorResultsCopy: O },
            { memoize: m, memoizeOptions: w },
            arguments
          );
        }
        k && (k = !1);
      }
      return c;
    }, ...C);
    return Object.assign(M, {
      resultFunc: d,
      memoizedResultFunc: H,
      dependencies: L,
      dependencyRecomputations: () => a,
      resetDependencyRecomputations: () => {
        a = 0;
      },
      lastResult: () => c,
      recomputations: () => i,
      resetRecomputations: () => {
        i = 0;
      },
      memoize: m,
      argsMemoize: x
    });
  };
  return Object.assign(r, {
    withTypes: () => r
  }), r;
}
var a1 = /* @__PURE__ */ t7(Ze), n7 = Object.assign(
  (e, t = a1) => {
    K6(
      e,
      `createStructuredSelector expects first argument to be an object where each property is a selector, instead received a ${typeof e}`
    );
    const n = Object.keys(e), r = n.map(
      (i) => e[i]
    );
    return t(
      r,
      (...i) => i.reduce((a, c, u) => (a[n[u]] = c, a), {})
    );
  },
  { withTypes: () => n7 }
);
const { useSelector: r7 } = Z6;
function z1(e) {
  return r7(e);
}
function G1(e) {
  return e.config;
}
const Fe = a1(G1, (e) => e.columns);
function We(e) {
  return e.data;
}
function Ue(e) {
  return e.entities;
}
const C2 = a1(Fe, Ue), o7 = a1(
  [C2, (e, t) => t],
  (e, t) => e[t]
), qe = a1(We, Ue);
a1(
  [qe, (e, t) => t],
  (e, t) => e[t]
);
const i7 = a1(
  [
    qe,
    (e, t, n) => ({
      column: n,
      id: t
    })
  ],
  (e, { id: t, column: n }) => {
    const r = e[t];
    return r ? r[n] : null;
  }
), $2 = a1(Fe, (e) => e.idx), Ke = a1(We, (e) => e.idx), m2 = a1(G1, (e) => !!e.pivot);
a1(
  [$2, C2],
  (e, t) => e.map((n) => t[n])
);
a1(G1, (e) => e.id);
function s7() {
  return z1($2);
}
function c7() {
  return z1(Ke);
}
function p2() {
  return z1(m2);
}
function Ye(e) {
  const t = i1(() => (r) => o7(r, e), [e]);
  return z1(t);
}
function a7() {
  const e = s7(), t = c7();
  return p2() ? e : t;
}
const l7 = a1(G1, (e) => !!e.expandable);
function u7() {
  return z1(l7);
}
const Ge = "label", Xe = a1(
  [$2, Ke, m2],
  (e, t, n) => n ? [Ge, ...t] : e
);
function O2() {
  return z1(Xe);
}
function d7(e) {
  let t = 0, n = Number.POSITIVE_INFINITY, r = 0, o = !1;
  for (const i in e) {
    const a = e[i];
    r = Math.max(r, a.width), typeof a.minWidth == "number" && (t = Math.max(t, a.minWidth)), typeof a.maxWidth == "number" && (n = Math.min(n, a.maxWidth)), o = o || !!a.resizable;
  }
  return {
    label: "column",
    width: r,
    minWidth: t === Number.POSITIVE_INFINITY ? void 0 : t,
    maxWidth: n === -1 ? void 0 : n,
    resizable: o,
    field: "column"
  };
}
const h7 = a1(C2, (e) => d7(e)), Je = {
  width: 100,
  resizable: !1,
  lastResizable: void 0,
  maxWidth: void 0,
  minWidth: void 0,
  field: "label",
  label: "label"
}, f7 = a1([G1, m2], (e, t) => {
  if (t && "pivotLabelColumnConfig" in e)
    return {
      ...Je,
      ...e.pivotLabelColumnConfig,
      resizable: !1
    };
});
a1(
  [C2, m2, Xe, h7, f7],
  (e, t, n, r, o) => t ? n.reduce(
    (i, a) => a === Ge ? (i[a] = o ?? Je, i) : (i[a] = { ...r, field: a, label: a }, i),
    {}
  ) : e
);
function C7(e, t) {
  const n = i1(() => (o) => i7(o, t, e), [e, t]);
  return z1(n);
}
const m7 = c2({
  onResize: () => {
  },
  columnWidths: [],
  resizing: !1,
  setResizing: () => {
  },
  touchEnabled: null
});
function B2() {
  return a2(m7);
}
function Qe(e) {
  const t = B2().columnWidths, n = O2(), r = i1(() => n[e], [e, n]), o = i1(() => {
    const a = t.findIndex((c) => c.field === r);
    if (a === -1) throw new Error(`Column width not found for index ${r}`);
    return a;
  }, [t, r]);
  return i1(() => {
    const a = t[o];
    if (!a) throw new Error(`Column width not found for index ${r}`);
    const { resizable: c, lastResizable: u, maxWidth: d, minWidth: h, width: m } = a;
    return { resizable: c, lastResizable: u, maxWidth: d, minWidth: h, width: m };
  }, [t, o, r]);
}
function p7(e, t = 0) {
  let n = e, r = t;
  for (; n !== null; )
    r += n.offsetLeft, n = n.offsetParent;
  return r;
}
function g7(e) {
  return "targetTouches" in e;
}
function w7(e, t) {
  const { onResize: n, setResizing: r, touchEnabled: o } = B2(), i = I(n);
  i.current = n;
  const a = I(null), c = E(
    (f) => {
      const x = e.current;
      a.current && globalThis.cancelAnimationFrame(a.current), a.current = window.requestAnimationFrame(() => {
        var C;
        if (!x) return;
        const _ = p7(x);
        let v = _;
        g7(f) ? v = ((C = f.targetTouches[0]) == null ? void 0 : C.clientX) ?? _ : v = f.clientX;
        const w = Math.round(v) - _;
        i.current(w, t), a.current = null;
      });
    },
    [e, a, i, t]
  ), u = E(() => {
    if (e.current) {
      if (r(!1), o) {
        window.removeEventListener("touchmove", c), window.removeEventListener("touchend", u);
        return;
      }
      window.removeEventListener("mousemove", c), window.removeEventListener("mouseup", u);
    }
  }, [c, e, o, r]), d = E(() => {
    if (e.current) {
      if (u(), r(!0), o) {
        window.addEventListener("touchmove", c), window.addEventListener("touchend", u);
        return;
      }
      window.addEventListener("mousemove", c), window.addEventListener("mouseup", u);
    }
  }, [c, e, u, o, r]), h = E(
    (f) => {
      if (f) {
        if (o) {
          f.addEventListener("touchstart", d);
          return;
        }
        f.addEventListener("mousedown", d);
      }
    },
    [d, o]
  ), m = E(
    (f) => {
      if (f) {
        if (typeof a.current == "number" && globalThis.cancelAnimationFrame(a.current), u(), o) {
          f.removeEventListener("touchstart", d);
          return;
        }
        f.removeEventListener("mousedown", d);
      }
    },
    [u, d, a, o]
  );
  V(() => {
    const f = e.current;
    return h(f), () => m(f);
  }, [e, h, m]);
}
function _7({ className: e, index: t }) {
  const n = I(null);
  return w7(n, t), /* @__PURE__ */ s.jsx("div", { className: b(p1.resizeHandle, e), ref: n });
}
const v7 = T1(_7);
function e0(e) {
  return function({
    colIndex: n,
    children: r,
    firstRow: o,
    ...i
  }) {
    const { resizable: a, ...c } = Qe(n), u = { ...i, ...c };
    return /* @__PURE__ */ s.jsxs(e, { ...u, children: [
      r,
      a && o && /* @__PURE__ */ s.jsx(v7, { index: n })
    ] });
  };
}
const x7 = e0(T6);
function b7({
  field: e,
  firstRow: t,
  colIndex: n,
  fixed: r
}) {
  const o = Ye(e), i = Qe(n);
  return /* @__PURE__ */ s.jsx(
    x7,
    {
      ...o,
      ...i,
      colIndex: n,
      firstRow: t,
      className: b({ [p1.fixed]: r })
    }
  );
}
const t0 = T1(b7);
function n0({ children: e }) {
  return /* @__PURE__ */ s.jsx("tr", { className: p1.row, children: e });
}
function L7() {
  const e = O2();
  return /* @__PURE__ */ s.jsx(n0, { children: e.map((t, n) => /* @__PURE__ */ s.jsx(t0, { field: t, firstRow: !0, colIndex: n }, t)) });
}
const E7 = T1(L7);
function k7({
  value: e
}) {
  return /* @__PURE__ */ s.jsx("span", { children: String(e) });
}
function y7({
  render: e,
  value: t,
  children: n,
  className: r,
  ...o
}) {
  const i = e ?? k7;
  return /* @__PURE__ */ s.jsxs(Ae, { ...o, className: r, children: [
    n,
    /* @__PURE__ */ s.jsx(i, { value: t })
  ] });
}
const j7 = e0(y7);
function M7({
  field: e,
  dataId: t,
  firstRow: n,
  colIndex: r
}) {
  const o = C7(e, t), i = Ye(e), a = i == null ? void 0 : i.render;
  return /* @__PURE__ */ s.jsx(
    j7,
    {
      render: a,
      value: o,
      className: n ? p1.headerCell : void 0,
      colIndex: r,
      firstRow: n
    }
  );
}
const N7 = T1(M7);
function H7({
  rowId: e,
  pivot: t,
  index: n
}) {
  const r = O2(), o = t && !n;
  return /* @__PURE__ */ s.jsx(n0, { children: r.map((i, a) => {
    const c = t ? e : i, u = t ? i : e;
    return t && !a ? /* @__PURE__ */ s.jsx(t0, { field: c, firstRow: o, colIndex: a, fixed: !0 }, u) : /* @__PURE__ */ s.jsx(N7, { dataId: u, field: c, firstRow: o, colIndex: a }, i);
  }) });
}
const T7 = T1(H7);
function z7() {
  const e = p2(), t = a7();
  return /* @__PURE__ */ s.jsx(s.Fragment, { children: t.map((n, r) => /* @__PURE__ */ s.jsx(T7, { rowId: n, pivot: e, index: r }, n)) });
}
const R7 = U(function({
  children: t,
  className: n,
  head: r,
  resizing: o,
  id: i,
  touchEnabled: a,
  pivot: c,
  expandable: u,
  maxWidth: d,
  slot: h
}, m) {
  return /* @__PURE__ */ s.jsxs(
    "div",
    {
      className: b(p1.container, p1.overflow, { [p1.firstColFixed]: c }),
      style: { "--max-width": d },
      children: [
        /* @__PURE__ */ s.jsxs(
          "table",
          {
            className: b(p1.table, n, {
              [p1.resizing]: o,
              [p1.touchEnabled]: a
            }),
            ref: m,
            id: i,
            children: [
              r && /* @__PURE__ */ s.jsx("thead", { children: r }),
              /* @__PURE__ */ s.jsx("tbody", { children: t })
            ]
          }
        ),
        h
      ]
    }
  );
});
function I7() {
  return p2() ? null : /* @__PURE__ */ s.jsx(E7, {});
}
U(function({ className: t }, n) {
  const { resizing: r, touchEnabled: o } = B2(), i = p2(), a = u7();
  return /* @__PURE__ */ s.jsx(
    R7,
    {
      ref: n,
      resizing: r,
      head: /* @__PURE__ */ s.jsx(I7, {}),
      pivot: i,
      expandable: a,
      className: t,
      touchEnabled: o ?? void 0,
      children: /* @__PURE__ */ s.jsx(z7, {})
    }
  );
});
const S7 = "_radioContainer_18a0e_1", V7 = "_label_18a0e_17", P7 = "_radioCircle_18a0e_27", A7 = "_radioWrapper_18a0e_60", $7 = "_radio_18a0e_1", O7 = "_disabledLabel_18a0e_70", P1 = {
  radioContainer: S7,
  label: V7,
  radioCircle: P7,
  radioWrapper: A7,
  radio: $7,
  disabledLabel: O7
}, B7 = U(function({
  children: t,
  disabled_: n,
  checked: r,
  classNames: o,
  disabled: i,
  "aria-disabled": a,
  fullWidth: c,
  ...u
}, d) {
  const { value: h, name: m, id: f } = u, x = v1(), v = `${f || m || x}-${String(h)}`, w = n || i, C = a || w;
  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions
    /* @__PURE__ */ s.jsx(
      "label",
      {
        htmlFor: v,
        className: b(P1.radioContainer, o == null ? void 0 : o.container, {
          [P1.disabledLabel]: w,
          fullWidth: c && c !== "mobile-only",
          fullWidthOnMobile: c && c === "mobile-only"
        }),
        onClick: u.onClick,
        children: /* @__PURE__ */ s.jsxs(
          "div",
          {
            className: b(P1.radioWrapper, {
              fullWidth: c && c !== "mobile-only",
              fullWidthOnMobile: c && c === "mobile-only"
            }),
            children: [
              /* @__PURE__ */ s.jsxs("div", { className: P1.radio, children: [
                /* @__PURE__ */ s.jsx(
                  "input",
                  {
                    ...u,
                    id: v,
                    type: "radio",
                    ref: d,
                    "aria-disabled": C,
                    "aria-checked": r,
                    disabled: n
                  }
                ),
                /* @__PURE__ */ s.jsx(_1, { name: "radio", size: "500", className: b(P1.radioCircle, o == null ? void 0 : o.radioCircle) })
              ] }),
              /* @__PURE__ */ s.jsx("div", { className: b(P1.label, o == null ? void 0 : o.label), children: t })
            ]
          }
        )
      }
    )
  );
});
U(function({ onChange: t, onClick: n, ...r }, o) {
  const { disabled: i } = r, a = i ? s1 : t, c = i ? s1 : n;
  return /* @__PURE__ */ s.jsx(B7, { ...r, onChange: a, onClick: c, ref: o });
});
const D7 = "_rangeInput_1f1n7_1", Z7 = {
  rangeInput: D7
};
U(function({ className: t, fullWidth: n, ...r }, o) {
  return /* @__PURE__ */ s.jsx(
    "input",
    {
      ref: o,
      ...r,
      className: b(Z7.rangeInput, t, {
        fullWidth: n && n !== "mobile-only",
        fullWidthOnMobile: n && n === "mobile-only"
      }),
      type: "range"
    }
  );
});
const F7 = "_rangeSlider_iyvux_1", W7 = "_track_iyvux_10", U7 = "_filledTrack_iyvux_22", q7 = "_sliderContainer_iyvux_34", K7 = "_thumb_iyvux_41", Y7 = "_scale_iyvux_63", G7 = "_scaleValue_iyvux_73", X7 = "_scaleValueFrom_iyvux_78", J7 = "_scaleValueTo_iyvux_82", Q7 = "_dragging_iyvux_86", g1 = {
  rangeSlider: F7,
  track: W7,
  filledTrack: U7,
  sliderContainer: q7,
  thumb: K7,
  scale: Y7,
  scaleValue: G7,
  scaleValueFrom: X7,
  scaleValueTo: J7,
  dragging: Q7
};
function r0(e, t, n) {
  return Math.min(Math.max(e, t), n);
}
function e9(e, t, n) {
  return n === t ? 0 : (e - t) / (n - t) * 100;
}
function w1(e, t, n, r) {
  if (r <= 0) return e;
  const o = r0(e, t, n);
  return Math.round((o - t) / r) * r + t;
}
function t9(e, t, n, r, o) {
  switch (e) {
    case K.Left:
    case K.Down:
      return w1(t - n, r, o, n);
    case K.Right:
    case K.Up:
      return w1(t + n, r, o, n);
    case K.Home:
    case K.End:
      return w1(o, r, o, n);
    default:
      return t;
  }
}
const n9 = U(
  ({
    className: e,
    trackClassName: t,
    thumbClassName: n,
    trackFilledClassName: r,
    min: o = 0,
    max: i = 100,
    step: a = 1,
    value: c,
    defaultValue: u,
    onChange: d,
    disabled: h,
    "aria-label": m,
    "aria-labelledby": f,
    children: x = () => null,
    scaleFormat: _,
    ...v
  }, w) => {
    const C = c !== void 0, [L, H] = P(!1), k = h || !L, M = Number(o), S = Number(i), A = Number(a);
    V(() => {
      H(!0);
    }, []);
    const g = E(() => {
      let j;
      return typeof c == "number" ? j = c : typeof u == "number" ? j = u : typeof c == "string" ? j = Number(c) : typeof u == "string" ? j = Number(u) : j = M, w1(j, M, S, A);
    }, [c, u, M, S, A]), [T, O] = P(g());
    V(() => {
      if (C && typeof c < "u" && !Array.isArray(c)) {
        const j = typeof c == "string" ? Number(c) : c;
        O(w1(j, M, S, A));
      }
    }, [c, C, M, S, A]);
    const F = I(null), W = I(null), z = E(() => {
      const j = F.current;
      j && (e1.current = j.getBoundingClientRect());
    }, []);
    pe(w, () => ({
      ...W.current,
      set value(j) {
        if (W.current) {
          W.current.value = j;
          const Y = w1(Number(j), M, S, A);
          if (C || O(Y), d) {
            const n1 = new Event("change", { bubbles: !0 });
            Object.defineProperty(n1, "target", { writable: !1, value: W.current }), d(n1);
          }
        }
      },
      get value() {
        var j;
        return ((j = W.current) == null ? void 0 : j.value) ?? "";
      }
    })), V(() => {
      const j = W.current;
      if (!j) return;
      const Y = new MutationObserver(() => {
        const n1 = w1(Number(j.value), M, S, A);
        C || O(n1);
      });
      return Y.observe(j, { attributes: !0, attributeFilter: ["value"] }), () => Y.disconnect();
    }, [C, M, S, A]);
    const y = w1(T, M, S, A), [B, Q] = P(void 0), e1 = I(void 0), t1 = e9(y, M, S);
    V(() => {
      z();
    }, [z]);
    const [J, p] = P(!1), N = E((j) => {
      const Y = e1.current;
      if (!Y) return 0;
      let n1 = j - Y.left;
      return n1 = r0(n1, 0, Y.width), n1 / Y.width;
    }, []), Z = E(
      (j) => {
        const Y = N(j), n1 = M + Y * (S - M);
        return w1(n1, M, S, A);
      },
      [N, M, S, A]
    ), R = B !== void 0 ? N(B) * 100 : void 0, q = E(
      (j) => {
        var R1, j1;
        if (k || !W.current) return;
        z(), p(!0);
        try {
          (j1 = (R1 = j.target).setPointerCapture) == null || j1.call(R1, j.pointerId);
        } catch {
        }
        const Y = j.clientX, n1 = Z(Y);
        if (W.current.value = n1.toString(), C || O(n1), d) {
          const g2 = {
            ...j,
            target: {
              ...j.target,
              value: n1
            }
          };
          d(g2);
        }
      },
      [k, Z, C, d, z]
    ), G = E(
      (j) => {
        if (!J || k) return;
        const Y = j.clientX;
        window.requestAnimationFrame(() => {
          Q(Y);
          const n1 = Z(Y);
          if (C || O(n1), !d) return;
          const R1 = {
            ...j,
            target: {
              ...j.target,
              value: n1
            }
          };
          d(R1);
        });
      },
      [J, k, Z, C, d]
    ), m1 = E(() => {
      p(!1), Q(void 0);
    }, [p]), $ = (j) => {
      if (k) return;
      const Y = t9(j.key, y, A, M, S);
      if (Y !== null && (j.preventDefault(), C || O(Y), d)) {
        const n1 = {
          ...j,
          target: {
            ...j.target,
            value: Y
          }
        };
        d(n1);
      }
    }, D = E(
      (j) => {
        if (k) return;
        z();
        const Y = e1.current;
        if (!Y) return;
        const R1 = (j.clientX - Y.left) / Y.width;
        let j1 = M + R1 * (S - M);
        if (j1 = w1(j1, M, S, A), C || O(j1), d) {
          const g2 = {
            ...j,
            target: {
              ...j.target,
              value: j1
            }
          };
          d(g2);
        }
      },
      [k, z, M, S, A, C, d]
    ), X = J ? R ?? t1 : t1;
    return /* @__PURE__ */ s.jsxs(
      l1,
      {
        className: b(g1.rangeSlider, e, { [g1.dragging]: J }),
        "aria-disabled": k,
        tabIndex: -1,
        space: "100",
        children: [
          /* @__PURE__ */ s.jsxs(U1, { className: g1.sliderContainer, children: [
            /* @__PURE__ */ s.jsx(
              "div",
              {
                ref: F,
                className: b(g1.track, t),
                onClick: D,
                role: "presentation",
                children: /* @__PURE__ */ s.jsx(
                  "div",
                  {
                    className: b(g1.filledTrack, r),
                    style: { inlineSize: `${X}%` }
                  }
                )
              }
            ),
            /* @__PURE__ */ s.jsx(
              "div",
              {
                className: b(g1.thumb, n),
                style: { insetInlineStart: `${X}%` },
                role: "slider",
                tabIndex: k ? -1 : 0,
                "aria-valuenow": y,
                "aria-valuemin": M,
                "aria-valuemax": S,
                "aria-disabled": k,
                "aria-label": m,
                "aria-labelledby": f,
                onPointerDown: q,
                onKeyDown: $,
                onPointerUp: m1,
                onPointerMove: G,
                ...v,
                children: /* @__PURE__ */ s.jsx(x, { value: y, percent: X })
              }
            )
          ] }),
          typeof _ == "function" ? /* @__PURE__ */ s.jsxs("dl", { className: g1.scale, children: [
            /* @__PURE__ */ s.jsx("dd", { className: b(g1.scaleValue, g1.scaleValueFrom), children: _(M) }),
            /* @__PURE__ */ s.jsx("dd", { className: b(g1.scaleValue, g1.scaleValueTo), children: _(S) })
          ] }) : null,
          /* @__PURE__ */ s.jsx("input", { type: "hidden", ref: W, value: y, readOnly: !0, tabIndex: -1, name: v.name })
        ]
      }
    );
  }
);
n9.displayName = "RangeSlider";
const r9 = "_input_1oxe5_1", o9 = "_growWrap_1oxe5_2", t2 = {
  input: r9,
  growWrap: o9,
  "input--error": "_input--error_1oxe5_29"
};
U(function({
  label: t,
  name: n,
  description: r,
  error: o,
  warning: i,
  id: a,
  required: c,
  className: u,
  onChange: d,
  errorDisplay: h,
  rows: m = 1,
  fullWidth: f,
  ...x
}, _) {
  const v = I(null), w = [];
  return o && w.push(`${n}-error`), i && w.push(`${n}-warning`), r && w.push(`${n}-description`), /* @__PURE__ */ s.jsx(
    P2,
    {
      label: t,
      name: n,
      description: r,
      error: o,
      warning: i,
      id: a || n,
      required: c,
      errorDisplay: h,
      fullWidth: f,
      /**
       * The following trick is used for the auto resizing textarea: https://css-tricks.com/the-cleanest-trick-for-autogrowing-textareas/
       * We need to make sure the same styles are applied to both the grow wrapper and the input
       */
      children: /* @__PURE__ */ s.jsx(
        "div",
        {
          className: b(t2.growWrap, u, {
            [t2.wrapError]: !!o,
            fullWidth: f && f !== "mobile-only",
            fullWidthOnMobile: f && f === "mobile-only"
          }),
          ref: v,
          children: /* @__PURE__ */ s.jsx(
            "textarea",
            {
              ...x,
              ref: _,
              id: a || n,
              name: n,
              "aria-describedby": w.length ? w.join(" ") : void 0,
              "aria-invalid": !!o,
              "aria-required": c,
              className: b(t2.input, u, {
                [t2["input--error"]]: !!o,
                fullWidth: f && f !== "mobile-only",
                fullWidthOnMobile: f && f === "mobile-only"
              }),
              rows: m,
              onChange: (C) => {
                var L;
                (L = v.current) == null || L.setAttribute("data-replicated-value", C.target.value), d && d(C);
              }
            }
          )
        }
      )
    }
  );
});
const i9 = "_button_1ijcr_1", s9 = "_hiddenInput_1ijcr_58", y2 = {
  button: i9,
  hiddenInput: s9,
  "size-large": "_size-large_1ijcr_64",
  "size-default": "_size-default_1ijcr_69",
  "size-small": "_size-small_1ijcr_74"
};
U(function({
  id: t,
  children: n,
  value: r,
  name: o,
  onChange: i,
  onClick: a,
  className: c,
  type: u = "radio",
  size: d = "default",
  disabled_: h,
  disabled: m,
  fullWidth: f,
  ...x
}, _) {
  const v = b(y2.button, y2[`size-${d}`], c), w = v1(), L = `${t || o || w}-${String(r)}`, H = m || h;
  return /* @__PURE__ */ s.jsxs(
    "label",
    {
      htmlFor: L,
      className: b(
        {
          fullWidth: f && f !== "mobile-only",
          fullWidthOnMobile: f && f === "mobile-only"
        },
        v
      ),
      children: [
        /* @__PURE__ */ s.jsx(
          "input",
          {
            ...x,
            ref: _,
            id: L,
            "aria-disabled": H,
            type: u,
            value: r,
            name: o,
            onClick: H ? s1 : a,
            onChange: H ? s1 : i,
            className: y2.hiddenInput,
            disabled: h
          }
        ),
        n
      ]
    }
  );
});
const c9 = "_toggle_1uf6m_1", a9 = "_toggleTrack_1uf6m_7", l9 = "_toggleTrackWithLabel_1uf6m_8", u9 = "_toggleTrackNoLabel_1uf6m_17", d9 = "_small_1uf6m_25", h9 = "_large_1uf6m_31", f9 = "_toggleIndicator_1uf6m_55", C9 = "_toggleInput_1uf6m_98", m9 = "_labelText_1uf6m_156", p9 = "_disabledLabel_1uf6m_161", g9 = "_onLabel_1uf6m_165", w9 = "_offLabel_1uf6m_166", f1 = {
  toggle: c9,
  toggleTrack: a9,
  toggleTrackWithLabel: l9,
  toggleTrackNoLabel: u9,
  small: d9,
  large: h9,
  toggleIndicator: f9,
  toggleInput: C9,
  labelText: m9,
  disabledLabel: p9,
  onLabel: g9,
  offLabel: w9
}, _9 = U(function({
  id: t,
  name: n,
  error: r = !1,
  classNames: o,
  "aria-disabled": i,
  "aria-required": a,
  children: c,
  required: u,
  checked: d,
  disabled_: h,
  disabled: m,
  size: f = "small",
  labelPosition: x = "right",
  labelForOn: _,
  labelForOff: v,
  ...w
}, C) {
  const L = v1(), H = t || n || L, k = i || m || h;
  return /* @__PURE__ */ s.jsxs("label", { className: b(f1.toggle, o == null ? void 0 : o.label), htmlFor: H, children: [
    x === "left" ? /* @__PURE__ */ s.jsx(
      "div",
      {
        className: b(f1.labelText, o == null ? void 0 : o.labelText, {
          [f1.disabledLabel]: k
        }),
        children: c
      }
    ) : null,
    /* @__PURE__ */ s.jsx(
      "input",
      {
        tabIndex: 0,
        ...w,
        role: "switch",
        type: "checkbox",
        className: b(f1.toggleInput, f1[f]),
        id: H,
        ref: C,
        name: n,
        required: u,
        disabled: h,
        "aria-disabled": k,
        "aria-required": u,
        "aria-checked": d
      }
    ),
    /* @__PURE__ */ s.jsxs(
      "span",
      {
        className: b(f1.toggleTrack, {
          [f1.toggleTrackNoLabel]: !(_ && v),
          [f1.toggleTrackWithLabel]: _ && v
        }),
        children: [
          _ && v ? /* @__PURE__ */ s.jsx("span", { className: f1.onLabel, "aria-hidden": !0, children: _ }) : null,
          /* @__PURE__ */ s.jsx("span", { className: f1.toggleIndicator }),
          _ && v ? /* @__PURE__ */ s.jsx("span", { className: f1.offLabel, "aria-hidden": !0, children: v }) : null
        ]
      }
    ),
    x === "right" ? /* @__PURE__ */ s.jsx(
      "div",
      {
        className: b(f1.labelText, o == null ? void 0 : o.labelText, {
          [f1.disabledLabel]: k
        }),
        children: c
      }
    ) : null
  ] });
});
U(function({ onChange: t, onClick: n, ...r }, o) {
  const { disabled: i } = r, a = i ? s1 : t, c = i ? s1 : n;
  return /* @__PURE__ */ s.jsx(_9, { ...r, onChange: a, onClick: c, ref: o });
});
const Ce = {
  containerWidth: void 0,
  rowHeightsMap: /* @__PURE__ */ new Map()
};
function v9(e) {
  return e.keys().reduce((t, n) => t + n, "");
}
function x9(e) {
  const { containerRef: t, rowRefs: n } = e, r = I(new Map([...n.current].map(([w, C]) => [C, w]))), o = I(/* @__PURE__ */ new Map()), i = I(/* @__PURE__ */ new Map()), [a, c] = P(Ce.containerWidth), [u, d] = P(Ce.rowHeightsMap), h = I(!1), m = I(void 0);
  m.current = e.onResize;
  const f = I(null), x = E(
    (w) => {
      if (!t || !t.current || !w) return;
      const C = me(w, "contentBoxSize", "inlineSize");
      typeof C == "number" && i.current.get(w.target) !== C && (h.current = !0, i.current.set(w.target, C), c(C));
    },
    [t]
  ), _ = E(
    (w) => {
      if (!n || !n.current || !w) return;
      const C = me(w, "borderBoxSize", "blockSize");
      typeof C == "number" && i.current.get(w.target) !== C && (h.current = !0, i.current.set(w.target, C), d((H) => {
        const k = r.current.get(w.target);
        if (typeof k != "number") return H;
        const M = new Map(H);
        return M.set(k, C), M;
      }));
    },
    [n]
  );
  V(() => {
    if (!(!t || !t.current || !n || !n.current) && !(!window || typeof window > "u" || !("ResizeObserver" in window)))
      return f.current = new ResizeObserver((w) => {
        for (const C of w)
          (C.target === t.current ? x : _)(C);
      }), f.current.observe(t.current, { box: "content-box" }), n.current.forEach((w, C) => {
        !w || !f.current || (o.current.set(C, w), r.current.set(w, C), f.current.observe(w, { box: "border-box" }));
      }), () => {
        f.current && f.current.disconnect();
      };
  }, [t, x, _, n]);
  const v = v9(n.current);
  return V(() => {
    o.current.entries().forEach(([w, C]) => {
      var L;
      C && !n.current.has(w) && ((L = f.current) == null || L.unobserve(C), r.current.delete(C));
    }), n.current.entries().forEach(([w, C]) => {
      var L;
      C && !o.current.has(w) && ((L = f.current) == null || L.observe(C, { box: "border-box" }), r.current.set(C, w));
    }), o.current = new Map(n.current);
  }, [n, v]), h.current && m.current && (m.current({ containerWidth: a, rowHeightsMap: u }), h.current = !1), { containerWidth: a, rowHeightsMap: u };
}
function me(e, t, n) {
  var o;
  const r = e[t];
  return Array.isArray(r) && r.length > 0 ? (o = r[0]) == null ? void 0 : o[n] : r && typeof r == "object" && n in r ? r[n] : n === "inlineSize" ? e.contentRect.width : e.contentRect.height;
}
function j2(e, t, n, r, o) {
  e.forEach((i) => {
    const a = t.get(i) || r, c = n.current[i] || i * (r + o);
    n.current[i + 1] = c + a + o;
  });
}
function b9(e) {
  if (!e.size) return 0;
  const t = [...e.values()].sort((r, o) => r - o), n = Math.floor(t.length / 2);
  return t.length % 2 ? t[n] : (t[n - 1] + t[n]) / 2;
}
function L9(e, t, n, r, o) {
  const i = r ?? n, a = o ?? e * (n + t);
  return {
    position: "absolute",
    inset: 0,
    height: `${i}px`,
    transform: `translateY(${a}px)`
  };
}
const M2 = {
  Up: "Up",
  Down: "Down",
  None: null
};
function E9(e, t, n, r, o) {
  const i = n[e];
  if (typeof i != "number") return Math.floor(t / (r + o));
  if (i === t) return e;
  const a = n.length;
  if (i > t) {
    for (let c = e - 1; c >= 0; c--) {
      const u = n[c];
      if (typeof u == "number" && u <= t) return c;
    }
    return 0;
  }
  if (i < t)
    for (let c = e + 1; c < a; c++) {
      const u = n[c];
      if (typeof u == "number" && u > t) return c - 1;
    }
  return Math.floor(t / (r + o));
}
function k9(e, t) {
  return e === t ? !1 : !e && t || !t && e ? !0 : Object.keys(t).some((n) => t[n] !== e[n]);
}
function y9(e) {
  const [t, n] = P(e);
  return V(() => {
    k9(t, e) && n(e);
  }, [e]), t;
}
const j9 = U(function({
  className: t,
  style: n,
  children: r,
  overscanRows: o,
  maxRows: i,
  rowHeight: a = 0,
  visibleRowCount: c,
  onScroll: u,
  gap: d = 0,
  reactiveProps: h,
  offset: m = 0
}, f) {
  const x = y9(h), [_, v] = f2(f), w = o || c, C = I([0]), [L, H] = P(a), k = I(0), [M, S] = P(0), A = I(M2.None), g = i ?? M + (c + w) * 2 + 1, T = c * (L + d), O = (L + d) * g, F = I(/* @__PURE__ */ new Map()), W = I(/* @__PURE__ */ new Map()), [, z] = P(0), y = I(0), B = I(0), Q = E(
    ($) => {
      j2([...F.current.keys()], $.rowHeightsMap, C, L, d), z((D) => ++D);
    },
    [d, L]
  ), { containerWidth: e1, rowHeightsMap: t1 } = x9({ containerRef: _, rowRefs: F, onResize: Q });
  !W.current.size && t1 && t1.get(0) && (W.current = new Map(t1));
  const J = E(
    ($) => {
      const D = Math.max(0, $ - w), X = Math.min(
        g - 1,
        // don't render past the end of the list
        $ + c + w
      );
      return [D, X, $];
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [g, w, c]
  ), p = E(
    ($) => {
      j2([...F.current.keys()], t1, C, L, d);
      const D = k.current;
      y.current = D, k.current = $.currentTarget.scrollTop;
      const X = E9(M, k.current, C.current, L, d);
      A.current = D < k.current ? M2.Down : M2.Up, u == null || u(J(X)), S(X);
    },
    [t1, L, d, M, u, J]
  );
  function N($) {
    return C.current[$] ?? $ * (L + d);
  }
  n2(() => {
    var D;
    const $ = m - B.current;
    if ($) {
      const X = N($);
      (D = _.current) == null || D.scrollBy({ top: X, behavior: "instant" }), B.current = m;
      const j = k.current + X;
      j2([...F.current.keys()], t1, C, L, d), k.current = j;
    }
    y.current = k.current;
  });
  const Z = E(($) => (D) => {
    D ? F.current.set($, D) : F.current.delete($);
  }, []);
  n2(() => {
    var $, D;
    if (!L) {
      const X = (D = ($ = _.current) == null ? void 0 : $.firstElementChild) == null ? void 0 : D.children;
      if (!(X != null && X.length)) return;
      const j = Array.from(X).map((Y) => Y.clientHeight);
      if (!j[0]) return;
      H(j[0]);
      return;
    }
    if (W.current.size) {
      const X = b9(W.current);
      H(X);
    }
  }, [_, L, e1, d]);
  function R($) {
    const D = t1.get($), X = C.current[$];
    return L9($, d, L, D, X);
  }
  const q = [], [G, m1] = J(M);
  for (let $ = G; $ <= m1; $++) {
    const D = Z($);
    q.push(/* @__PURE__ */ s.jsx(r, { index: $, style: R($), ref: D }, $));
  }
  return /* @__PURE__ */ s.jsx(
    "div",
    {
      className: t,
      style: {
        // allow to override the height
        height: T,
        ...n,
        overflowY: "auto",
        position: "relative",
        scrollBehavior: "smooth",
        willChange: "contents",
        maxHeight: T
      },
      ref: v,
      onScroll: p,
      "data-testid": "scroll-container",
      children: /* @__PURE__ */ s.jsxs("div", { style: { position: "absolute", top: 0, left: 0, right: 0, height: O }, children: [
        /* @__PURE__ */ s0(r, { ...x, index: -1, key: -1, style: { opacity: "0", pointerEvents: "none" }, ref: An }),
        q
      ] })
    }
  );
});
T1(j9);
function S9({ text: e, Link: t = C1 }) {
  return /* @__PURE__ */ s.jsx("div", { className: o1.login, children: /* @__PURE__ */ s.jsxs(
    t,
    {
      href: e.loginUrl,
      className: b(Y1.navigationLink, o1.trigger, o1.loginLink),
      title: e.label,
      "aria-label": e.label,
      children: [
        /* @__PURE__ */ s.jsx(_1, { name: "user", color: "fg-content-primary", className: o1.icon, size: "400" }),
        /* @__PURE__ */ s.jsx("span", { className: o1.label, children: e.label })
      ]
    }
  ) });
}
function V9() {
  return /* @__PURE__ */ s.jsxs("div", { className: b(o1.trigger, o1.login, Y1.navigationLink), children: [
    /* @__PURE__ */ s.jsx(k1, { className: o1.image, width: "40px", height: "40px", borderRadius: "100%" }),
    /* @__PURE__ */ s.jsx(k1, { className: o1.label, height: "28px", width: "164px" })
  ] });
}
export {
  z9 as Footer,
  H9 as FooterCompact,
  d4 as FooterDesktopSectionContent,
  u4 as FooterMobileSectionContent,
  R9 as Header,
  H0 as HeaderCompact,
  T9 as LocaleSwitchLink,
  I9 as UserInfo,
  V9 as UserInfoLoading,
  S9 as UserLoginLink
};
